import { IIsoState } from '../interfaces';

// @ts-ignore
export const STATES: IIsoState[] = [
  { country_code: 'AD', subdivision_name: 'Andorra la Vella', code: 'AD-07' },
  { country_code: 'AD', subdivision_name: 'Canillo', code: 'AD-02' },
  { country_code: 'AD', subdivision_name: 'Encamp', code: 'AD-03' },
  { country_code: 'AD', subdivision_name: 'Escaldes-Engordany', code: 'AD-08' },
  { country_code: 'AD', subdivision_name: 'La Massana', code: 'AD-04' },
  { country_code: 'AD', subdivision_name: 'Ordino', code: 'AD-05' },
  { country_code: 'AD', subdivision_name: 'Sant Julia de Loria', code: 'AD-06' },
  { country_code: 'AE', subdivision_name: "'Ajman", code: 'AE-AJ' },
  { country_code: 'AE', subdivision_name: 'Abu Zaby', code: 'AE-AZ' },
  { country_code: 'AE', subdivision_name: 'Al Fujayrah', code: 'AE-FU' },
  { country_code: 'AE', subdivision_name: 'Ash Shariqah', code: 'AE-SH' },
  { country_code: 'AE', subdivision_name: 'Dubayy', code: 'AE-DU' },
  { country_code: 'AE', subdivision_name: "Ra's al Khaymah", code: 'AE-RK' },
  { country_code: 'AE', subdivision_name: 'Umm al Qaywayn', code: 'AE-UQ' },
  { country_code: 'AF', subdivision_name: 'Badakhshan', code: 'AF-BDS' },
  { country_code: 'AF', subdivision_name: 'Baghlan', code: 'AF-BGL' },
  { country_code: 'AF', subdivision_name: 'Balkh', code: 'AF-BAL' },
  { country_code: 'AF', subdivision_name: 'Bamyan', code: 'AF-BAM' },
  { country_code: 'AF', subdivision_name: 'Farah', code: 'AF-FRA' },
  { country_code: 'AF', subdivision_name: 'Faryab', code: 'AF-FYB' },
  { country_code: 'AF', subdivision_name: 'Ghazni', code: 'AF-GHA' },
  { country_code: 'AF', subdivision_name: 'Ghor', code: 'AF-GHO' },
  { country_code: 'AF', subdivision_name: 'Helmand', code: 'AF-HEL' },
  { country_code: 'AF', subdivision_name: 'Herat', code: 'AF-HER' },
  { country_code: 'AF', subdivision_name: 'Kabul', code: 'AF-KAB' },
  { country_code: 'AF', subdivision_name: 'Kandahar', code: 'AF-KAN' },
  { country_code: 'AF', subdivision_name: 'Khost', code: 'AF-KHO' },
  { country_code: 'AF', subdivision_name: 'Kunduz', code: 'AF-KDZ' },
  { country_code: 'AF', subdivision_name: 'Laghman', code: 'AF-LAG' },
  { country_code: 'AF', subdivision_name: 'Logar', code: 'AF-LOG' },
  { country_code: 'AF', subdivision_name: 'Nangarhar', code: 'AF-NAN' },
  { country_code: 'AF', subdivision_name: 'Nimroz', code: 'AF-NIM' },
  { country_code: 'AF', subdivision_name: 'Paktiya', code: 'AF-PIA' },
  { country_code: 'AF', subdivision_name: 'Parwan', code: 'AF-PAR' },
  { country_code: 'AF', subdivision_name: 'Samangan', code: 'AF-SAM' },
  { country_code: 'AF', subdivision_name: 'Takhar', code: 'AF-TAK' },
  { country_code: 'AF', subdivision_name: 'Uruzgan', code: 'AF-URU' },
  { country_code: 'AG', subdivision_name: 'Redonda', code: 'AG-11' },
  { country_code: 'AG', subdivision_name: 'Saint George', code: 'AG-03' },
  { country_code: 'AG', subdivision_name: 'Saint John', code: 'AG-04' },
  { country_code: 'AG', subdivision_name: 'Saint Mary', code: 'AG-05' },
  { country_code: 'AG', subdivision_name: 'Saint Paul', code: 'AG-06' },
  { country_code: 'AG', subdivision_name: 'Saint Peter', code: 'AG-07' },
  { country_code: 'AG', subdivision_name: 'Saint Philip', code: 'AG-08' },
  { country_code: 'AI', subdivision_name: 'Anguilla', code: '-' },
  { country_code: 'AL', subdivision_name: 'Berat', code: 'AL-01' },
  { country_code: 'AL', subdivision_name: 'Diber', code: 'AL-09' },
  { country_code: 'AL', subdivision_name: 'Durres', code: 'AL-02' },
  { country_code: 'AL', subdivision_name: 'Elbasan', code: 'AL-03' },
  { country_code: 'AL', subdivision_name: 'Fier', code: 'AL-04' },
  { country_code: 'AL', subdivision_name: 'Gjirokaster', code: 'AL-05' },
  { country_code: 'AL', subdivision_name: 'Korce', code: 'AL-06' },
  { country_code: 'AL', subdivision_name: 'Kukes', code: 'AL-07' },
  { country_code: 'AL', subdivision_name: 'Lezhe', code: 'AL-08' },
  { country_code: 'AL', subdivision_name: 'Shkoder', code: 'AL-10' },
  { country_code: 'AL', subdivision_name: 'Tirane', code: 'AL-11' },
  { country_code: 'AL', subdivision_name: 'Vlore', code: 'AL-12' },
  { country_code: 'AM', subdivision_name: 'Aragacotn', code: 'AM-AG' },
  { country_code: 'AM', subdivision_name: 'Ararat', code: 'AM-AR' },
  { country_code: 'AM', subdivision_name: 'Armavir', code: 'AM-AV' },
  { country_code: 'AM', subdivision_name: 'Erevan', code: 'AM-ER' },
  { country_code: 'AM', subdivision_name: "Gegark'unik'", code: 'AM-GR' },
  { country_code: 'AM', subdivision_name: "Kotayk'", code: 'AM-KT' },
  { country_code: 'AM', subdivision_name: 'Lori', code: 'AM-LO' },
  { country_code: 'AM', subdivision_name: 'Sirak', code: 'AM-SH' },
  { country_code: 'AM', subdivision_name: "Syunik'", code: 'AM-SU' },
  { country_code: 'AM', subdivision_name: 'Tavus', code: 'AM-TV' },
  { country_code: 'AM', subdivision_name: 'Vayoc Jor', code: 'AM-VD' },
  { country_code: 'AO', subdivision_name: 'Bengo', code: 'AO-BGO' },
  { country_code: 'AO', subdivision_name: 'Benguela', code: 'AO-BGU' },
  { country_code: 'AO', subdivision_name: 'Bie', code: 'AO-BIE' },
  { country_code: 'AO', subdivision_name: 'Cabinda', code: 'AO-CAB' },
  { country_code: 'AO', subdivision_name: 'Cunene', code: 'AO-CNN' },
  { country_code: 'AO', subdivision_name: 'Huambo', code: 'AO-HUA' },
  { country_code: 'AO', subdivision_name: 'Huila', code: 'AO-HUI' },
  { country_code: 'AO', subdivision_name: 'Kuando Kubango', code: 'AO-CCU' },
  { country_code: 'AO', subdivision_name: 'Kwanza Norte', code: 'AO-CNO' },
  { country_code: 'AO', subdivision_name: 'Kwanza Sul', code: 'AO-CUS' },
  { country_code: 'AO', subdivision_name: 'Luanda', code: 'AO-LUA' },
  { country_code: 'AO', subdivision_name: 'Lunda Norte', code: 'AO-LNO' },
  { country_code: 'AO', subdivision_name: 'Lunda Sul', code: 'AO-LSU' },
  { country_code: 'AO', subdivision_name: 'Malange', code: 'AO-MAL' },
  { country_code: 'AO', subdivision_name: 'Moxico', code: 'AO-MOX' },
  { country_code: 'AO', subdivision_name: 'Namibe', code: 'AO-NAM' },
  { country_code: 'AO', subdivision_name: 'Uige', code: 'AO-UIG' },
  { country_code: 'AO', subdivision_name: 'Zaire', code: 'AO-ZAI' },
  { country_code: 'AR', subdivision_name: 'Buenos Aires', code: 'AR-B' },
  { country_code: 'AR', subdivision_name: 'Catamarca', code: 'AR-K' },
  { country_code: 'AR', subdivision_name: 'Chaco', code: 'AR-H' },
  { country_code: 'AR', subdivision_name: 'Chubut', code: 'AR-U' },
  { country_code: 'AR', subdivision_name: 'Ciudad Autonoma de Buenos Aires', code: 'AR-C' },
  { country_code: 'AR', subdivision_name: 'Cordoba', code: 'AR-X' },
  { country_code: 'AR', subdivision_name: 'Corrientes', code: 'AR-W' },
  { country_code: 'AR', subdivision_name: 'Entre Rios', code: 'AR-E' },
  { country_code: 'AR', subdivision_name: 'Formosa', code: 'AR-P' },
  { country_code: 'AR', subdivision_name: 'Jujuy', code: 'AR-Y' },
  { country_code: 'AR', subdivision_name: 'La Pampa', code: 'AR-L' },
  { country_code: 'AR', subdivision_name: 'La Rioja', code: 'AR-F' },
  { country_code: 'AR', subdivision_name: 'Mendoza', code: 'AR-M' },
  { country_code: 'AR', subdivision_name: 'Misiones', code: 'AR-N' },
  { country_code: 'AR', subdivision_name: 'Neuquen', code: 'AR-Q' },
  { country_code: 'AR', subdivision_name: 'Rio Negro', code: 'AR-R' },
  { country_code: 'AR', subdivision_name: 'Salta', code: 'AR-A' },
  { country_code: 'AR', subdivision_name: 'San Juan', code: 'AR-J' },
  { country_code: 'AR', subdivision_name: 'San Luis', code: 'AR-D' },
  { country_code: 'AR', subdivision_name: 'Santa Cruz', code: 'AR-Z' },
  { country_code: 'AR', subdivision_name: 'Santa Fe', code: 'AR-S' },
  { country_code: 'AR', subdivision_name: 'Santiago del Estero', code: 'AR-G' },
  { country_code: 'AR', subdivision_name: 'Tierra del Fuego', code: 'AR-V' },
  { country_code: 'AR', subdivision_name: 'Tucuman', code: 'AR-T' },
  { country_code: 'AS', subdivision_name: 'Eastern District', code: '-' },
  { country_code: 'AS', subdivision_name: 'Western District', code: '-' },
  { country_code: 'AT', subdivision_name: 'Burgenland', code: 'AT-1' },
  { country_code: 'AT', subdivision_name: 'Karnten', code: 'AT-2' },
  { country_code: 'AT', subdivision_name: 'Niederosterreich', code: 'AT-3' },
  { country_code: 'AT', subdivision_name: 'Oberosterreich', code: 'AT-4' },
  { country_code: 'AT', subdivision_name: 'Salzburg', code: 'AT-5' },
  { country_code: 'AT', subdivision_name: 'Steiermark', code: 'AT-6' },
  { country_code: 'AT', subdivision_name: 'Tirol', code: 'AT-7' },
  { country_code: 'AT', subdivision_name: 'Vorarlberg', code: 'AT-8' },
  { country_code: 'AT', subdivision_name: 'Wien', code: 'AT-9' },
  { country_code: 'AU', subdivision_name: 'Australian Capital Territory', code: 'AU-ACT' },
  { country_code: 'AU', subdivision_name: 'New South Wales', code: 'AU-NSW' },
  { country_code: 'AU', subdivision_name: 'Northern Territory', code: 'AU-NT' },
  { country_code: 'AU', subdivision_name: 'Queensland', code: 'AU-QLD' },
  { country_code: 'AU', subdivision_name: 'South Australia', code: 'AU-SA' },
  { country_code: 'AU', subdivision_name: 'Tasmania', code: 'AU-TAS' },
  { country_code: 'AU', subdivision_name: 'Victoria', code: 'AU-VIC' },
  { country_code: 'AU', subdivision_name: 'Western Australia', code: 'AU-WA' },
  { country_code: 'AW', subdivision_name: 'Aruba', code: '-' },
  { country_code: 'AX', subdivision_name: 'Eckeroe', code: '-' },
  { country_code: 'AX', subdivision_name: 'Finstroem', code: '-' },
  { country_code: 'AX', subdivision_name: 'Hammarland', code: '-' },
  { country_code: 'AX', subdivision_name: 'Jomala', code: '-' },
  { country_code: 'AX', subdivision_name: 'Mariehamn', code: '-' },
  { country_code: 'AX', subdivision_name: 'Saltvik', code: '-' },
  { country_code: 'AX', subdivision_name: 'Sund', code: '-' },
  { country_code: 'AZ', subdivision_name: 'Abseron', code: 'AZ-ABS' },
  { country_code: 'AZ', subdivision_name: 'Agcabadi', code: 'AZ-AGC' },
  { country_code: 'AZ', subdivision_name: 'Agstafa', code: 'AZ-AGA' },
  { country_code: 'AZ', subdivision_name: 'Agsu', code: 'AZ-AGU' },
  { country_code: 'AZ', subdivision_name: 'Baki', code: 'AZ-BA' },
  { country_code: 'AZ', subdivision_name: 'Balakan', code: 'AZ-BAL' },
  { country_code: 'AZ', subdivision_name: 'Barda', code: 'AZ-BAR' },
  { country_code: 'AZ', subdivision_name: 'Beylaqan', code: 'AZ-BEY' },
  { country_code: 'AZ', subdivision_name: 'Bilasuvar', code: 'AZ-BIL' },
  { country_code: 'AZ', subdivision_name: 'Calilabad', code: 'AZ-CAL' },
  { country_code: 'AZ', subdivision_name: 'Daskasan', code: 'AZ-DAS' },
  { country_code: 'AZ', subdivision_name: 'Fuzuli', code: 'AZ-FUZ' },
  { country_code: 'AZ', subdivision_name: 'Gadabay', code: 'AZ-GAD' },
  { country_code: 'AZ', subdivision_name: 'Ganca', code: 'AZ-GA' },
  { country_code: 'AZ', subdivision_name: 'Goranboy', code: 'AZ-GOR' },
  { country_code: 'AZ', subdivision_name: 'Goycay', code: 'AZ-GOY' },
  { country_code: 'AZ', subdivision_name: 'Goygol', code: 'AZ-GYG' },
  { country_code: 'AZ', subdivision_name: 'Haciqabul', code: 'AZ-HAC' },
  { country_code: 'AZ', subdivision_name: 'Imisli', code: 'AZ-IMI' },
  { country_code: 'AZ', subdivision_name: 'Kurdamir', code: 'AZ-KUR' },
  { country_code: 'AZ', subdivision_name: 'Lankaran', code: 'AZ-LA' },
  { country_code: 'AZ', subdivision_name: 'Masalli', code: 'AZ-MAS' },
  { country_code: 'AZ', subdivision_name: 'Mingacevir', code: 'AZ-MI' },
  { country_code: 'AZ', subdivision_name: 'Naftalan', code: 'AZ-NA' },
  { country_code: 'AZ', subdivision_name: 'Naxcivan', code: 'AZ-NX' },
  { country_code: 'AZ', subdivision_name: 'Neftcala', code: 'AZ-NEF' },
  { country_code: 'AZ', subdivision_name: 'Oguz', code: 'AZ-OGU' },
  { country_code: 'AZ', subdivision_name: 'Qabala', code: 'AZ-QAB' },
  { country_code: 'AZ', subdivision_name: 'Qax', code: 'AZ-QAX' },
  { country_code: 'AZ', subdivision_name: 'Qazax', code: 'AZ-QAZ' },
  { country_code: 'AZ', subdivision_name: 'Quba', code: 'AZ-QBA' },
  { country_code: 'AZ', subdivision_name: 'Qusar', code: 'AZ-QUS' },
  { country_code: 'AZ', subdivision_name: 'Sabirabad', code: 'AZ-SAB' },
  { country_code: 'AZ', subdivision_name: 'Saki', code: 'AZ-SAK' },
  { country_code: 'AZ', subdivision_name: 'Salyan', code: 'AZ-SAL' },
  { country_code: 'AZ', subdivision_name: 'Samaxi', code: 'AZ-SMI' },
  { country_code: 'AZ', subdivision_name: 'Samkir', code: 'AZ-SKR' },
  { country_code: 'AZ', subdivision_name: 'Samux', code: 'AZ-SMX' },
  { country_code: 'AZ', subdivision_name: 'Sirvan', code: 'AZ-SR' },
  { country_code: 'AZ', subdivision_name: 'Siyazan', code: 'AZ-SIY' },
  { country_code: 'AZ', subdivision_name: 'Sumqayit', code: 'AZ-SM' },
  { country_code: 'AZ', subdivision_name: 'Tovuz', code: 'AZ-TOV' },
  { country_code: 'AZ', subdivision_name: 'Xacmaz', code: 'AZ-XAC' },
  { country_code: 'AZ', subdivision_name: 'Xizi', code: 'AZ-XIZ' },
  { country_code: 'AZ', subdivision_name: 'Yardimli', code: 'AZ-YAR' },
  { country_code: 'AZ', subdivision_name: 'Yevlax', code: 'AZ-YEV' },
  { country_code: 'AZ', subdivision_name: 'Zaqatala', code: 'AZ-ZAQ' },
  { country_code: 'BA', subdivision_name: 'Brcko distrikt', code: 'BA-BRC' },
  { country_code: 'BA', subdivision_name: 'Federacija Bosne i Hercegovine', code: 'BA-BIH' },
  { country_code: 'BA', subdivision_name: 'Republika Srpska', code: 'BA-SRP' },
  { country_code: 'BB', subdivision_name: 'Christ Church', code: 'BB-01' },
  { country_code: 'BB', subdivision_name: 'Saint Andrew', code: 'BB-02' },
  { country_code: 'BB', subdivision_name: 'Saint George', code: 'BB-03' },
  { country_code: 'BB', subdivision_name: 'Saint James', code: 'BB-04' },
  { country_code: 'BB', subdivision_name: 'Saint John', code: 'BB-05' },
  { country_code: 'BB', subdivision_name: 'Saint Joseph', code: 'BB-06' },
  { country_code: 'BB', subdivision_name: 'Saint Lucy', code: 'BB-07' },
  { country_code: 'BB', subdivision_name: 'Saint Michael', code: 'BB-08' },
  { country_code: 'BB', subdivision_name: 'Saint Peter', code: 'BB-09' },
  { country_code: 'BB', subdivision_name: 'Saint Philip', code: 'BB-10' },
  { country_code: 'BB', subdivision_name: 'Saint Thomas', code: 'BB-11' },
  { country_code: 'BD', subdivision_name: 'Barisal', code: 'BD-A' },
  { country_code: 'BD', subdivision_name: 'Chittagong', code: 'BD-B' },
  { country_code: 'BD', subdivision_name: 'Dhaka', code: 'BD-C' },
  { country_code: 'BD', subdivision_name: 'Khulna', code: 'BD-D' },
  { country_code: 'BD', subdivision_name: 'Rajshahi', code: 'BD-E' },
  { country_code: 'BD', subdivision_name: 'Rangpur', code: 'BD-F' },
  { country_code: 'BD', subdivision_name: 'Sylhet', code: 'BD-G' },
  { country_code: 'BE', subdivision_name: 'Antwerpen', code: 'BE-VAN' },
  { country_code: 'BE', subdivision_name: 'Brabant wallon', code: 'BE-WBR' },
  { country_code: 'BE', subdivision_name: 'Brussels Hoofdstedelijk Gewest', code: 'BE-BRU' },
  { country_code: 'BE', subdivision_name: 'Hainaut', code: 'BE-WHT' },
  { country_code: 'BE', subdivision_name: 'Liege', code: 'BE-WLG' },
  { country_code: 'BE', subdivision_name: 'Limburg', code: 'BE-VLI' },
  { country_code: 'BE', subdivision_name: 'Luxembourg', code: 'BE-WLX' },
  { country_code: 'BE', subdivision_name: 'Namur', code: 'BE-WNA' },
  { country_code: 'BE', subdivision_name: 'Oost-Vlaanderen', code: 'BE-VOV' },
  { country_code: 'BE', subdivision_name: 'Vlaams-Brabant', code: 'BE-VBR' },
  { country_code: 'BE', subdivision_name: 'West-Vlaanderen', code: 'BE-VWV' },
  { country_code: 'BF', subdivision_name: 'Bale', code: 'BF-BAL' },
  { country_code: 'BF', subdivision_name: 'Bazega', code: 'BF-BAZ' },
  { country_code: 'BF', subdivision_name: 'Boulgou', code: 'BF-BLG' },
  { country_code: 'BF', subdivision_name: 'Boulkiemde', code: 'BF-BLK' },
  { country_code: 'BF', subdivision_name: 'Comoe', code: 'BF-COM' },
  { country_code: 'BF', subdivision_name: 'Gnagna', code: 'BF-GNA' },
  { country_code: 'BF', subdivision_name: 'Houet', code: 'BF-HOU' },
  { country_code: 'BF', subdivision_name: 'Kadiogo', code: 'BF-KAD' },
  { country_code: 'BF', subdivision_name: 'Kourweogo', code: 'BF-KOW' },
  { country_code: 'BF', subdivision_name: 'Leraba', code: 'BF-LER' },
  { country_code: 'BF', subdivision_name: 'Mouhoun', code: 'BF-MOU' },
  { country_code: 'BF', subdivision_name: 'Poni', code: 'BF-PON' },
  { country_code: 'BF', subdivision_name: 'Sanmatenga', code: 'BF-SMT' },
  { country_code: 'BF', subdivision_name: 'Tapoa', code: 'BF-TAP' },
  { country_code: 'BF', subdivision_name: 'Tuy', code: 'BF-TUI' },
  { country_code: 'BF', subdivision_name: 'Yatenga', code: 'BF-YAT' },
  { country_code: 'BF', subdivision_name: 'Zoundweogo', code: 'BF-ZOU' },
  { country_code: 'BG', subdivision_name: 'Blagoevgrad', code: 'BG-01' },
  { country_code: 'BG', subdivision_name: 'Burgas', code: 'BG-02' },
  { country_code: 'BG', subdivision_name: 'Dobrich', code: 'BG-08' },
  { country_code: 'BG', subdivision_name: 'Gabrovo', code: 'BG-07' },
  { country_code: 'BG', subdivision_name: 'Haskovo', code: 'BG-26' },
  { country_code: 'BG', subdivision_name: 'Kardzhali', code: 'BG-09' },
  { country_code: 'BG', subdivision_name: 'Kyustendil', code: 'BG-10' },
  { country_code: 'BG', subdivision_name: 'Lovech', code: 'BG-11' },
  { country_code: 'BG', subdivision_name: 'Montana', code: 'BG-12' },
  { country_code: 'BG', subdivision_name: 'Pazardzhik', code: 'BG-13' },
  { country_code: 'BG', subdivision_name: 'Pernik', code: 'BG-14' },
  { country_code: 'BG', subdivision_name: 'Pleven', code: 'BG-15' },
  { country_code: 'BG', subdivision_name: 'Plovdiv', code: 'BG-16' },
  { country_code: 'BG', subdivision_name: 'Razgrad', code: 'BG-17' },
  { country_code: 'BG', subdivision_name: 'Ruse', code: 'BG-18' },
  { country_code: 'BG', subdivision_name: 'Shumen', code: 'BG-27' },
  { country_code: 'BG', subdivision_name: 'Silistra', code: 'BG-19' },
  { country_code: 'BG', subdivision_name: 'Sliven', code: 'BG-20' },
  { country_code: 'BG', subdivision_name: 'Smolyan', code: 'BG-21' },
  { country_code: 'BG', subdivision_name: 'Sofia', code: 'BG-23' },
  { country_code: 'BG', subdivision_name: 'Sofia (stolitsa)', code: 'BG-22' },
  { country_code: 'BG', subdivision_name: 'Stara Zagora', code: 'BG-24' },
  { country_code: 'BG', subdivision_name: 'Targovishte', code: 'BG-25' },
  { country_code: 'BG', subdivision_name: 'Varna', code: 'BG-03' },
  { country_code: 'BG', subdivision_name: 'Veliko Tarnovo', code: 'BG-04' },
  { country_code: 'BG', subdivision_name: 'Vidin', code: 'BG-05' },
  { country_code: 'BG', subdivision_name: 'Vratsa', code: 'BG-06' },
  { country_code: 'BG', subdivision_name: 'Yambol', code: 'BG-28' },
  { country_code: 'BH', subdivision_name: "Al 'Asimah", code: 'BH-13' },
  { country_code: 'BH', subdivision_name: 'Al Janubiyah', code: 'BH-14' },
  { country_code: 'BH', subdivision_name: 'Al Muharraq', code: 'BH-15' },
  { country_code: 'BH', subdivision_name: 'Ash Shamaliyah', code: 'BH-17' },
  { country_code: 'BI', subdivision_name: 'Bubanza', code: 'BI-BB' },
  { country_code: 'BI', subdivision_name: 'Bujumbura Mairie', code: 'BI-BM' },
  { country_code: 'BI', subdivision_name: 'Bururi', code: 'BI-BR' },
  { country_code: 'BI', subdivision_name: 'Cibitoke', code: 'BI-CI' },
  { country_code: 'BI', subdivision_name: 'Gitega', code: 'BI-GI' },
  { country_code: 'BI', subdivision_name: 'Kirundo', code: 'BI-KI' },
  { country_code: 'BI', subdivision_name: 'Muyinga', code: 'BI-MY' },
  { country_code: 'BI', subdivision_name: 'Mwaro', code: 'BI-MW' },
  { country_code: 'BI', subdivision_name: 'Ngozi', code: 'BI-NG' },
  { country_code: 'BI', subdivision_name: 'Rutana', code: 'BI-RT' },
  { country_code: 'BI', subdivision_name: 'Ruyigi', code: 'BI-RY' },
  { country_code: 'BJ', subdivision_name: 'Alibori', code: 'BJ-AL' },
  { country_code: 'BJ', subdivision_name: 'Atacora', code: 'BJ-AK' },
  { country_code: 'BJ', subdivision_name: 'Atlantique', code: 'BJ-AQ' },
  { country_code: 'BJ', subdivision_name: 'Borgou', code: 'BJ-BO' },
  { country_code: 'BJ', subdivision_name: 'Donga', code: 'BJ-DO' },
  { country_code: 'BJ', subdivision_name: 'Littoral', code: 'BJ-LI' },
  { country_code: 'BJ', subdivision_name: 'Mono', code: 'BJ-MO' },
  { country_code: 'BJ', subdivision_name: 'Oueme', code: 'BJ-OU' },
  { country_code: 'BJ', subdivision_name: 'Plateau', code: 'BJ-PL' },
  { country_code: 'BJ', subdivision_name: 'Zou', code: 'BJ-ZO' },
  { country_code: 'BL', subdivision_name: 'Saint Barthelemy', code: '-' },
  { country_code: 'BM', subdivision_name: 'Hamilton', code: '-' },
  { country_code: 'BM', subdivision_name: 'Saint George', code: '-' },
  { country_code: 'BN', subdivision_name: 'Belait', code: 'BN-BE' },
  { country_code: 'BN', subdivision_name: 'Brunei-Muara', code: 'BN-BM' },
  { country_code: 'BN', subdivision_name: 'Temburong', code: 'BN-TE' },
  { country_code: 'BN', subdivision_name: 'Tutong', code: 'BN-TU' },
  { country_code: 'BO', subdivision_name: 'Chuquisaca', code: 'BO-H' },
  { country_code: 'BO', subdivision_name: 'Cochabamba', code: 'BO-C' },
  { country_code: 'BO', subdivision_name: 'El Beni', code: 'BO-B' },
  { country_code: 'BO', subdivision_name: 'La Paz', code: 'BO-L' },
  { country_code: 'BO', subdivision_name: 'Oruro', code: 'BO-O' },
  { country_code: 'BO', subdivision_name: 'Pando', code: 'BO-N' },
  { country_code: 'BO', subdivision_name: 'Potosi', code: 'BO-P' },
  { country_code: 'BO', subdivision_name: 'Santa Cruz', code: 'BO-S' },
  { country_code: 'BO', subdivision_name: 'Tarija', code: 'BO-T' },
  { country_code: 'BQ', subdivision_name: 'Bonaire', code: 'BQ-BO' },
  { country_code: 'BQ', subdivision_name: 'Saba', code: 'BQ-SA' },
  { country_code: 'BQ', subdivision_name: 'Sint Eustatius', code: 'BQ-SE' },
  { country_code: 'BR', subdivision_name: 'Acre', code: 'BR-AC' },
  { country_code: 'BR', subdivision_name: 'Alagoas', code: 'BR-AL' },
  { country_code: 'BR', subdivision_name: 'Amapa', code: 'BR-AP' },
  { country_code: 'BR', subdivision_name: 'Amazonas', code: 'BR-AM' },
  { country_code: 'BR', subdivision_name: 'Bahia', code: 'BR-BA' },
  { country_code: 'BR', subdivision_name: 'Ceara', code: 'BR-CE' },
  { country_code: 'BR', subdivision_name: 'Distrito Federal', code: 'BR-DF' },
  { country_code: 'BR', subdivision_name: 'Espirito Santo', code: 'BR-ES' },
  { country_code: 'BR', subdivision_name: 'Goias', code: 'BR-GO' },
  { country_code: 'BR', subdivision_name: 'Maranhao', code: 'BR-MA' },
  { country_code: 'BR', subdivision_name: 'Mato Grosso', code: 'BR-MT' },
  { country_code: 'BR', subdivision_name: 'Mato Grosso do Sul', code: 'BR-MS' },
  { country_code: 'BR', subdivision_name: 'Minas Gerais', code: 'BR-MG' },
  { country_code: 'BR', subdivision_name: 'Para', code: 'BR-PA' },
  { country_code: 'BR', subdivision_name: 'Paraiba', code: 'BR-PB' },
  { country_code: 'BR', subdivision_name: 'Parana', code: 'BR-PR' },
  { country_code: 'BR', subdivision_name: 'Pernambuco', code: 'BR-PE' },
  { country_code: 'BR', subdivision_name: 'Piaui', code: 'BR-PI' },
  { country_code: 'BR', subdivision_name: 'Rio Grande do Norte', code: 'BR-RN' },
  { country_code: 'BR', subdivision_name: 'Rio Grande do Sul', code: 'BR-RS' },
  { country_code: 'BR', subdivision_name: 'Rio de Janeiro', code: 'BR-RJ' },
  { country_code: 'BR', subdivision_name: 'Rondonia', code: 'BR-RO' },
  { country_code: 'BR', subdivision_name: 'Roraima', code: 'BR-RR' },
  { country_code: 'BR', subdivision_name: 'Santa Catarina', code: 'BR-SC' },
  { country_code: 'BR', subdivision_name: 'Sao Paulo', code: 'BR-SP' },
  { country_code: 'BR', subdivision_name: 'Sergipe', code: 'BR-SE' },
  { country_code: 'BR', subdivision_name: 'Tocantins', code: 'BR-TO' },
  { country_code: 'BS', subdivision_name: 'Central Andros', code: 'BS-CS' },
  { country_code: 'BS', subdivision_name: 'City of Freeport', code: 'BS-FP' },
  { country_code: 'BS', subdivision_name: 'Harbour Island', code: 'BS-HI' },
  { country_code: 'BS', subdivision_name: 'Hope Town', code: 'BS-HT' },
  { country_code: 'BS', subdivision_name: 'Long Island', code: 'BS-LI' },
  { country_code: 'BS', subdivision_name: 'New Providence', code: 'BS-NP' },
  { country_code: 'BS', subdivision_name: 'South Eleuthera', code: 'BS-SE' },
  { country_code: 'BT', subdivision_name: 'Bumthang', code: 'BT-33' },
  { country_code: 'BT', subdivision_name: 'Chhukha', code: 'BT-12' },
  { country_code: 'BT', subdivision_name: 'Gasa', code: 'BT-GA' },
  { country_code: 'BT', subdivision_name: 'Haa', code: 'BT-13' },
  { country_code: 'BT', subdivision_name: 'Lhuentse', code: 'BT-44' },
  { country_code: 'BT', subdivision_name: 'Monggar', code: 'BT-42' },
  { country_code: 'BT', subdivision_name: 'Paro', code: 'BT-11' },
  { country_code: 'BT', subdivision_name: 'Pemagatshel', code: 'BT-43' },
  { country_code: 'BT', subdivision_name: 'Punakha', code: 'BT-23' },
  { country_code: 'BT', subdivision_name: 'Samdrup Jongkhar', code: 'BT-45' },
  { country_code: 'BT', subdivision_name: 'Samtse', code: 'BT-14' },
  { country_code: 'BT', subdivision_name: 'Thimphu', code: 'BT-15' },
  { country_code: 'BT', subdivision_name: 'Trashigang', code: 'BT-41' },
  { country_code: 'BT', subdivision_name: 'Trongsa', code: 'BT-32' },
  { country_code: 'BT', subdivision_name: 'Tsirang', code: 'BT-21' },
  { country_code: 'BT', subdivision_name: 'Wangdue Phodrang', code: 'BT-24' },
  { country_code: 'BW', subdivision_name: 'Central', code: 'BW-CE' },
  { country_code: 'BW', subdivision_name: 'Kgatleng', code: 'BW-KL' },
  { country_code: 'BW', subdivision_name: 'Kweneng', code: 'BW-KW' },
  { country_code: 'BW', subdivision_name: 'North East', code: 'BW-NE' },
  { country_code: 'BW', subdivision_name: 'North West', code: 'BW-NW' },
  { country_code: 'BW', subdivision_name: 'South East', code: 'BW-SE' },
  { country_code: 'BY', subdivision_name: "Brestskaya voblasts'", code: 'BY-BR' },
  { country_code: 'BY', subdivision_name: "Homyel'skaya voblasts'", code: 'BY-HO' },
  { country_code: 'BY', subdivision_name: 'Horad Minsk', code: 'BY-HM' },
  { country_code: 'BY', subdivision_name: "Hrodzenskaya voblasts'", code: 'BY-HR' },
  { country_code: 'BY', subdivision_name: "Mahilyowskaya voblasts'", code: 'BY-MA' },
  { country_code: 'BY', subdivision_name: "Minskaya voblasts'", code: 'BY-MI' },
  { country_code: 'BY', subdivision_name: "Vitsyebskaya voblasts'", code: 'BY-VI' },
  { country_code: 'BZ', subdivision_name: 'Belize', code: 'BZ-BZ' },
  { country_code: 'BZ', subdivision_name: 'Cayo', code: 'BZ-CY' },
  { country_code: 'BZ', subdivision_name: 'Corozal', code: 'BZ-CZL' },
  { country_code: 'BZ', subdivision_name: 'Orange Walk', code: 'BZ-OW' },
  { country_code: 'BZ', subdivision_name: 'Stann Creek', code: 'BZ-SC' },
  { country_code: 'BZ', subdivision_name: 'Toledo', code: 'BZ-TOL' },
  { country_code: 'CA', subdivision_name: 'Alberta', code: 'CA-AB' },
  { country_code: 'CA', subdivision_name: 'British Columbia', code: 'CA-BC' },
  { country_code: 'CA', subdivision_name: 'Manitoba', code: 'CA-MB' },
  { country_code: 'CA', subdivision_name: 'New Brunswick', code: 'CA-NB' },
  { country_code: 'CA', subdivision_name: 'Newfoundland and Labrador', code: 'CA-NL' },
  { country_code: 'CA', subdivision_name: 'Northwest Territories', code: 'CA-NT' },
  { country_code: 'CA', subdivision_name: 'Nova Scotia', code: 'CA-NS' },
  { country_code: 'CA', subdivision_name: 'Nunavut', code: 'CA-NU' },
  { country_code: 'CA', subdivision_name: 'Ontario', code: 'CA-ON' },
  { country_code: 'CA', subdivision_name: 'Prince Edward Island', code: 'CA-PE' },
  { country_code: 'CA', subdivision_name: 'Quebec', code: 'CA-QC' },
  { country_code: 'CA', subdivision_name: 'Saskatchewan', code: 'CA-SK' },
  { country_code: 'CA', subdivision_name: 'Yukon', code: 'CA-YT' },
  { country_code: 'CD', subdivision_name: 'Equateur', code: 'CD-EQ' },
  { country_code: 'CD', subdivision_name: 'Haut-Katanga', code: 'CD-HK' },
  { country_code: 'CD', subdivision_name: 'Ituri', code: 'CD-IT' },
  { country_code: 'CD', subdivision_name: 'Kasai Central', code: 'CD-KC' },
  { country_code: 'CD', subdivision_name: 'Kasai Oriental', code: 'CD-KE' },
  { country_code: 'CD', subdivision_name: 'Kinshasa', code: 'CD-KN' },
  { country_code: 'CD', subdivision_name: 'Kongo Central', code: 'CD-BC' },
  { country_code: 'CD', subdivision_name: 'Kwilu', code: 'CD-KL' },
  { country_code: 'CD', subdivision_name: 'Lualaba', code: 'CD-LU' },
  { country_code: 'CD', subdivision_name: 'Maniema', code: 'CD-MA' },
  { country_code: 'CD', subdivision_name: 'Nord-Kivu', code: 'CD-NK' },
  { country_code: 'CD', subdivision_name: 'Nord-Ubangi', code: 'CD-NU' },
  { country_code: 'CD', subdivision_name: 'Sankuru', code: 'CD-SA' },
  { country_code: 'CD', subdivision_name: 'Sud-Kivu', code: 'CD-SK' },
  { country_code: 'CD', subdivision_name: 'Sud-Ubangi', code: 'CD-SU' },
  { country_code: 'CD', subdivision_name: 'Tanganyika', code: 'CD-TA' },
  { country_code: 'CD', subdivision_name: 'Tshopo', code: 'CD-TO' },
  { country_code: 'CD', subdivision_name: 'Tshuapa', code: 'CD-TU' },
  { country_code: 'CF', subdivision_name: 'Bangui', code: 'CF-BGF' },
  { country_code: 'CF', subdivision_name: 'Haute-Kotto', code: 'CF-HK' },
  { country_code: 'CF', subdivision_name: 'Nana-Mambere', code: 'CF-NM' },
  { country_code: 'CF', subdivision_name: 'Ouham', code: 'CF-AC' },
  { country_code: 'CG', subdivision_name: 'Brazzaville', code: 'CG-BZV' },
  { country_code: 'CG', subdivision_name: 'Cuvette-Ouest', code: 'CG-15' },
  { country_code: 'CG', subdivision_name: 'Pointe-Noire', code: 'CG-16' },
  { country_code: 'CG', subdivision_name: 'Sangha', code: 'CG-13' },
  { country_code: 'CH', subdivision_name: 'Aargau', code: 'CH-AG' },
  { country_code: 'CH', subdivision_name: 'Appenzell Ausserrhoden', code: 'CH-AR' },
  { country_code: 'CH', subdivision_name: 'Appenzell Innerrhoden', code: 'CH-AI' },
  { country_code: 'CH', subdivision_name: 'Basel-Landschaft', code: 'CH-BL' },
  { country_code: 'CH', subdivision_name: 'Basel-Stadt', code: 'CH-BS' },
  { country_code: 'CH', subdivision_name: 'Bern', code: 'CH-BE' },
  { country_code: 'CH', subdivision_name: 'Fribourg', code: 'CH-FR' },
  { country_code: 'CH', subdivision_name: 'Geneve', code: 'CH-GE' },
  { country_code: 'CH', subdivision_name: 'Glarus', code: 'CH-GL' },
  { country_code: 'CH', subdivision_name: 'Graubunden', code: 'CH-GR' },
  { country_code: 'CH', subdivision_name: 'Jura', code: 'CH-JU' },
  { country_code: 'CH', subdivision_name: 'Luzern', code: 'CH-LU' },
  { country_code: 'CH', subdivision_name: 'Neuchatel', code: 'CH-NE' },
  { country_code: 'CH', subdivision_name: 'Nidwalden', code: 'CH-NW' },
  { country_code: 'CH', subdivision_name: 'Obwalden', code: 'CH-OW' },
  { country_code: 'CH', subdivision_name: 'Sankt Gallen', code: 'CH-SG' },
  { country_code: 'CH', subdivision_name: 'Schaffhausen', code: 'CH-SH' },
  { country_code: 'CH', subdivision_name: 'Schwyz', code: 'CH-SZ' },
  { country_code: 'CH', subdivision_name: 'Solothurn', code: 'CH-SO' },
  { country_code: 'CH', subdivision_name: 'Thurgau', code: 'CH-TG' },
  { country_code: 'CH', subdivision_name: 'Ticino', code: 'CH-TI' },
  { country_code: 'CH', subdivision_name: 'Uri', code: 'CH-UR' },
  { country_code: 'CH', subdivision_name: 'Valais', code: 'CH-VS' },
  { country_code: 'CH', subdivision_name: 'Vaud', code: 'CH-VD' },
  { country_code: 'CH', subdivision_name: 'Zug', code: 'CH-ZG' },
  { country_code: 'CH', subdivision_name: 'Zurich', code: 'CH-ZH' },
  { country_code: 'CI', subdivision_name: 'Abidjan', code: 'CI-AB' },
  { country_code: 'CI', subdivision_name: 'Bas-Sassandra', code: 'CI-BS' },
  { country_code: 'CI', subdivision_name: 'Comoe', code: 'CI-CM' },
  { country_code: 'CI', subdivision_name: 'Denguele', code: 'CI-DN' },
  { country_code: 'CI', subdivision_name: 'Goh-Djiboua', code: 'CI-GD' },
  { country_code: 'CI', subdivision_name: 'Lacs', code: 'CI-LC' },
  { country_code: 'CI', subdivision_name: 'Lagunes', code: 'CI-LG' },
  { country_code: 'CI', subdivision_name: 'Montagnes', code: 'CI-MG' },
  { country_code: 'CI', subdivision_name: 'Sassandra-Marahoue', code: 'CI-SM' },
  { country_code: 'CI', subdivision_name: 'Savanes', code: 'CI-SV' },
  { country_code: 'CI', subdivision_name: 'Vallee du Bandama', code: 'CI-VB' },
  { country_code: 'CI', subdivision_name: 'Woroba', code: 'CI-WR' },
  { country_code: 'CI', subdivision_name: 'Yamoussoukro', code: 'CI-YM' },
  { country_code: 'CI', subdivision_name: 'Zanzan', code: 'CI-ZZ' },
  { country_code: 'CK', subdivision_name: 'Cook Islands', code: '-' },
  { country_code: 'CL', subdivision_name: 'Aisen del General Carlos Ibanez del Campo', code: 'CL-AI' },
  { country_code: 'CL', subdivision_name: 'Antofagasta', code: 'CL-AN' },
  { country_code: 'CL', subdivision_name: 'Arica y Parinacota', code: 'CL-AP' },
  { country_code: 'CL', subdivision_name: 'Atacama', code: 'CL-AT' },
  { country_code: 'CL', subdivision_name: 'Biobio', code: 'CL-BI' },
  { country_code: 'CL', subdivision_name: 'Coquimbo', code: 'CL-CO' },
  { country_code: 'CL', subdivision_name: 'La Araucania', code: 'CL-AR' },
  { country_code: 'CL', subdivision_name: "Libertador General Bernardo O'Higgins", code: 'CL-LI' },
  { country_code: 'CL', subdivision_name: 'Los Lagos', code: 'CL-LL' },
  { country_code: 'CL', subdivision_name: 'Los Rios', code: 'CL-LR' },
  { country_code: 'CL', subdivision_name: 'Magallanes', code: 'CL-MA' },
  { country_code: 'CL', subdivision_name: 'Maule', code: 'CL-ML' },
  { country_code: 'CL', subdivision_name: 'Region Metropolitana de Santiago', code: 'CL-RM' },
  { country_code: 'CL', subdivision_name: 'Tarapaca', code: 'CL-TA' },
  { country_code: 'CL', subdivision_name: 'Valparaiso', code: 'CL-VS' },
  { country_code: 'CM', subdivision_name: 'Adamaoua', code: 'CM-AD' },
  { country_code: 'CM', subdivision_name: 'Centre', code: 'CM-CE' },
  { country_code: 'CM', subdivision_name: 'Est', code: 'CM-ES' },
  { country_code: 'CM', subdivision_name: 'Extreme-Nord', code: 'CM-EN' },
  { country_code: 'CM', subdivision_name: 'Littoral', code: 'CM-LT' },
  { country_code: 'CM', subdivision_name: 'Nord', code: 'CM-NO' },
  { country_code: 'CM', subdivision_name: 'Nord-Ouest', code: 'CM-NW' },
  { country_code: 'CM', subdivision_name: 'Ouest', code: 'CM-OU' },
  { country_code: 'CM', subdivision_name: 'Sud', code: 'CM-SU' },
  { country_code: 'CM', subdivision_name: 'Sud-Ouest', code: 'CM-SW' },
  { country_code: 'CN', subdivision_name: 'Anhui', code: 'CN-AH' },
  { country_code: 'CN', subdivision_name: 'Beijing', code: 'CN-BJ' },
  { country_code: 'CN', subdivision_name: 'Chongqing', code: 'CN-CQ' },
  { country_code: 'CN', subdivision_name: 'Fujian', code: 'CN-FJ' },
  { country_code: 'CN', subdivision_name: 'Gansu', code: 'CN-GS' },
  { country_code: 'CN', subdivision_name: 'Guangdong', code: 'CN-GD' },
  { country_code: 'CN', subdivision_name: 'Guangxi', code: 'CN-GX' },
  { country_code: 'CN', subdivision_name: 'Guizhou', code: 'CN-GZ' },
  { country_code: 'CN', subdivision_name: 'Hainan', code: 'CN-HI' },
  { country_code: 'CN', subdivision_name: 'Hebei', code: 'CN-HE' },
  { country_code: 'CN', subdivision_name: 'Heilongjiang', code: 'CN-HL' },
  { country_code: 'CN', subdivision_name: 'Henan', code: 'CN-HA' },
  { country_code: 'CN', subdivision_name: 'Hubei', code: 'CN-HB' },
  { country_code: 'CN', subdivision_name: 'Hunan', code: 'CN-HN' },
  { country_code: 'CN', subdivision_name: 'Jiangsu', code: 'CN-JS' },
  { country_code: 'CN', subdivision_name: 'Jiangxi', code: 'CN-JX' },
  { country_code: 'CN', subdivision_name: 'Jilin', code: 'CN-JL' },
  { country_code: 'CN', subdivision_name: 'Liaoning', code: 'CN-LN' },
  { country_code: 'CN', subdivision_name: 'Nei Mongol', code: 'CN-NM' },
  { country_code: 'CN', subdivision_name: 'Ningxia', code: 'CN-NX' },
  { country_code: 'CN', subdivision_name: 'Qinghai', code: 'CN-QH' },
  { country_code: 'CN', subdivision_name: 'Shaanxi', code: 'CN-SN' },
  { country_code: 'CN', subdivision_name: 'Shandong', code: 'CN-SD' },
  { country_code: 'CN', subdivision_name: 'Shanghai', code: 'CN-SH' },
  { country_code: 'CN', subdivision_name: 'Shanxi', code: 'CN-SX' },
  { country_code: 'CN', subdivision_name: 'Sichuan', code: 'CN-SC' },
  { country_code: 'CN', subdivision_name: 'Tianjin', code: 'CN-TJ' },
  { country_code: 'CN', subdivision_name: 'Xinjiang', code: 'CN-XJ' },
  { country_code: 'CN', subdivision_name: 'Xizang', code: 'CN-XZ' },
  { country_code: 'CN', subdivision_name: 'Yunnan', code: 'CN-YN' },
  { country_code: 'CN', subdivision_name: 'Zhejiang', code: 'CN-ZJ' },
  { country_code: 'CO', subdivision_name: 'Amazonas', code: 'CO-AMA' },
  { country_code: 'CO', subdivision_name: 'Antioquia', code: 'CO-ANT' },
  { country_code: 'CO', subdivision_name: 'Arauca', code: 'CO-ARA' },
  { country_code: 'CO', subdivision_name: 'Atlantico', code: 'CO-ATL' },
  { country_code: 'CO', subdivision_name: 'Bolivar', code: 'CO-BOL' },
  { country_code: 'CO', subdivision_name: 'Boyaca', code: 'CO-BOY' },
  { country_code: 'CO', subdivision_name: 'Caldas', code: 'CO-CAL' },
  { country_code: 'CO', subdivision_name: 'Caqueta', code: 'CO-CAQ' },
  { country_code: 'CO', subdivision_name: 'Casanare', code: 'CO-CAS' },
  { country_code: 'CO', subdivision_name: 'Cauca', code: 'CO-CAU' },
  { country_code: 'CO', subdivision_name: 'Cesar', code: 'CO-CES' },
  { country_code: 'CO', subdivision_name: 'Choco', code: 'CO-CHO' },
  { country_code: 'CO', subdivision_name: 'Cordoba', code: 'CO-COR' },
  { country_code: 'CO', subdivision_name: 'Cundinamarca', code: 'CO-CUN' },
  { country_code: 'CO', subdivision_name: 'Distrito Capital de Bogota', code: 'CO-DC' },
  { country_code: 'CO', subdivision_name: 'Guainia', code: 'CO-GUA' },
  { country_code: 'CO', subdivision_name: 'Guaviare', code: 'CO-GUV' },
  { country_code: 'CO', subdivision_name: 'Huila', code: 'CO-HUI' },
  { country_code: 'CO', subdivision_name: 'La Guajira', code: 'CO-LAG' },
  { country_code: 'CO', subdivision_name: 'Magdalena', code: 'CO-MAG' },
  { country_code: 'CO', subdivision_name: 'Meta', code: 'CO-MET' },
  { country_code: 'CO', subdivision_name: 'Narino', code: 'CO-NAR' },
  { country_code: 'CO', subdivision_name: 'Norte de Santander', code: 'CO-NSA' },
  { country_code: 'CO', subdivision_name: 'Putumayo', code: 'CO-PUT' },
  { country_code: 'CO', subdivision_name: 'Quindio', code: 'CO-QUI' },
  { country_code: 'CO', subdivision_name: 'Risaralda', code: 'CO-RIS' },
  { country_code: 'CO', subdivision_name: 'San Andres, Providencia y Santa Catalina', code: 'CO-SAP' },
  { country_code: 'CO', subdivision_name: 'Santander', code: 'CO-SAN' },
  { country_code: 'CO', subdivision_name: 'Sucre', code: 'CO-SUC' },
  { country_code: 'CO', subdivision_name: 'Tolima', code: 'CO-TOL' },
  { country_code: 'CO', subdivision_name: 'Valle del Cauca', code: 'CO-VAC' },
  { country_code: 'CO', subdivision_name: 'Vichada', code: 'CO-VID' },
  { country_code: 'CR', subdivision_name: 'Alajuela', code: 'CR-A' },
  { country_code: 'CR', subdivision_name: 'Cartago', code: 'CR-C' },
  { country_code: 'CR', subdivision_name: 'Guanacaste', code: 'CR-G' },
  { country_code: 'CR', subdivision_name: 'Heredia', code: 'CR-H' },
  { country_code: 'CR', subdivision_name: 'Limon', code: 'CR-L' },
  { country_code: 'CR', subdivision_name: 'Puntarenas', code: 'CR-P' },
  { country_code: 'CR', subdivision_name: 'San Jose', code: 'CR-SJ' },
  { country_code: 'CU', subdivision_name: 'Artemisa', code: 'CU-15' },
  { country_code: 'CU', subdivision_name: 'Camaguey', code: 'CU-09' },
  { country_code: 'CU', subdivision_name: 'Ciego de Avila', code: 'CU-08' },
  { country_code: 'CU', subdivision_name: 'Cienfuegos', code: 'CU-06' },
  { country_code: 'CU', subdivision_name: 'Granma', code: 'CU-12' },
  { country_code: 'CU', subdivision_name: 'Guantanamo', code: 'CU-14' },
  { country_code: 'CU', subdivision_name: 'Holguin', code: 'CU-11' },
  { country_code: 'CU', subdivision_name: 'La Habana', code: 'CU-03' },
  { country_code: 'CU', subdivision_name: 'Las Tunas', code: 'CU-10' },
  { country_code: 'CU', subdivision_name: 'Matanzas', code: 'CU-04' },
  { country_code: 'CU', subdivision_name: 'Mayabeque', code: 'CU-16' },
  { country_code: 'CU', subdivision_name: 'Pinar del Rio', code: 'CU-01' },
  { country_code: 'CU', subdivision_name: 'Sancti Spiritus', code: 'CU-07' },
  { country_code: 'CU', subdivision_name: 'Santiago de Cuba', code: 'CU-13' },
  { country_code: 'CU', subdivision_name: 'Villa Clara', code: 'CU-05' },
  { country_code: 'CV', subdivision_name: 'Boa Vista', code: 'CV-BV' },
  { country_code: 'CV', subdivision_name: 'Paul', code: 'CV-PA' },
  { country_code: 'CV', subdivision_name: 'Porto Novo', code: 'CV-PN' },
  { country_code: 'CV', subdivision_name: 'Praia', code: 'CV-PR' },
  { country_code: 'CV', subdivision_name: 'Ribeira Grande', code: 'CV-RG' },
  { country_code: 'CV', subdivision_name: 'Sal', code: 'CV-SL' },
  { country_code: 'CV', subdivision_name: 'Sao Vicente', code: 'CV-SV' },
  { country_code: 'CV', subdivision_name: 'Tarrafal', code: 'CV-TA' },
  { country_code: 'CW', subdivision_name: 'Curacao', code: '-' },
  { country_code: 'CY', subdivision_name: 'Ammochostos', code: 'CY-04' },
  { country_code: 'CY', subdivision_name: 'Keryneia', code: 'CY-06' },
  { country_code: 'CY', subdivision_name: 'Larnaka', code: 'CY-03' },
  { country_code: 'CY', subdivision_name: 'Lefkosia', code: 'CY-01' },
  { country_code: 'CY', subdivision_name: 'Lemesos', code: 'CY-02' },
  { country_code: 'CY', subdivision_name: 'Pafos', code: 'CY-05' },
  { country_code: 'CZ', subdivision_name: 'Jihocesky kraj', code: 'CZ-31' },
  { country_code: 'CZ', subdivision_name: 'Jihomoravsky kraj', code: 'CZ-64' },
  { country_code: 'CZ', subdivision_name: 'Karlovarsky kraj', code: 'CZ-41' },
  { country_code: 'CZ', subdivision_name: 'Kraj Vysocina', code: 'CZ-63' },
  { country_code: 'CZ', subdivision_name: 'Kralovehradecky kraj', code: 'CZ-52' },
  { country_code: 'CZ', subdivision_name: 'Liberecky kraj', code: 'CZ-51' },
  { country_code: 'CZ', subdivision_name: 'Moravskoslezsky kraj', code: 'CZ-80' },
  { country_code: 'CZ', subdivision_name: 'Olomoucky kraj', code: 'CZ-71' },
  { country_code: 'CZ', subdivision_name: 'Pardubicky kraj', code: 'CZ-53' },
  { country_code: 'CZ', subdivision_name: 'Plzensky kraj', code: 'CZ-32' },
  { country_code: 'CZ', subdivision_name: 'Praha, Hlavni mesto', code: 'CZ-10' },
  { country_code: 'CZ', subdivision_name: 'Stredocesky kraj', code: 'CZ-20' },
  { country_code: 'CZ', subdivision_name: 'Ustecky kraj', code: 'CZ-42' },
  { country_code: 'CZ', subdivision_name: 'Zlinsky kraj', code: 'CZ-72' },
  { country_code: 'DE', subdivision_name: 'Baden-Wurttemberg', code: 'DE-BW' },
  { country_code: 'DE', subdivision_name: 'Bayern', code: 'DE-BY' },
  { country_code: 'DE', subdivision_name: 'Berlin', code: 'DE-BE' },
  { country_code: 'DE', subdivision_name: 'Brandenburg', code: 'DE-BB' },
  { country_code: 'DE', subdivision_name: 'Bremen', code: 'DE-HB' },
  { country_code: 'DE', subdivision_name: 'Hamburg', code: 'DE-HH' },
  { country_code: 'DE', subdivision_name: 'Hessen', code: 'DE-HE' },
  { country_code: 'DE', subdivision_name: 'Mecklenburg-Vorpommern', code: 'DE-MV' },
  { country_code: 'DE', subdivision_name: 'Niedersachsen', code: 'DE-NI' },
  { country_code: 'DE', subdivision_name: 'Nordrhein-Westfalen', code: 'DE-NW' },
  { country_code: 'DE', subdivision_name: 'Rheinland-Pfalz', code: 'DE-RP' },
  { country_code: 'DE', subdivision_name: 'Saarland', code: 'DE-SL' },
  { country_code: 'DE', subdivision_name: 'Sachsen', code: 'DE-SN' },
  { country_code: 'DE', subdivision_name: 'Sachsen-Anhalt', code: 'DE-ST' },
  { country_code: 'DE', subdivision_name: 'Schleswig-Holstein', code: 'DE-SH' },
  { country_code: 'DE', subdivision_name: 'Thuringen', code: 'DE-TH' },
  { country_code: 'DJ', subdivision_name: 'Djibouti', code: 'DJ-DJ' },
  { country_code: 'DJ', subdivision_name: 'Obock', code: 'DJ-OB' },
  { country_code: 'DK', subdivision_name: 'Hovedstaden', code: 'DK-84' },
  { country_code: 'DK', subdivision_name: 'Midtjylland', code: 'DK-82' },
  { country_code: 'DK', subdivision_name: 'Nordjylland', code: 'DK-81' },
  { country_code: 'DK', subdivision_name: 'Sjaelland', code: 'DK-85' },
  { country_code: 'DK', subdivision_name: 'Syddanmark', code: 'DK-83' },
  { country_code: 'DM', subdivision_name: 'Saint Andrew', code: 'DM-02' },
  { country_code: 'DM', subdivision_name: 'Saint George', code: 'DM-04' },
  { country_code: 'DM', subdivision_name: 'Saint Luke', code: 'DM-07' },
  { country_code: 'DM', subdivision_name: 'Saint Mark', code: 'DM-08' },
  { country_code: 'DM', subdivision_name: 'Saint Paul', code: 'DM-10' },
  { country_code: 'DO', subdivision_name: 'Azua', code: 'DO-02' },
  { country_code: 'DO', subdivision_name: 'Baoruco', code: 'DO-03' },
  { country_code: 'DO', subdivision_name: 'Barahona', code: 'DO-04' },
  { country_code: 'DO', subdivision_name: 'Dajabon', code: 'DO-05' },
  { country_code: 'DO', subdivision_name: 'Distrito Nacional (Santo Domingo)', code: 'DO-01' },
  { country_code: 'DO', subdivision_name: 'Duarte', code: 'DO-06' },
  { country_code: 'DO', subdivision_name: 'El Seibo', code: 'DO-08' },
  { country_code: 'DO', subdivision_name: 'Elias Pina', code: 'DO-07' },
  { country_code: 'DO', subdivision_name: 'Espaillat', code: 'DO-09' },
  { country_code: 'DO', subdivision_name: 'Hato Mayor', code: 'DO-30' },
  { country_code: 'DO', subdivision_name: 'Hermanas Mirabal', code: 'DO-19' },
  { country_code: 'DO', subdivision_name: 'Independencia', code: 'DO-10' },
  { country_code: 'DO', subdivision_name: 'La Altagracia', code: 'DO-11' },
  { country_code: 'DO', subdivision_name: 'La Romana', code: 'DO-12' },
  { country_code: 'DO', subdivision_name: 'La Vega', code: 'DO-13' },
  { country_code: 'DO', subdivision_name: 'Maria Trinidad Sanchez', code: 'DO-14' },
  { country_code: 'DO', subdivision_name: 'Monsenor Nouel', code: 'DO-28' },
  { country_code: 'DO', subdivision_name: 'Monte Cristi', code: 'DO-15' },
  { country_code: 'DO', subdivision_name: 'Monte Plata', code: 'DO-29' },
  { country_code: 'DO', subdivision_name: 'Peravia', code: 'DO-17' },
  { country_code: 'DO', subdivision_name: 'Puerto Plata', code: 'DO-18' },
  { country_code: 'DO', subdivision_name: 'Samana', code: 'DO-20' },
  { country_code: 'DO', subdivision_name: 'San Cristobal', code: 'DO-21' },
  { country_code: 'DO', subdivision_name: 'San Jose de Ocoa', code: 'DO-31' },
  { country_code: 'DO', subdivision_name: 'San Juan', code: 'DO-22' },
  { country_code: 'DO', subdivision_name: 'San Pedro de Macoris', code: 'DO-23' },
  { country_code: 'DO', subdivision_name: 'Sanchez Ramirez', code: 'DO-24' },
  { country_code: 'DO', subdivision_name: 'Santiago', code: 'DO-25' },
  { country_code: 'DO', subdivision_name: 'Santiago Rodriguez', code: 'DO-26' },
  { country_code: 'DO', subdivision_name: 'Valverde', code: 'DO-27' },
  { country_code: 'DZ', subdivision_name: 'Adrar', code: 'DZ-01' },
  { country_code: 'DZ', subdivision_name: 'Ain Defla', code: 'DZ-44' },
  { country_code: 'DZ', subdivision_name: 'Ain Temouchent', code: 'DZ-46' },
  { country_code: 'DZ', subdivision_name: 'Alger', code: 'DZ-16' },
  { country_code: 'DZ', subdivision_name: 'Annaba', code: 'DZ-23' },
  { country_code: 'DZ', subdivision_name: 'Batna', code: 'DZ-05' },
  { country_code: 'DZ', subdivision_name: 'Bechar', code: 'DZ-08' },
  { country_code: 'DZ', subdivision_name: 'Bejaia', code: 'DZ-06' },
  { country_code: 'DZ', subdivision_name: 'Biskra', code: 'DZ-07' },
  { country_code: 'DZ', subdivision_name: 'Blida', code: 'DZ-09' },
  { country_code: 'DZ', subdivision_name: 'Bordj Bou Arreridj', code: 'DZ-34' },
  { country_code: 'DZ', subdivision_name: 'Bouira', code: 'DZ-10' },
  { country_code: 'DZ', subdivision_name: 'Boumerdes', code: 'DZ-35' },
  { country_code: 'DZ', subdivision_name: 'Chlef', code: 'DZ-02' },
  { country_code: 'DZ', subdivision_name: 'Constantine', code: 'DZ-25' },
  { country_code: 'DZ', subdivision_name: 'Djelfa', code: 'DZ-17' },
  { country_code: 'DZ', subdivision_name: 'El Bayadh', code: 'DZ-32' },
  { country_code: 'DZ', subdivision_name: 'El Oued', code: 'DZ-39' },
  { country_code: 'DZ', subdivision_name: 'El Tarf', code: 'DZ-36' },
  { country_code: 'DZ', subdivision_name: 'Ghardaia', code: 'DZ-47' },
  { country_code: 'DZ', subdivision_name: 'Guelma', code: 'DZ-24' },
  { country_code: 'DZ', subdivision_name: 'Illizi', code: 'DZ-33' },
  { country_code: 'DZ', subdivision_name: 'Jijel', code: 'DZ-18' },
  { country_code: 'DZ', subdivision_name: 'Khenchela', code: 'DZ-40' },
  { country_code: 'DZ', subdivision_name: 'Laghouat', code: 'DZ-03' },
  { country_code: 'DZ', subdivision_name: "M'sila", code: 'DZ-28' },
  { country_code: 'DZ', subdivision_name: 'Mascara', code: 'DZ-29' },
  { country_code: 'DZ', subdivision_name: 'Medea', code: 'DZ-26' },
  { country_code: 'DZ', subdivision_name: 'Mila', code: 'DZ-43' },
  { country_code: 'DZ', subdivision_name: 'Mostaganem', code: 'DZ-27' },
  { country_code: 'DZ', subdivision_name: 'Naama', code: 'DZ-45' },
  { country_code: 'DZ', subdivision_name: 'Oran', code: 'DZ-31' },
  { country_code: 'DZ', subdivision_name: 'Ouargla', code: 'DZ-30' },
  { country_code: 'DZ', subdivision_name: 'Oum el Bouaghi', code: 'DZ-04' },
  { country_code: 'DZ', subdivision_name: 'Relizane', code: 'DZ-48' },
  { country_code: 'DZ', subdivision_name: 'Saida', code: 'DZ-20' },
  { country_code: 'DZ', subdivision_name: 'Setif', code: 'DZ-19' },
  { country_code: 'DZ', subdivision_name: 'Sidi Bel Abbes', code: 'DZ-22' },
  { country_code: 'DZ', subdivision_name: 'Skikda', code: 'DZ-21' },
  { country_code: 'DZ', subdivision_name: 'Souk Ahras', code: 'DZ-41' },
  { country_code: 'DZ', subdivision_name: 'Tamanrasset', code: 'DZ-11' },
  { country_code: 'DZ', subdivision_name: 'Tebessa', code: 'DZ-12' },
  { country_code: 'DZ', subdivision_name: 'Tiaret', code: 'DZ-14' },
  { country_code: 'DZ', subdivision_name: 'Tindouf', code: 'DZ-37' },
  { country_code: 'DZ', subdivision_name: 'Tipaza', code: 'DZ-42' },
  { country_code: 'DZ', subdivision_name: 'Tissemsilt', code: 'DZ-38' },
  { country_code: 'DZ', subdivision_name: 'Tizi Ouzou', code: 'DZ-15' },
  { country_code: 'DZ', subdivision_name: 'Tlemcen', code: 'DZ-13' },
  { country_code: 'EC', subdivision_name: 'Azuay', code: 'EC-A' },
  { country_code: 'EC', subdivision_name: 'Bolivar', code: 'EC-B' },
  { country_code: 'EC', subdivision_name: 'Canar', code: 'EC-F' },
  { country_code: 'EC', subdivision_name: 'Carchi', code: 'EC-C' },
  { country_code: 'EC', subdivision_name: 'Chimborazo', code: 'EC-H' },
  { country_code: 'EC', subdivision_name: 'Cotopaxi', code: 'EC-X' },
  { country_code: 'EC', subdivision_name: 'El Oro', code: 'EC-O' },
  { country_code: 'EC', subdivision_name: 'Esmeraldas', code: 'EC-E' },
  { country_code: 'EC', subdivision_name: 'Galapagos', code: 'EC-W' },
  { country_code: 'EC', subdivision_name: 'Guayas', code: 'EC-G' },
  { country_code: 'EC', subdivision_name: 'Imbabura', code: 'EC-I' },
  { country_code: 'EC', subdivision_name: 'Loja', code: 'EC-L' },
  { country_code: 'EC', subdivision_name: 'Los Rios', code: 'EC-R' },
  { country_code: 'EC', subdivision_name: 'Manabi', code: 'EC-M' },
  { country_code: 'EC', subdivision_name: 'Morona Santiago', code: 'EC-S' },
  { country_code: 'EC', subdivision_name: 'Napo', code: 'EC-N' },
  { country_code: 'EC', subdivision_name: 'Orellana', code: 'EC-D' },
  { country_code: 'EC', subdivision_name: 'Pastaza', code: 'EC-Y' },
  { country_code: 'EC', subdivision_name: 'Pichincha', code: 'EC-P' },
  { country_code: 'EC', subdivision_name: 'Santa Elena', code: 'EC-SE' },
  { country_code: 'EC', subdivision_name: 'Santo Domingo de los Tsachilas', code: 'EC-SD' },
  { country_code: 'EC', subdivision_name: 'Sucumbios', code: 'EC-U' },
  { country_code: 'EC', subdivision_name: 'Tungurahua', code: 'EC-T' },
  { country_code: 'EC', subdivision_name: 'Zamora Chinchipe', code: 'EC-Z' },
  { country_code: 'EE', subdivision_name: 'Harjumaa', code: 'EE-37' },
  { country_code: 'EE', subdivision_name: 'Hiiumaa', code: 'EE-39' },
  { country_code: 'EE', subdivision_name: 'Ida-Virumaa', code: 'EE-44' },
  { country_code: 'EE', subdivision_name: 'Jarvamaa', code: 'EE-51' },
  { country_code: 'EE', subdivision_name: 'Jogevamaa', code: 'EE-49' },
  { country_code: 'EE', subdivision_name: 'Laane-Virumaa', code: 'EE-59' },
  { country_code: 'EE', subdivision_name: 'Laanemaa', code: 'EE-57' },
  { country_code: 'EE', subdivision_name: 'Parnumaa', code: 'EE-67' },
  { country_code: 'EE', subdivision_name: 'Polvamaa', code: 'EE-65' },
  { country_code: 'EE', subdivision_name: 'Raplamaa', code: 'EE-70' },
  { country_code: 'EE', subdivision_name: 'Saaremaa', code: 'EE-74' },
  { country_code: 'EE', subdivision_name: 'Tartumaa', code: 'EE-78' },
  { country_code: 'EE', subdivision_name: 'Valgamaa', code: 'EE-82' },
  { country_code: 'EE', subdivision_name: 'Viljandimaa', code: 'EE-84' },
  { country_code: 'EE', subdivision_name: 'Vorumaa', code: 'EE-86' },
  { country_code: 'EG', subdivision_name: 'Ad Daqahliyah', code: 'EG-DK' },
  { country_code: 'EG', subdivision_name: 'Al Bahr al Ahmar', code: 'EG-BA' },
  { country_code: 'EG', subdivision_name: 'Al Buhayrah', code: 'EG-BH' },
  { country_code: 'EG', subdivision_name: 'Al Fayyum', code: 'EG-FYM' },
  { country_code: 'EG', subdivision_name: 'Al Gharbiyah', code: 'EG-GH' },
  { country_code: 'EG', subdivision_name: 'Al Iskandariyah', code: 'EG-ALX' },
  { country_code: 'EG', subdivision_name: "Al Isma'iliyah", code: 'EG-IS' },
  { country_code: 'EG', subdivision_name: 'Al Jizah', code: 'EG-GZ' },
  { country_code: 'EG', subdivision_name: 'Al Minufiyah', code: 'EG-MNF' },
  { country_code: 'EG', subdivision_name: 'Al Minya', code: 'EG-MN' },
  { country_code: 'EG', subdivision_name: 'Al Qahirah', code: 'EG-C' },
  { country_code: 'EG', subdivision_name: 'Al Qalyubiyah', code: 'EG-KB' },
  { country_code: 'EG', subdivision_name: 'Al Uqsur', code: 'EG-LX' },
  { country_code: 'EG', subdivision_name: 'Al Wadi al Jadid', code: 'EG-WAD' },
  { country_code: 'EG', subdivision_name: 'As Suways', code: 'EG-SUZ' },
  { country_code: 'EG', subdivision_name: 'Ash Sharqiyah', code: 'EG-SHR' },
  { country_code: 'EG', subdivision_name: 'Aswan', code: 'EG-ASN' },
  { country_code: 'EG', subdivision_name: 'Asyut', code: 'EG-AST' },
  { country_code: 'EG', subdivision_name: 'Bani Suwayf', code: 'EG-BNS' },
  { country_code: 'EG', subdivision_name: "Bur Sa'id", code: 'EG-PTS' },
  { country_code: 'EG', subdivision_name: 'Dumyat', code: 'EG-DT' },
  { country_code: 'EG', subdivision_name: "Janub Sina'", code: 'EG-JS' },
  { country_code: 'EG', subdivision_name: 'Kafr ash Shaykh', code: 'EG-KFS' },
  { country_code: 'EG', subdivision_name: 'Matruh', code: 'EG-MT' },
  { country_code: 'EG', subdivision_name: 'Qina', code: 'EG-KN' },
  { country_code: 'EG', subdivision_name: "Shamal Sina'", code: 'EG-SIN' },
  { country_code: 'EG', subdivision_name: 'Suhaj', code: 'EG-SHG' },
  { country_code: 'ER', subdivision_name: 'Al Awsat', code: 'ER-MA' },
  { country_code: 'ES', subdivision_name: 'Andalucia', code: 'ES-AN' },
  { country_code: 'ES', subdivision_name: 'Aragon', code: 'ES-AR' },
  { country_code: 'ES', subdivision_name: 'Asturias, Principado de', code: 'ES-AS' },
  { country_code: 'ES', subdivision_name: 'Canarias', code: 'ES-CN' },
  { country_code: 'ES', subdivision_name: 'Cantabria', code: 'ES-CB' },
  { country_code: 'ES', subdivision_name: 'Castilla y Leon', code: 'ES-CL' },
  { country_code: 'ES', subdivision_name: 'Castilla-La Mancha', code: 'ES-CM' },
  { country_code: 'ES', subdivision_name: 'Catalunya', code: 'ES-CT' },
  { country_code: 'ES', subdivision_name: 'Ceuta', code: 'ES-CE' },
  { country_code: 'ES', subdivision_name: 'Extremadura', code: 'ES-EX' },
  { country_code: 'ES', subdivision_name: 'Galicia', code: 'ES-GA' },
  { country_code: 'ES', subdivision_name: 'Illes Balears', code: 'ES-IB' },
  { country_code: 'ES', subdivision_name: 'La Rioja', code: 'ES-RI' },
  { country_code: 'ES', subdivision_name: 'Madrid, Comunidad de', code: 'ES-MD' },
  { country_code: 'ES', subdivision_name: 'Melilla', code: 'ES-ML' },
  { country_code: 'ES', subdivision_name: 'Murcia, Region de', code: 'ES-MC' },
  { country_code: 'ES', subdivision_name: 'Navarra, Comunidad Foral de', code: 'ES-NC' },
  { country_code: 'ES', subdivision_name: 'Pais Vasco', code: 'ES-PV' },
  { country_code: 'ES', subdivision_name: 'Valenciana, Comunidad', code: 'ES-VC' },
  { country_code: 'ET', subdivision_name: 'Adis Abeba', code: 'ET-AA' },
  { country_code: 'ET', subdivision_name: 'Afar', code: 'ET-AF' },
  { country_code: 'ET', subdivision_name: 'Amara', code: 'ET-AM' },
  { country_code: 'ET', subdivision_name: 'Binshangul Gumuz', code: 'ET-BE' },
  { country_code: 'ET', subdivision_name: 'Dire Dawa', code: 'ET-DD' },
  { country_code: 'ET', subdivision_name: 'Hareri Hizb', code: 'ET-HA' },
  { country_code: 'ET', subdivision_name: 'Oromiya', code: 'ET-OR' },
  { country_code: 'ET', subdivision_name: 'Sumale', code: 'ET-SO' },
  { country_code: 'ET', subdivision_name: 'Tigray', code: 'ET-TI' },
  { country_code: 'ET', subdivision_name: 'YeDebub Biheroch Bihereseboch na Hizboch', code: 'ET-SN' },
  { country_code: 'FI', subdivision_name: 'Etela-Karjala', code: 'FI-02' },
  { country_code: 'FI', subdivision_name: 'Etela-Pohjanmaa', code: 'FI-03' },
  { country_code: 'FI', subdivision_name: 'Etela-Savo', code: 'FI-04' },
  { country_code: 'FI', subdivision_name: 'Kainuu', code: 'FI-05' },
  { country_code: 'FI', subdivision_name: 'Kanta-Hame', code: 'FI-06' },
  { country_code: 'FI', subdivision_name: 'Keski-Pohjanmaa', code: 'FI-07' },
  { country_code: 'FI', subdivision_name: 'Keski-Suomi', code: 'FI-08' },
  { country_code: 'FI', subdivision_name: 'Kymenlaakso', code: 'FI-09' },
  { country_code: 'FI', subdivision_name: 'Lappi', code: 'FI-10' },
  { country_code: 'FI', subdivision_name: 'Paijat-Hame', code: 'FI-16' },
  { country_code: 'FI', subdivision_name: 'Pirkanmaa', code: 'FI-11' },
  { country_code: 'FI', subdivision_name: 'Pohjanmaa', code: 'FI-12' },
  { country_code: 'FI', subdivision_name: 'Pohjois-Karjala', code: 'FI-13' },
  { country_code: 'FI', subdivision_name: 'Pohjois-Pohjanmaa', code: 'FI-14' },
  { country_code: 'FI', subdivision_name: 'Pohjois-Savo', code: 'FI-15' },
  { country_code: 'FI', subdivision_name: 'Satakunta', code: 'FI-17' },
  { country_code: 'FI', subdivision_name: 'Uusimaa', code: 'FI-18' },
  { country_code: 'FI', subdivision_name: 'Varsinais-Suomi', code: 'FI-19' },
  { country_code: 'FJ', subdivision_name: 'Central', code: 'FJ-C' },
  { country_code: 'FJ', subdivision_name: 'Eastern', code: 'FJ-E' },
  { country_code: 'FJ', subdivision_name: 'Rotuma', code: 'FJ-R' },
  { country_code: 'FJ', subdivision_name: 'Western', code: 'FJ-W' },
  { country_code: 'FK', subdivision_name: 'Falkland Islands (Malvinas)', code: '-' },
  { country_code: 'FM', subdivision_name: 'Chuuk', code: 'FM-TRK' },
  { country_code: 'FM', subdivision_name: 'Kosrae', code: 'FM-KSA' },
  { country_code: 'FM', subdivision_name: 'Pohnpei', code: 'FM-PNI' },
  { country_code: 'FM', subdivision_name: 'Yap', code: 'FM-YAP' },
  { country_code: 'FO', subdivision_name: 'Eysturoy', code: '-' },
  { country_code: 'FO', subdivision_name: 'Nordoyar', code: '-' },
  { country_code: 'FO', subdivision_name: 'Streymoy', code: '-' },
  { country_code: 'FO', subdivision_name: 'Suduroy', code: '-' },
  { country_code: 'FO', subdivision_name: 'Vagar', code: '-' },
  { country_code: 'FR', subdivision_name: 'Auvergne-Rhone-Alpes', code: 'FR-ARA' },
  { country_code: 'FR', subdivision_name: 'Bourgogne-Franche-Comte', code: 'FR-BFC' },
  { country_code: 'FR', subdivision_name: 'Bretagne', code: 'FR-BRE' },
  { country_code: 'FR', subdivision_name: 'Centre-Val de Loire', code: 'FR-CVL' },
  { country_code: 'FR', subdivision_name: 'Corse', code: 'FR-COR' },
  { country_code: 'FR', subdivision_name: 'Grand-Est', code: 'FR-GES' },
  { country_code: 'FR', subdivision_name: 'Hauts-de-France', code: 'FR-HDF' },
  { country_code: 'FR', subdivision_name: 'Ile-de-France', code: 'FR-IDF' },
  { country_code: 'FR', subdivision_name: 'Normandie', code: 'FR-NOR' },
  { country_code: 'FR', subdivision_name: 'Nouvelle-Aquitaine', code: 'FR-NAQ' },
  { country_code: 'FR', subdivision_name: 'Occitanie', code: 'FR-OCC' },
  { country_code: 'FR', subdivision_name: 'Pays-de-la-Loire', code: 'FR-PDL' },
  { country_code: 'FR', subdivision_name: "Provence-Alpes-Cote-d'Azur", code: 'FR-PAC' },
  { country_code: 'GA', subdivision_name: 'Estuaire', code: 'GA-1' },
  { country_code: 'GA', subdivision_name: 'Haut-Ogooue', code: 'GA-2' },
  { country_code: 'GA', subdivision_name: 'Moyen-Ogooue', code: 'GA-3' },
  { country_code: 'GA', subdivision_name: 'Ngounie', code: 'GA-4' },
  { country_code: 'GA', subdivision_name: 'Ogooue-Ivindo', code: 'GA-6' },
  { country_code: 'GA', subdivision_name: 'Ogooue-Maritime', code: 'GA-8' },
  { country_code: 'GA', subdivision_name: 'Woleu-Ntem', code: 'GA-9' },
  { country_code: 'GB', subdivision_name: 'England', code: 'GB-ENG' },
  { country_code: 'GB', subdivision_name: 'Northern Ireland', code: 'GB-NIR' },
  { country_code: 'GB', subdivision_name: 'Scotland', code: 'GB-SCT' },
  { country_code: 'GB', subdivision_name: 'Wales', code: 'GB-WLS' },
  { country_code: 'GD', subdivision_name: 'Saint Andrew', code: 'GD-01' },
  { country_code: 'GD', subdivision_name: 'Saint David', code: 'GD-02' },
  { country_code: 'GD', subdivision_name: 'Saint George', code: 'GD-03' },
  { country_code: 'GD', subdivision_name: 'Saint John', code: 'GD-04' },
  { country_code: 'GD', subdivision_name: 'Saint Mark', code: 'GD-05' },
  { country_code: 'GD', subdivision_name: 'Saint Patrick', code: 'GD-06' },
  { country_code: 'GD', subdivision_name: 'Southern Grenadine Islands', code: 'GD-10' },
  { country_code: 'GE', subdivision_name: 'Abkhazia', code: 'GE-AB' },
  { country_code: 'GE', subdivision_name: 'Ajaria', code: 'GE-AJ' },
  { country_code: 'GE', subdivision_name: 'Guria', code: 'GE-GU' },
  { country_code: 'GE', subdivision_name: 'Imereti', code: 'GE-IM' },
  { country_code: 'GE', subdivision_name: "K'akheti", code: 'GE-KA' },
  { country_code: 'GE', subdivision_name: 'Kvemo Kartli', code: 'GE-KK' },
  { country_code: 'GE', subdivision_name: 'Mtskheta-Mtianeti', code: 'GE-MM' },
  { country_code: 'GE', subdivision_name: "Rach'a-Lechkhumi-Kvemo Svaneti", code: 'GE-RL' },
  { country_code: 'GE', subdivision_name: 'Samegrelo-Zemo Svaneti', code: 'GE-SZ' },
  { country_code: 'GE', subdivision_name: 'Samtskhe-Javakheti', code: 'GE-SJ' },
  { country_code: 'GE', subdivision_name: 'Shida Kartli', code: 'GE-SK' },
  { country_code: 'GE', subdivision_name: 'Tbilisi', code: 'GE-TB' },
  { country_code: 'GF', subdivision_name: 'Guyane', code: '-' },
  { country_code: 'GG', subdivision_name: 'Guernsey', code: '-' },
  { country_code: 'GH', subdivision_name: 'Ashanti', code: 'GH-AH' },
  { country_code: 'GH', subdivision_name: 'Brong-Ahafo', code: 'GH-BA' },
  { country_code: 'GH', subdivision_name: 'Central', code: 'GH-CP' },
  { country_code: 'GH', subdivision_name: 'Eastern', code: 'GH-EP' },
  { country_code: 'GH', subdivision_name: 'Greater Accra', code: 'GH-AA' },
  { country_code: 'GH', subdivision_name: 'Northern', code: 'GH-NP' },
  { country_code: 'GH', subdivision_name: 'Upper East', code: 'GH-UE' },
  { country_code: 'GH', subdivision_name: 'Volta', code: 'GH-TV' },
  { country_code: 'GH', subdivision_name: 'Western', code: 'GH-WP' },
  { country_code: 'GI', subdivision_name: 'Gibraltar', code: '-' },
  { country_code: 'GL', subdivision_name: 'Avannaata Kommunia', code: 'GL-AV' },
  { country_code: 'GL', subdivision_name: 'Kommune Kujalleq', code: 'GL-KU' },
  { country_code: 'GL', subdivision_name: 'Kommune Qeqertalik', code: 'GL-QT' },
  { country_code: 'GL', subdivision_name: 'Kommuneqarfik Sermersooq', code: 'GL-SM' },
  { country_code: 'GL', subdivision_name: 'Qeqqata Kommunia', code: 'GL-QE' },
  { country_code: 'GM', subdivision_name: 'Banjul', code: 'GM-B' },
  { country_code: 'GM', subdivision_name: 'Central River', code: 'GM-M' },
  { country_code: 'GM', subdivision_name: 'Lower River', code: 'GM-L' },
  { country_code: 'GM', subdivision_name: 'North Bank', code: 'GM-N' },
  { country_code: 'GM', subdivision_name: 'Upper River', code: 'GM-U' },
  { country_code: 'GM', subdivision_name: 'Western', code: 'GM-W' },
  { country_code: 'GN', subdivision_name: 'Boffa', code: 'GN-BF' },
  { country_code: 'GN', subdivision_name: 'Boke', code: 'GN-B' },
  { country_code: 'GN', subdivision_name: 'Conakry', code: 'GN-C' },
  { country_code: 'GN', subdivision_name: 'Coyah', code: 'GN-CO' },
  { country_code: 'GN', subdivision_name: 'Dabola', code: 'GN-DB' },
  { country_code: 'GN', subdivision_name: 'Dalaba', code: 'GN-DL' },
  { country_code: 'GN', subdivision_name: 'Dubreka', code: 'GN-DU' },
  { country_code: 'GN', subdivision_name: 'Kankan', code: 'GN-K' },
  { country_code: 'GN', subdivision_name: 'Kissidougou', code: 'GN-KS' },
  { country_code: 'GN', subdivision_name: 'Kouroussa', code: 'GN-KO' },
  { country_code: 'GN', subdivision_name: 'Labe', code: 'GN-L' },
  { country_code: 'GN', subdivision_name: 'Macenta', code: 'GN-MC' },
  { country_code: 'GN', subdivision_name: 'Nzerekore', code: 'GN-N' },
  { country_code: 'GN', subdivision_name: 'Siguiri', code: 'GN-SI' },
  { country_code: 'GP', subdivision_name: 'Guadeloupe', code: '-' },
  { country_code: 'GQ', subdivision_name: 'Bioko Norte', code: 'GQ-BN' },
  { country_code: 'GQ', subdivision_name: 'Bioko Sur', code: 'GQ-BS' },
  { country_code: 'GQ', subdivision_name: 'Litoral', code: 'GQ-LI' },
  { country_code: 'GQ', subdivision_name: 'Wele-Nzas', code: 'GQ-WN' },
  { country_code: 'GR', subdivision_name: 'Anatoliki Makedonia kai Thraki', code: 'GR-A' },
  { country_code: 'GR', subdivision_name: 'Attiki', code: 'GR-I' },
  { country_code: 'GR', subdivision_name: 'Dytiki Ellada', code: 'GR-G' },
  { country_code: 'GR', subdivision_name: 'Dytiki Makedonia', code: 'GR-C' },
  { country_code: 'GR', subdivision_name: 'Ionia Nisia', code: 'GR-F' },
  { country_code: 'GR', subdivision_name: 'Ipeiros', code: 'GR-D' },
  { country_code: 'GR', subdivision_name: 'Kentriki Makedonia', code: 'GR-B' },
  { country_code: 'GR', subdivision_name: 'Kriti', code: 'GR-M' },
  { country_code: 'GR', subdivision_name: 'Notio Aigaio', code: 'GR-L' },
  { country_code: 'GR', subdivision_name: 'Peloponnisos', code: 'GR-J' },
  { country_code: 'GR', subdivision_name: 'Sterea Ellada', code: 'GR-H' },
  { country_code: 'GR', subdivision_name: 'Thessalia', code: 'GR-E' },
  { country_code: 'GR', subdivision_name: 'Voreio Aigaio', code: 'GR-K' },
  { country_code: 'GS', subdivision_name: 'South Georgia and the South Sandwich Islands', code: '-' },
  { country_code: 'GT', subdivision_name: 'Alta Verapaz', code: 'GT-AV' },
  { country_code: 'GT', subdivision_name: 'Baja Verapaz', code: 'GT-BV' },
  { country_code: 'GT', subdivision_name: 'Chimaltenango', code: 'GT-CM' },
  { country_code: 'GT', subdivision_name: 'Chiquimula', code: 'GT-CQ' },
  { country_code: 'GT', subdivision_name: 'El Progreso', code: 'GT-PR' },
  { country_code: 'GT', subdivision_name: 'Escuintla', code: 'GT-ES' },
  { country_code: 'GT', subdivision_name: 'Guatemala', code: 'GT-GU' },
  { country_code: 'GT', subdivision_name: 'Huehuetenango', code: 'GT-HU' },
  { country_code: 'GT', subdivision_name: 'Izabal', code: 'GT-IZ' },
  { country_code: 'GT', subdivision_name: 'Jalapa', code: 'GT-JA' },
  { country_code: 'GT', subdivision_name: 'Jutiapa', code: 'GT-JU' },
  { country_code: 'GT', subdivision_name: 'Peten', code: 'GT-PE' },
  { country_code: 'GT', subdivision_name: 'Quetzaltenango', code: 'GT-QZ' },
  { country_code: 'GT', subdivision_name: 'Quiche', code: 'GT-QC' },
  { country_code: 'GT', subdivision_name: 'Retalhuleu', code: 'GT-RE' },
  { country_code: 'GT', subdivision_name: 'Sacatepequez', code: 'GT-SA' },
  { country_code: 'GT', subdivision_name: 'San Marcos', code: 'GT-SM' },
  { country_code: 'GT', subdivision_name: 'Santa Rosa', code: 'GT-SR' },
  { country_code: 'GT', subdivision_name: 'Solola', code: 'GT-SO' },
  { country_code: 'GT', subdivision_name: 'Suchitepequez', code: 'GT-SU' },
  { country_code: 'GT', subdivision_name: 'Totonicapan', code: 'GT-TO' },
  { country_code: 'GT', subdivision_name: 'Zacapa', code: 'GT-ZA' },
  { country_code: 'GU', subdivision_name: 'Agat', code: '-' },
  { country_code: 'GU', subdivision_name: 'Barrigada', code: '-' },
  { country_code: 'GU', subdivision_name: 'Chalan Pago-Ordot', code: '-' },
  { country_code: 'GU', subdivision_name: 'Dededo', code: '-' },
  { country_code: 'GU', subdivision_name: 'Hagatna', code: '-' },
  { country_code: 'GU', subdivision_name: 'Mangilao', code: '-' },
  { country_code: 'GU', subdivision_name: 'Mongmong-Toto-Maite', code: '-' },
  { country_code: 'GU', subdivision_name: 'Piti', code: '-' },
  { country_code: 'GU', subdivision_name: 'Santa Rita', code: '-' },
  { country_code: 'GU', subdivision_name: 'Sinajana', code: '-' },
  { country_code: 'GU', subdivision_name: 'Tamuning-Tumon-Harmon', code: '-' },
  { country_code: 'GU', subdivision_name: 'Yigo', code: '-' },
  { country_code: 'GU', subdivision_name: 'Yona', code: '-' },
  { country_code: 'GW', subdivision_name: 'Bissau', code: 'GW-BS' },
  { country_code: 'GW', subdivision_name: 'Gabu', code: 'GW-GA' },
  { country_code: 'GY', subdivision_name: 'Demerara-Mahaica', code: 'GY-DE' },
  { country_code: 'GY', subdivision_name: 'East Berbice-Corentyne', code: 'GY-EB' },
  { country_code: 'GY', subdivision_name: 'Essequibo Islands-West Demerara', code: 'GY-ES' },
  { country_code: 'GY', subdivision_name: 'Upper Demerara-Berbice', code: 'GY-UD' },
  { country_code: 'HK', subdivision_name: 'Hong Kong', code: '-' },
  { country_code: 'HN', subdivision_name: 'Atlantida', code: 'HN-AT' },
  { country_code: 'HN', subdivision_name: 'Choluteca', code: 'HN-CH' },
  { country_code: 'HN', subdivision_name: 'Colon', code: 'HN-CL' },
  { country_code: 'HN', subdivision_name: 'Comayagua', code: 'HN-CM' },
  { country_code: 'HN', subdivision_name: 'Copan', code: 'HN-CP' },
  { country_code: 'HN', subdivision_name: 'Cortes', code: 'HN-CR' },
  { country_code: 'HN', subdivision_name: 'El Paraiso', code: 'HN-EP' },
  { country_code: 'HN', subdivision_name: 'Francisco Morazan', code: 'HN-FM' },
  { country_code: 'HN', subdivision_name: 'Intibuca', code: 'HN-IN' },
  { country_code: 'HN', subdivision_name: 'Islas de la Bahia', code: 'HN-IB' },
  { country_code: 'HN', subdivision_name: 'La Paz', code: 'HN-LP' },
  { country_code: 'HN', subdivision_name: 'Lempira', code: 'HN-LE' },
  { country_code: 'HN', subdivision_name: 'Ocotepeque', code: 'HN-OC' },
  { country_code: 'HN', subdivision_name: 'Olancho', code: 'HN-OL' },
  { country_code: 'HN', subdivision_name: 'Santa Barbara', code: 'HN-SB' },
  { country_code: 'HN', subdivision_name: 'Valle', code: 'HN-VA' },
  { country_code: 'HN', subdivision_name: 'Yoro', code: 'HN-YO' },
  { country_code: 'HR', subdivision_name: 'Bjelovarsko-bilogorska zupanija', code: 'HR-07' },
  { country_code: 'HR', subdivision_name: 'Brodsko-posavska zupanija', code: 'HR-12' },
  { country_code: 'HR', subdivision_name: 'Dubrovacko-neretvanska zupanija', code: 'HR-19' },
  { country_code: 'HR', subdivision_name: 'Grad Zagreb', code: 'HR-21' },
  { country_code: 'HR', subdivision_name: 'Istarska zupanija', code: 'HR-18' },
  { country_code: 'HR', subdivision_name: 'Karlovacka zupanija', code: 'HR-04' },
  { country_code: 'HR', subdivision_name: 'Koprivnicko-krizevacka zupanija', code: 'HR-06' },
  { country_code: 'HR', subdivision_name: 'Krapinsko-zagorska zupanija', code: 'HR-02' },
  { country_code: 'HR', subdivision_name: 'Licko-senjska zupanija', code: 'HR-09' },
  { country_code: 'HR', subdivision_name: 'Medimurska zupanija', code: 'HR-20' },
  { country_code: 'HR', subdivision_name: 'Osjecko-baranjska zupanija', code: 'HR-14' },
  { country_code: 'HR', subdivision_name: 'Pozesko-slavonska zupanija', code: 'HR-11' },
  { country_code: 'HR', subdivision_name: 'Primorsko-goranska zupanija', code: 'HR-08' },
  { country_code: 'HR', subdivision_name: 'Sibensko-kninska zupanija', code: 'HR-15' },
  { country_code: 'HR', subdivision_name: 'Sisacko-moslavacka zupanija', code: 'HR-03' },
  { country_code: 'HR', subdivision_name: 'Splitsko-dalmatinska zupanija', code: 'HR-17' },
  { country_code: 'HR', subdivision_name: 'Varazdinska zupanija', code: 'HR-05' },
  { country_code: 'HR', subdivision_name: 'Viroviticko-podravska zupanija', code: 'HR-10' },
  { country_code: 'HR', subdivision_name: 'Vukovarsko-srijemska zupanija', code: 'HR-16' },
  { country_code: 'HR', subdivision_name: 'Zadarska zupanija', code: 'HR-13' },
  { country_code: 'HR', subdivision_name: 'Zagrebacka zupanija', code: 'HR-01' },
  { country_code: 'HT', subdivision_name: 'Artibonite', code: 'HT-AR' },
  { country_code: 'HT', subdivision_name: 'Centre', code: 'HT-CE' },
  { country_code: 'HT', subdivision_name: "Grande'Anse", code: 'HT-GA' },
  { country_code: 'HT', subdivision_name: 'Nippes', code: 'HT-NI' },
  { country_code: 'HT', subdivision_name: 'Nord', code: 'HT-ND' },
  { country_code: 'HT', subdivision_name: 'Nord-Est', code: 'HT-NE' },
  { country_code: 'HT', subdivision_name: 'Nord-Ouest', code: 'HT-NO' },
  { country_code: 'HT', subdivision_name: 'Ouest', code: 'HT-OU' },
  { country_code: 'HT', subdivision_name: 'Sud', code: 'HT-SD' },
  { country_code: 'HT', subdivision_name: 'Sud-Est', code: 'HT-SE' },
  { country_code: 'HU', subdivision_name: 'Bacs-Kiskun', code: 'HU-BK' },
  { country_code: 'HU', subdivision_name: 'Baranya', code: 'HU-BA' },
  { country_code: 'HU', subdivision_name: 'Bekes', code: 'HU-BE' },
  { country_code: 'HU', subdivision_name: 'Borsod-Abauj-Zemplen', code: 'HU-BZ' },
  { country_code: 'HU', subdivision_name: 'Budapest', code: 'HU-BU' },
  { country_code: 'HU', subdivision_name: 'Csongrad', code: 'HU-CS' },
  { country_code: 'HU', subdivision_name: 'Fejer', code: 'HU-FE' },
  { country_code: 'HU', subdivision_name: 'Gyor-Moson-Sopron', code: 'HU-GS' },
  { country_code: 'HU', subdivision_name: 'Hajdu-Bihar', code: 'HU-HB' },
  { country_code: 'HU', subdivision_name: 'Heves', code: 'HU-HE' },
  { country_code: 'HU', subdivision_name: 'Jasz-Nagykun-Szolnok', code: 'HU-JN' },
  { country_code: 'HU', subdivision_name: 'Komarom-Esztergom', code: 'HU-KE' },
  { country_code: 'HU', subdivision_name: 'Nograd', code: 'HU-NO' },
  { country_code: 'HU', subdivision_name: 'Pest', code: 'HU-PE' },
  { country_code: 'HU', subdivision_name: 'Somogy', code: 'HU-SO' },
  { country_code: 'HU', subdivision_name: 'Szabolcs-Szatmar-Bereg', code: 'HU-SZ' },
  { country_code: 'HU', subdivision_name: 'Tolna', code: 'HU-TO' },
  { country_code: 'HU', subdivision_name: 'Vas', code: 'HU-VA' },
  { country_code: 'HU', subdivision_name: 'Veszprem', code: 'HU-VE' },
  { country_code: 'HU', subdivision_name: 'Zala', code: 'HU-ZA' },
  { country_code: 'ID', subdivision_name: 'Aceh', code: 'ID-AC' },
  { country_code: 'ID', subdivision_name: 'Bali', code: 'ID-BA' },
  { country_code: 'ID', subdivision_name: 'Banten', code: 'ID-BT' },
  { country_code: 'ID', subdivision_name: 'Bengkulu', code: 'ID-BE' },
  { country_code: 'ID', subdivision_name: 'Gorontalo', code: 'ID-GO' },
  { country_code: 'ID', subdivision_name: 'Jakarta Raya', code: 'ID-JK' },
  { country_code: 'ID', subdivision_name: 'Jambi', code: 'ID-JA' },
  { country_code: 'ID', subdivision_name: 'Jawa Barat', code: 'ID-JB' },
  { country_code: 'ID', subdivision_name: 'Jawa Tengah', code: 'ID-JT' },
  { country_code: 'ID', subdivision_name: 'Jawa Timur', code: 'ID-JI' },
  { country_code: 'ID', subdivision_name: 'Kalimantan Barat', code: 'ID-KB' },
  { country_code: 'ID', subdivision_name: 'Kalimantan Selatan', code: 'ID-KS' },
  { country_code: 'ID', subdivision_name: 'Kalimantan Tengah', code: 'ID-KT' },
  { country_code: 'ID', subdivision_name: 'Kalimantan Timur', code: 'ID-KI' },
  { country_code: 'ID', subdivision_name: 'Kalimantan Utara', code: 'ID-KU' },
  { country_code: 'ID', subdivision_name: 'Kepulauan Bangka Belitung', code: 'ID-BB' },
  { country_code: 'ID', subdivision_name: 'Kepulauan Riau', code: 'ID-KR' },
  { country_code: 'ID', subdivision_name: 'Lampung', code: 'ID-LA' },
  { country_code: 'ID', subdivision_name: 'Maluku', code: 'ID-ML' },
  { country_code: 'ID', subdivision_name: 'Maluku Utara', code: 'ID-MU' },
  { country_code: 'ID', subdivision_name: 'Nusa Tenggara Barat', code: 'ID-NB' },
  { country_code: 'ID', subdivision_name: 'Nusa Tenggara Timur', code: 'ID-NT' },
  { country_code: 'ID', subdivision_name: 'Papua', code: 'ID-PP' },
  { country_code: 'ID', subdivision_name: 'Papua Barat', code: 'ID-PB' },
  { country_code: 'ID', subdivision_name: 'Riau', code: 'ID-RI' },
  { country_code: 'ID', subdivision_name: 'Sulawesi Barat', code: 'ID-SR' },
  { country_code: 'ID', subdivision_name: 'Sulawesi Selatan', code: 'ID-SN' },
  { country_code: 'ID', subdivision_name: 'Sulawesi Tengah', code: 'ID-ST' },
  { country_code: 'ID', subdivision_name: 'Sulawesi Tenggara', code: 'ID-SG' },
  { country_code: 'ID', subdivision_name: 'Sulawesi Utara', code: 'ID-SA' },
  { country_code: 'ID', subdivision_name: 'Sumatera Barat', code: 'ID-SB' },
  { country_code: 'ID', subdivision_name: 'Sumatera Selatan', code: 'ID-SS' },
  { country_code: 'ID', subdivision_name: 'Sumatera Utara', code: 'ID-SU' },
  { country_code: 'ID', subdivision_name: 'Yogyakarta', code: 'ID-YO' },
  { country_code: 'IE', subdivision_name: 'Carlow', code: 'IE-CW' },
  { country_code: 'IE', subdivision_name: 'Cavan', code: 'IE-CN' },
  { country_code: 'IE', subdivision_name: 'Clare', code: 'IE-CE' },
  { country_code: 'IE', subdivision_name: 'Cork', code: 'IE-CO' },
  { country_code: 'IE', subdivision_name: 'Donegal', code: 'IE-DL' },
  { country_code: 'IE', subdivision_name: 'Dublin', code: 'IE-D' },
  { country_code: 'IE', subdivision_name: 'Galway', code: 'IE-G' },
  { country_code: 'IE', subdivision_name: 'Kerry', code: 'IE-KY' },
  { country_code: 'IE', subdivision_name: 'Kildare', code: 'IE-KE' },
  { country_code: 'IE', subdivision_name: 'Kilkenny', code: 'IE-KK' },
  { country_code: 'IE', subdivision_name: 'Laois', code: 'IE-LS' },
  { country_code: 'IE', subdivision_name: 'Leitrim', code: 'IE-LM' },
  { country_code: 'IE', subdivision_name: 'Limerick', code: 'IE-LK' },
  { country_code: 'IE', subdivision_name: 'Longford', code: 'IE-LD' },
  { country_code: 'IE', subdivision_name: 'Louth', code: 'IE-LH' },
  { country_code: 'IE', subdivision_name: 'Mayo', code: 'IE-MO' },
  { country_code: 'IE', subdivision_name: 'Meath', code: 'IE-MH' },
  { country_code: 'IE', subdivision_name: 'Monaghan', code: 'IE-MN' },
  { country_code: 'IE', subdivision_name: 'Offaly', code: 'IE-OY' },
  { country_code: 'IE', subdivision_name: 'Roscommon', code: 'IE-RN' },
  { country_code: 'IE', subdivision_name: 'Sligo', code: 'IE-SO' },
  { country_code: 'IE', subdivision_name: 'Tipperary', code: 'IE-TA' },
  { country_code: 'IE', subdivision_name: 'Waterford', code: 'IE-WD' },
  { country_code: 'IE', subdivision_name: 'Westmeath', code: 'IE-WH' },
  { country_code: 'IE', subdivision_name: 'Wexford', code: 'IE-WX' },
  { country_code: 'IE', subdivision_name: 'Wicklow', code: 'IE-WW' },
  { country_code: 'IL', subdivision_name: 'HaDarom', code: 'IL-D' },
  { country_code: 'IL', subdivision_name: 'HaMerkaz', code: 'IL-M' },
  { country_code: 'IL', subdivision_name: 'HaTsafon', code: 'IL-Z' },
  { country_code: 'IL', subdivision_name: 'Hefa', code: 'IL-HA' },
  { country_code: 'IL', subdivision_name: 'Tel Aviv', code: 'IL-TA' },
  { country_code: 'IL', subdivision_name: 'Yerushalayim', code: 'IL-JM' },
  { country_code: 'IM', subdivision_name: 'Isle of Man', code: '-' },
  { country_code: 'IN', subdivision_name: 'Andaman and Nicobar Islands', code: 'IN-AN' },
  { country_code: 'IN', subdivision_name: 'Andhra Pradesh', code: 'IN-AP' },
  { country_code: 'IN', subdivision_name: 'Arunachal Pradesh', code: 'IN-AR' },
  { country_code: 'IN', subdivision_name: 'Assam', code: 'IN-AS' },
  { country_code: 'IN', subdivision_name: 'Bihar', code: 'IN-BR' },
  { country_code: 'IN', subdivision_name: 'Chandigarh', code: 'IN-CH' },
  { country_code: 'IN', subdivision_name: 'Chhattisgarh', code: 'IN-CT' },
  { country_code: 'IN', subdivision_name: 'Dadra and Nagar Haveli', code: 'IN-DN' },
  { country_code: 'IN', subdivision_name: 'Daman and Diu', code: 'IN-DD' },
  { country_code: 'IN', subdivision_name: 'Delhi', code: 'IN-DL' },
  { country_code: 'IN', subdivision_name: 'Goa', code: 'IN-GA' },
  { country_code: 'IN', subdivision_name: 'Gujarat', code: 'IN-GJ' },
  { country_code: 'IN', subdivision_name: 'Haryana', code: 'IN-HR' },
  { country_code: 'IN', subdivision_name: 'Himachal Pradesh', code: 'IN-HP' },
  { country_code: 'IN', subdivision_name: 'Jammu and Kashmir', code: 'IN-JK' },
  { country_code: 'IN', subdivision_name: 'Jharkhand', code: 'IN-JH' },
  { country_code: 'IN', subdivision_name: 'Karnataka', code: 'IN-KA' },
  { country_code: 'IN', subdivision_name: 'Kerala', code: 'IN-KL' },
  { country_code: 'IN', subdivision_name: 'Madhya Pradesh', code: 'IN-MP' },
  { country_code: 'IN', subdivision_name: 'Maharashtra', code: 'IN-MH' },
  { country_code: 'IN', subdivision_name: 'Manipur', code: 'IN-MN' },
  { country_code: 'IN', subdivision_name: 'Meghalaya', code: 'IN-ML' },
  { country_code: 'IN', subdivision_name: 'Mizoram', code: 'IN-MZ' },
  { country_code: 'IN', subdivision_name: 'Nagaland', code: 'IN-NL' },
  { country_code: 'IN', subdivision_name: 'Odisha', code: 'IN-OR' },
  { country_code: 'IN', subdivision_name: 'Puducherry', code: 'IN-PY' },
  { country_code: 'IN', subdivision_name: 'Punjab', code: 'IN-PB' },
  { country_code: 'IN', subdivision_name: 'Rajasthan', code: 'IN-RJ' },
  { country_code: 'IN', subdivision_name: 'Sikkim', code: 'IN-SK' },
  { country_code: 'IN', subdivision_name: 'Tamil Nadu', code: 'IN-TN' },
  { country_code: 'IN', subdivision_name: 'Telangana', code: 'IN-TG' },
  { country_code: 'IN', subdivision_name: 'Tripura', code: 'IN-TR' },
  { country_code: 'IN', subdivision_name: 'Uttar Pradesh', code: 'IN-UP' },
  { country_code: 'IN', subdivision_name: 'Uttarakhand', code: 'IN-UT' },
  { country_code: 'IN', subdivision_name: 'West Bengal', code: 'IN-WB' },
  { country_code: 'IO', subdivision_name: 'British Indian Ocean Territory', code: '-' },
  { country_code: 'IQ', subdivision_name: 'Al Anbar', code: 'IQ-AN' },
  { country_code: 'IQ', subdivision_name: 'Al Basrah', code: 'IQ-BA' },
  { country_code: 'IQ', subdivision_name: 'Al Muthanna', code: 'IQ-MU' },
  { country_code: 'IQ', subdivision_name: 'Al Qadisiyah', code: 'IQ-QA' },
  { country_code: 'IQ', subdivision_name: 'An Najaf', code: 'IQ-NA' },
  { country_code: 'IQ', subdivision_name: 'Arbil', code: 'IQ-AR' },
  { country_code: 'IQ', subdivision_name: 'As Sulaymaniyah', code: 'IQ-SU' },
  { country_code: 'IQ', subdivision_name: 'Babil', code: 'IQ-BB' },
  { country_code: 'IQ', subdivision_name: 'Baghdad', code: 'IQ-BG' },
  { country_code: 'IQ', subdivision_name: 'Dahuk', code: 'IQ-DA' },
  { country_code: 'IQ', subdivision_name: 'Dhi Qar', code: 'IQ-DQ' },
  { country_code: 'IQ', subdivision_name: 'Diyala', code: 'IQ-DI' },
  { country_code: 'IQ', subdivision_name: "Karbala'", code: 'IQ-KA' },
  { country_code: 'IQ', subdivision_name: 'Kirkuk', code: 'IQ-KI' },
  { country_code: 'IQ', subdivision_name: 'Maysan', code: 'IQ-MA' },
  { country_code: 'IQ', subdivision_name: 'Ninawa', code: 'IQ-NI' },
  { country_code: 'IQ', subdivision_name: 'Salah ad Din', code: 'IQ-SD' },
  { country_code: 'IQ', subdivision_name: 'Wasit', code: 'IQ-WA' },
  { country_code: 'IR', subdivision_name: 'Alborz', code: 'IR-32' },
  { country_code: 'IR', subdivision_name: 'Ardabil', code: 'IR-03' },
  { country_code: 'IR', subdivision_name: 'Azarbayjan-e Gharbi', code: 'IR-02' },
  { country_code: 'IR', subdivision_name: 'Azarbayjan-e Sharqi', code: 'IR-01' },
  { country_code: 'IR', subdivision_name: 'Bushehr', code: 'IR-06' },
  { country_code: 'IR', subdivision_name: 'Chahar Mahal va Bakhtiari', code: 'IR-08' },
  { country_code: 'IR', subdivision_name: 'Esfahan', code: 'IR-04' },
  { country_code: 'IR', subdivision_name: 'Fars', code: 'IR-14' },
  { country_code: 'IR', subdivision_name: 'Gilan', code: 'IR-19' },
  { country_code: 'IR', subdivision_name: 'Golestan', code: 'IR-27' },
  { country_code: 'IR', subdivision_name: 'Hamadan', code: 'IR-24' },
  { country_code: 'IR', subdivision_name: 'Hormozgan', code: 'IR-23' },
  { country_code: 'IR', subdivision_name: 'Ilam', code: 'IR-05' },
  { country_code: 'IR', subdivision_name: 'Kerman', code: 'IR-15' },
  { country_code: 'IR', subdivision_name: 'Kermanshah', code: 'IR-17' },
  { country_code: 'IR', subdivision_name: 'Khorasan-e Jonubi', code: 'IR-29' },
  { country_code: 'IR', subdivision_name: 'Khorasan-e Razavi', code: 'IR-30' },
  { country_code: 'IR', subdivision_name: 'Khorasan-e Shomali', code: 'IR-31' },
  { country_code: 'IR', subdivision_name: 'Khuzestan', code: 'IR-10' },
  { country_code: 'IR', subdivision_name: 'Kohgiluyeh va Bowyer Ahmad', code: 'IR-18' },
  { country_code: 'IR', subdivision_name: 'Kordestan', code: 'IR-16' },
  { country_code: 'IR', subdivision_name: 'Lorestan', code: 'IR-20' },
  { country_code: 'IR', subdivision_name: 'Markazi', code: 'IR-22' },
  { country_code: 'IR', subdivision_name: 'Mazandaran', code: 'IR-21' },
  { country_code: 'IR', subdivision_name: 'Qazvin', code: 'IR-28' },
  { country_code: 'IR', subdivision_name: 'Qom', code: 'IR-26' },
  { country_code: 'IR', subdivision_name: 'Semnan', code: 'IR-12' },
  { country_code: 'IR', subdivision_name: 'Sistan va Baluchestan', code: 'IR-13' },
  { country_code: 'IR', subdivision_name: 'Tehran', code: 'IR-07' },
  { country_code: 'IR', subdivision_name: 'Yazd', code: 'IR-25' },
  { country_code: 'IR', subdivision_name: 'Zanjan', code: 'IR-11' },
  { country_code: 'IS', subdivision_name: 'Austurland', code: 'IS-7' },
  { country_code: 'IS', subdivision_name: 'Hofudborgarsvaedi', code: 'IS-1' },
  { country_code: 'IS', subdivision_name: 'Nordurland eystra', code: 'IS-6' },
  { country_code: 'IS', subdivision_name: 'Nordurland vestra', code: 'IS-5' },
  { country_code: 'IS', subdivision_name: 'Sudurland', code: 'IS-8' },
  { country_code: 'IS', subdivision_name: 'Sudurnes', code: 'IS-2' },
  { country_code: 'IS', subdivision_name: 'Vestfirdir', code: 'IS-4' },
  { country_code: 'IS', subdivision_name: 'Vesturland', code: 'IS-3' },
  { country_code: 'IT', subdivision_name: 'Abruzzo', code: 'IT-65' },
  { country_code: 'IT', subdivision_name: 'Basilicata', code: 'IT-77' },
  { country_code: 'IT', subdivision_name: 'Calabria', code: 'IT-78' },
  { country_code: 'IT', subdivision_name: 'Campania', code: 'IT-72' },
  { country_code: 'IT', subdivision_name: 'Emilia-Romagna', code: 'IT-45' },
  { country_code: 'IT', subdivision_name: 'Friuli-Venezia Giulia', code: 'IT-36' },
  { country_code: 'IT', subdivision_name: 'Lazio', code: 'IT-62' },
  { country_code: 'IT', subdivision_name: 'Liguria', code: 'IT-42' },
  { country_code: 'IT', subdivision_name: 'Lombardia', code: 'IT-25' },
  { country_code: 'IT', subdivision_name: 'Marche', code: 'IT-57' },
  { country_code: 'IT', subdivision_name: 'Molise', code: 'IT-67' },
  { country_code: 'IT', subdivision_name: 'Piemonte', code: 'IT-21' },
  { country_code: 'IT', subdivision_name: 'Puglia', code: 'IT-75' },
  { country_code: 'IT', subdivision_name: 'Sardegna', code: 'IT-88' },
  { country_code: 'IT', subdivision_name: 'Sicilia', code: 'IT-82' },
  { country_code: 'IT', subdivision_name: 'Toscana', code: 'IT-52' },
  { country_code: 'IT', subdivision_name: 'Trentino-Alto Adige', code: 'IT-32' },
  { country_code: 'IT', subdivision_name: 'Umbria', code: 'IT-55' },
  { country_code: 'IT', subdivision_name: "Valle d'Aosta", code: 'IT-23' },
  { country_code: 'IT', subdivision_name: 'Veneto', code: 'IT-34' },
  { country_code: 'JE', subdivision_name: 'Jersey', code: '-' },
  { country_code: 'JM', subdivision_name: 'Clarendon', code: 'JM-13' },
  { country_code: 'JM', subdivision_name: 'Hanover', code: 'JM-09' },
  { country_code: 'JM', subdivision_name: 'Kingston', code: 'JM-01' },
  { country_code: 'JM', subdivision_name: 'Manchester', code: 'JM-12' },
  { country_code: 'JM', subdivision_name: 'Portland', code: 'JM-04' },
  { country_code: 'JM', subdivision_name: 'Saint Andrew', code: 'JM-02' },
  { country_code: 'JM', subdivision_name: 'Saint Ann', code: 'JM-06' },
  { country_code: 'JM', subdivision_name: 'Saint Catherine', code: 'JM-14' },
  { country_code: 'JM', subdivision_name: 'Saint Elizabeth', code: 'JM-11' },
  { country_code: 'JM', subdivision_name: 'Saint James', code: 'JM-08' },
  { country_code: 'JM', subdivision_name: 'Saint Mary', code: 'JM-05' },
  { country_code: 'JM', subdivision_name: 'Saint Thomas', code: 'JM-03' },
  { country_code: 'JM', subdivision_name: 'Trelawny', code: 'JM-07' },
  { country_code: 'JM', subdivision_name: 'Westmoreland', code: 'JM-10' },
  { country_code: 'JO', subdivision_name: "'Ajlun", code: 'JO-AJ' },
  { country_code: 'JO', subdivision_name: "Al 'Aqabah", code: 'JO-AQ' },
  { country_code: 'JO', subdivision_name: "Al 'Asimah", code: 'JO-AM' },
  { country_code: 'JO', subdivision_name: "Al Balqa'", code: 'JO-BA' },
  { country_code: 'JO', subdivision_name: 'Al Karak', code: 'JO-KA' },
  { country_code: 'JO', subdivision_name: 'Al Mafraq', code: 'JO-MA' },
  { country_code: 'JO', subdivision_name: 'At Tafilah', code: 'JO-AT' },
  { country_code: 'JO', subdivision_name: "Az Zarqa'", code: 'JO-AZ' },
  { country_code: 'JO', subdivision_name: 'Irbid', code: 'JO-IR' },
  { country_code: 'JO', subdivision_name: 'Jarash', code: 'JO-JA' },
  { country_code: 'JO', subdivision_name: "Ma'an", code: 'JO-MN' },
  { country_code: 'JO', subdivision_name: 'Madaba', code: 'JO-MD' },
  { country_code: 'JP', subdivision_name: 'Aichi', code: 'JP-23' },
  { country_code: 'JP', subdivision_name: 'Akita', code: 'JP-05' },
  { country_code: 'JP', subdivision_name: 'Aomori', code: 'JP-02' },
  { country_code: 'JP', subdivision_name: 'Chiba', code: 'JP-12' },
  { country_code: 'JP', subdivision_name: 'Ehime', code: 'JP-38' },
  { country_code: 'JP', subdivision_name: 'Fukui', code: 'JP-18' },
  { country_code: 'JP', subdivision_name: 'Fukuoka', code: 'JP-40' },
  { country_code: 'JP', subdivision_name: 'Fukushima', code: 'JP-07' },
  { country_code: 'JP', subdivision_name: 'Gifu', code: 'JP-21' },
  { country_code: 'JP', subdivision_name: 'Gunma', code: 'JP-10' },
  { country_code: 'JP', subdivision_name: 'Hiroshima', code: 'JP-34' },
  { country_code: 'JP', subdivision_name: 'Hokkaido', code: 'JP-01' },
  { country_code: 'JP', subdivision_name: 'Hyogo', code: 'JP-28' },
  { country_code: 'JP', subdivision_name: 'Ibaraki', code: 'JP-08' },
  { country_code: 'JP', subdivision_name: 'Ishikawa', code: 'JP-17' },
  { country_code: 'JP', subdivision_name: 'Iwate', code: 'JP-03' },
  { country_code: 'JP', subdivision_name: 'Kagawa', code: 'JP-37' },
  { country_code: 'JP', subdivision_name: 'Kagoshima', code: 'JP-46' },
  { country_code: 'JP', subdivision_name: 'Kanagawa', code: 'JP-14' },
  { country_code: 'JP', subdivision_name: 'Kochi', code: 'JP-39' },
  { country_code: 'JP', subdivision_name: 'Kumamoto', code: 'JP-43' },
  { country_code: 'JP', subdivision_name: 'Kyoto', code: 'JP-26' },
  { country_code: 'JP', subdivision_name: 'Mie', code: 'JP-24' },
  { country_code: 'JP', subdivision_name: 'Miyagi', code: 'JP-04' },
  { country_code: 'JP', subdivision_name: 'Miyazaki', code: 'JP-45' },
  { country_code: 'JP', subdivision_name: 'Nagano', code: 'JP-20' },
  { country_code: 'JP', subdivision_name: 'Nagasaki', code: 'JP-42' },
  { country_code: 'JP', subdivision_name: 'Nara', code: 'JP-29' },
  { country_code: 'JP', subdivision_name: 'Niigata', code: 'JP-15' },
  { country_code: 'JP', subdivision_name: 'Oita', code: 'JP-44' },
  { country_code: 'JP', subdivision_name: 'Okayama', code: 'JP-33' },
  { country_code: 'JP', subdivision_name: 'Okinawa', code: 'JP-47' },
  { country_code: 'JP', subdivision_name: 'Osaka', code: 'JP-27' },
  { country_code: 'JP', subdivision_name: 'Saga', code: 'JP-41' },
  { country_code: 'JP', subdivision_name: 'Saitama', code: 'JP-11' },
  { country_code: 'JP', subdivision_name: 'Shiga', code: 'JP-25' },
  { country_code: 'JP', subdivision_name: 'Shimane', code: 'JP-32' },
  { country_code: 'JP', subdivision_name: 'Shizuoka', code: 'JP-22' },
  { country_code: 'JP', subdivision_name: 'Tochigi', code: 'JP-09' },
  { country_code: 'JP', subdivision_name: 'Tokushima', code: 'JP-36' },
  { country_code: 'JP', subdivision_name: 'Tokyo', code: 'JP-13' },
  { country_code: 'JP', subdivision_name: 'Tottori', code: 'JP-31' },
  { country_code: 'JP', subdivision_name: 'Toyama', code: 'JP-16' },
  { country_code: 'JP', subdivision_name: 'Wakayama', code: 'JP-30' },
  { country_code: 'JP', subdivision_name: 'Yamagata', code: 'JP-06' },
  { country_code: 'JP', subdivision_name: 'Yamaguchi', code: 'JP-35' },
  { country_code: 'JP', subdivision_name: 'Yamanashi', code: 'JP-19' },
  { country_code: 'KE', subdivision_name: 'Baringo', code: 'KE-01' },
  { country_code: 'KE', subdivision_name: 'Bomet', code: 'KE-02' },
  { country_code: 'KE', subdivision_name: 'Bungoma', code: 'KE-03' },
  { country_code: 'KE', subdivision_name: 'Busia', code: 'KE-04' },
  { country_code: 'KE', subdivision_name: 'Elgeyo/Marakwet', code: 'KE-05' },
  { country_code: 'KE', subdivision_name: 'Embu', code: 'KE-06' },
  { country_code: 'KE', subdivision_name: 'Garissa', code: 'KE-07' },
  { country_code: 'KE', subdivision_name: 'Homa Bay', code: 'KE-08' },
  { country_code: 'KE', subdivision_name: 'Isiolo', code: 'KE-09' },
  { country_code: 'KE', subdivision_name: 'Kajiado', code: 'KE-10' },
  { country_code: 'KE', subdivision_name: 'Kakamega', code: 'KE-11' },
  { country_code: 'KE', subdivision_name: 'Kericho', code: 'KE-12' },
  { country_code: 'KE', subdivision_name: 'Kiambu', code: 'KE-13' },
  { country_code: 'KE', subdivision_name: 'Kilifi', code: 'KE-14' },
  { country_code: 'KE', subdivision_name: 'Kirinyaga', code: 'KE-15' },
  { country_code: 'KE', subdivision_name: 'Kisii', code: 'KE-16' },
  { country_code: 'KE', subdivision_name: 'Kisumu', code: 'KE-17' },
  { country_code: 'KE', subdivision_name: 'Kitui', code: 'KE-18' },
  { country_code: 'KE', subdivision_name: 'Kwale', code: 'KE-19' },
  { country_code: 'KE', subdivision_name: 'Laikipia', code: 'KE-20' },
  { country_code: 'KE', subdivision_name: 'Lamu', code: 'KE-21' },
  { country_code: 'KE', subdivision_name: 'Machakos', code: 'KE-22' },
  { country_code: 'KE', subdivision_name: 'Makueni', code: 'KE-23' },
  { country_code: 'KE', subdivision_name: 'Mandera', code: 'KE-24' },
  { country_code: 'KE', subdivision_name: 'Marsabit', code: 'KE-25' },
  { country_code: 'KE', subdivision_name: 'Meru', code: 'KE-26' },
  { country_code: 'KE', subdivision_name: 'Migori', code: 'KE-27' },
  { country_code: 'KE', subdivision_name: 'Mombasa', code: 'KE-28' },
  { country_code: 'KE', subdivision_name: "Murang'a", code: 'KE-29' },
  { country_code: 'KE', subdivision_name: 'Nairobi City', code: 'KE-30' },
  { country_code: 'KE', subdivision_name: 'Nakuru', code: 'KE-31' },
  { country_code: 'KE', subdivision_name: 'Nandi', code: 'KE-32' },
  { country_code: 'KE', subdivision_name: 'Narok', code: 'KE-33' },
  { country_code: 'KE', subdivision_name: 'Nyamira', code: 'KE-34' },
  { country_code: 'KE', subdivision_name: 'Nyandarua', code: 'KE-35' },
  { country_code: 'KE', subdivision_name: 'Nyeri', code: 'KE-36' },
  { country_code: 'KE', subdivision_name: 'Siaya', code: 'KE-38' },
  { country_code: 'KE', subdivision_name: 'Taita/Taveta', code: 'KE-39' },
  { country_code: 'KE', subdivision_name: 'Tharaka-Nithi', code: 'KE-41' },
  { country_code: 'KE', subdivision_name: 'Trans Nzoia', code: 'KE-42' },
  { country_code: 'KE', subdivision_name: 'Turkana', code: 'KE-43' },
  { country_code: 'KE', subdivision_name: 'Uasin Gishu', code: 'KE-44' },
  { country_code: 'KE', subdivision_name: 'Wajir', code: 'KE-46' },
  { country_code: 'KG', subdivision_name: 'Batken', code: 'KG-B' },
  { country_code: 'KG', subdivision_name: 'Bishkek', code: 'KG-GB' },
  { country_code: 'KG', subdivision_name: 'Chuy', code: 'KG-C' },
  { country_code: 'KG', subdivision_name: 'Jalal-Abad', code: 'KG-J' },
  { country_code: 'KG', subdivision_name: 'Naryn', code: 'KG-N' },
  { country_code: 'KG', subdivision_name: 'Osh', code: 'KG-GO' },
  { country_code: 'KG', subdivision_name: 'Talas', code: 'KG-T' },
  { country_code: 'KG', subdivision_name: 'Ysyk-Kol', code: 'KG-Y' },
  { country_code: 'KH', subdivision_name: 'Baat Dambang', code: 'KH-2' },
  { country_code: 'KH', subdivision_name: 'Banteay Mean Chey', code: 'KH-1' },
  { country_code: 'KH', subdivision_name: 'Kampong Chaam', code: 'KH-3' },
  { country_code: 'KH', subdivision_name: 'Kampong Chhnang', code: 'KH-4' },
  { country_code: 'KH', subdivision_name: 'Kampong Spueu', code: 'KH-5' },
  { country_code: 'KH', subdivision_name: 'Kampong Thum', code: 'KH-6' },
  { country_code: 'KH', subdivision_name: 'Kampot', code: 'KH-7' },
  { country_code: 'KH', subdivision_name: 'Kandaal', code: 'KH-8' },
  { country_code: 'KH', subdivision_name: 'Kaoh Kong', code: 'KH-9' },
  { country_code: 'KH', subdivision_name: 'Kracheh', code: 'KH-10' },
  { country_code: 'KH', subdivision_name: 'Krong Kaeb', code: 'KH-23' },
  { country_code: 'KH', subdivision_name: 'Krong Pailin', code: 'KH-24' },
  { country_code: 'KH', subdivision_name: 'Krong Preah Sihanouk', code: 'KH-18' },
  { country_code: 'KH', subdivision_name: 'Mondol Kiri', code: 'KH-11' },
  { country_code: 'KH', subdivision_name: 'Phnom Penh', code: 'KH-12' },
  { country_code: 'KH', subdivision_name: 'Pousaat', code: 'KH-15' },
  { country_code: 'KH', subdivision_name: 'Prey Veaeng', code: 'KH-14' },
  { country_code: 'KH', subdivision_name: 'Rotanak Kiri', code: 'KH-16' },
  { country_code: 'KH', subdivision_name: 'Siem Reab', code: 'KH-17' },
  { country_code: 'KH', subdivision_name: 'Svaay Rieng', code: 'KH-20' },
  { country_code: 'KH', subdivision_name: 'Taakaev', code: 'KH-21' },
  { country_code: 'KI', subdivision_name: 'Gilbert Islands', code: 'KI-G' },
  { country_code: 'KI', subdivision_name: 'Line Islands', code: 'KI-L' },
  { country_code: 'KM', subdivision_name: 'Grande Comore', code: 'KM-G' },
  { country_code: 'KN', subdivision_name: 'Saint Anne Sandy Point', code: 'KN-02' },
  { country_code: 'KN', subdivision_name: 'Saint George Basseterre', code: 'KN-03' },
  { country_code: 'KN', subdivision_name: 'Saint James Windward', code: 'KN-05' },
  { country_code: 'KN', subdivision_name: 'Saint John Capisterre', code: 'KN-06' },
  { country_code: 'KN', subdivision_name: 'Saint John Figtree', code: 'KN-07' },
  { country_code: 'KN', subdivision_name: 'Saint Mary Cayon', code: 'KN-08' },
  { country_code: 'KN', subdivision_name: 'Saint Paul Capisterre', code: 'KN-09' },
  { country_code: 'KN', subdivision_name: 'Saint Paul Charlestown', code: 'KN-10' },
  { country_code: 'KN', subdivision_name: 'Saint Peter Basseterre', code: 'KN-11' },
  { country_code: 'KN', subdivision_name: 'Saint Thomas Lowland', code: 'KN-12' },
  { country_code: 'KN', subdivision_name: 'Saint Thomas Middle Island', code: 'KN-13' },
  { country_code: 'KP', subdivision_name: "P'yongyang", code: 'KP-01' },
  { country_code: 'KR', subdivision_name: 'Busan-gwangyeoksi', code: 'KR-26' },
  { country_code: 'KR', subdivision_name: 'Chungcheongbuk-do', code: 'KR-43' },
  { country_code: 'KR', subdivision_name: 'Chungcheongnam-do', code: 'KR-44' },
  { country_code: 'KR', subdivision_name: 'Daegu-gwangyeoksi', code: 'KR-27' },
  { country_code: 'KR', subdivision_name: 'Daejeon-gwangyeoksi', code: 'KR-30' },
  { country_code: 'KR', subdivision_name: 'Gangwon-do', code: 'KR-42' },
  { country_code: 'KR', subdivision_name: 'Gwangju-gwangyeoksi', code: 'KR-29' },
  { country_code: 'KR', subdivision_name: 'Gyeonggi-do', code: 'KR-41' },
  { country_code: 'KR', subdivision_name: 'Gyeongsangbuk-do', code: 'KR-47' },
  { country_code: 'KR', subdivision_name: 'Gyeongsangnam-do', code: 'KR-48' },
  { country_code: 'KR', subdivision_name: 'Incheon-gwangyeoksi', code: 'KR-28' },
  { country_code: 'KR', subdivision_name: 'Jeju-teukbyeoljachido', code: 'KR-49' },
  { country_code: 'KR', subdivision_name: 'Jeollabuk-do', code: 'KR-45' },
  { country_code: 'KR', subdivision_name: 'Jeollanam-do', code: 'KR-46' },
  { country_code: 'KR', subdivision_name: 'Seoul-teukbyeolsi', code: 'KR-11' },
  { country_code: 'KR', subdivision_name: 'Ulsan-gwangyeoksi', code: 'KR-31' },
  { country_code: 'KW', subdivision_name: "Al 'Asimah", code: 'KW-KU' },
  { country_code: 'KW', subdivision_name: 'Al Ahmadi', code: 'KW-AH' },
  { country_code: 'KW', subdivision_name: 'Al Farwaniyah', code: 'KW-FA' },
  { country_code: 'KW', subdivision_name: "Al Jahra'", code: 'KW-JA' },
  { country_code: 'KW', subdivision_name: 'Hawalli', code: 'KW-HA' },
  { country_code: 'KW', subdivision_name: 'Mubarak al Kabir', code: 'KW-MU' },
  { country_code: 'KY', subdivision_name: 'Cayman Islands', code: '-' },
  { country_code: 'KZ', subdivision_name: 'Almaty', code: 'KZ-ALA' },
  { country_code: 'KZ', subdivision_name: 'Almaty oblysy', code: 'KZ-ALM' },
  { country_code: 'KZ', subdivision_name: 'Aqmola oblysy', code: 'KZ-AKM' },
  { country_code: 'KZ', subdivision_name: 'Aqtobe oblysy', code: 'KZ-AKT' },
  { country_code: 'KZ', subdivision_name: 'Astana', code: 'KZ-AST' },
  { country_code: 'KZ', subdivision_name: 'Atyrau oblysy', code: 'KZ-ATY' },
  { country_code: 'KZ', subdivision_name: 'Batys Qazaqstan oblysy', code: 'KZ-ZAP' },
  { country_code: 'KZ', subdivision_name: 'Bayqongyr', code: 'KZ-BAY' },
  { country_code: 'KZ', subdivision_name: 'Mangghystau oblysy', code: 'KZ-MAN' },
  { country_code: 'KZ', subdivision_name: 'Ongtustik Qazaqstan oblysy', code: 'KZ-YUZ' },
  { country_code: 'KZ', subdivision_name: 'Pavlodar oblysy', code: 'KZ-PAV' },
  { country_code: 'KZ', subdivision_name: 'Qaraghandy oblysy', code: 'KZ-KAR' },
  { country_code: 'KZ', subdivision_name: 'Qostanay oblysy', code: 'KZ-KUS' },
  { country_code: 'KZ', subdivision_name: 'Qyzylorda oblysy', code: 'KZ-KZY' },
  { country_code: 'KZ', subdivision_name: 'Shyghys Qazaqstan oblysy', code: 'KZ-VOS' },
  { country_code: 'KZ', subdivision_name: 'Soltustik Qazaqstan oblysy', code: 'KZ-SEV' },
  { country_code: 'KZ', subdivision_name: 'Zhambyl oblysy', code: 'KZ-ZHA' },
  { country_code: 'LA', subdivision_name: 'Champasak', code: 'LA-CH' },
  { country_code: 'LA', subdivision_name: 'Houaphan', code: 'LA-HO' },
  { country_code: 'LA', subdivision_name: 'Khammouan', code: 'LA-KH' },
  { country_code: 'LA', subdivision_name: 'Louang Namtha', code: 'LA-LM' },
  { country_code: 'LA', subdivision_name: 'Louangphabang', code: 'LA-LP' },
  { country_code: 'LA', subdivision_name: 'Oudomxai', code: 'LA-OU' },
  { country_code: 'LA', subdivision_name: 'Savannakhet', code: 'LA-SV' },
  { country_code: 'LA', subdivision_name: 'Viangchan', code: 'LA-VI' },
  { country_code: 'LA', subdivision_name: 'Xaignabouli', code: 'LA-XA' },
  { country_code: 'LA', subdivision_name: 'Xekong', code: 'LA-XE' },
  { country_code: 'LB', subdivision_name: 'Aakkar', code: 'LB-AK' },
  { country_code: 'LB', subdivision_name: 'Baalbek-Hermel', code: 'LB-BH' },
  { country_code: 'LB', subdivision_name: 'Beqaa', code: 'LB-BI' },
  { country_code: 'LB', subdivision_name: 'Beyrouth', code: 'LB-BA' },
  { country_code: 'LB', subdivision_name: 'Liban-Nord', code: 'LB-AS' },
  { country_code: 'LB', subdivision_name: 'Liban-Sud', code: 'LB-JA' },
  { country_code: 'LB', subdivision_name: 'Mont-Liban', code: 'LB-JL' },
  { country_code: 'LB', subdivision_name: 'Nabatiye', code: 'LB-NA' },
  { country_code: 'LC', subdivision_name: 'Anse la Raye', code: 'LC-01' },
  { country_code: 'LC', subdivision_name: 'Castries', code: 'LC-02' },
  { country_code: 'LC', subdivision_name: 'Choiseul', code: 'LC-03' },
  { country_code: 'LC', subdivision_name: 'Dennery', code: 'LC-05' },
  { country_code: 'LC', subdivision_name: 'Gros Islet', code: 'LC-06' },
  { country_code: 'LC', subdivision_name: 'Laborie', code: 'LC-07' },
  { country_code: 'LC', subdivision_name: 'Micoud', code: 'LC-08' },
  { country_code: 'LC', subdivision_name: 'Soufriere', code: 'LC-10' },
  { country_code: 'LC', subdivision_name: 'Vieux Fort', code: 'LC-11' },
  { country_code: 'LI', subdivision_name: 'Balzers', code: 'LI-01' },
  { country_code: 'LI', subdivision_name: 'Eschen', code: 'LI-02' },
  { country_code: 'LI', subdivision_name: 'Gamprin', code: 'LI-03' },
  { country_code: 'LI', subdivision_name: 'Mauren', code: 'LI-04' },
  { country_code: 'LI', subdivision_name: 'Planken', code: 'LI-05' },
  { country_code: 'LI', subdivision_name: 'Ruggell', code: 'LI-06' },
  { country_code: 'LI', subdivision_name: 'Schaan', code: 'LI-07' },
  { country_code: 'LI', subdivision_name: 'Schellenberg', code: 'LI-08' },
  { country_code: 'LI', subdivision_name: 'Triesen', code: 'LI-09' },
  { country_code: 'LI', subdivision_name: 'Triesenberg', code: 'LI-10' },
  { country_code: 'LI', subdivision_name: 'Vaduz', code: 'LI-11' },
  { country_code: 'LK', subdivision_name: 'Central Province', code: 'LK-2' },
  { country_code: 'LK', subdivision_name: 'Eastern Province', code: 'LK-5' },
  { country_code: 'LK', subdivision_name: 'North Central Province', code: 'LK-7' },
  { country_code: 'LK', subdivision_name: 'North Western Province', code: 'LK-6' },
  { country_code: 'LK', subdivision_name: 'Northern Province', code: 'LK-4' },
  { country_code: 'LK', subdivision_name: 'Sabaragamuwa Province', code: 'LK-9' },
  { country_code: 'LK', subdivision_name: 'Southern Province', code: 'LK-3' },
  { country_code: 'LK', subdivision_name: 'Uva Province', code: 'LK-8' },
  { country_code: 'LK', subdivision_name: 'Western Province', code: 'LK-1' },
  { country_code: 'LR', subdivision_name: 'Grand Bassa', code: 'LR-GB' },
  { country_code: 'LR', subdivision_name: 'Grand Gedeh', code: 'LR-GG' },
  { country_code: 'LR', subdivision_name: 'Margibi', code: 'LR-MG' },
  { country_code: 'LR', subdivision_name: 'Maryland', code: 'LR-MY' },
  { country_code: 'LR', subdivision_name: 'Montserrado', code: 'LR-MO' },
  { country_code: 'LR', subdivision_name: 'Nimba', code: 'LR-NI' },
  { country_code: 'LR', subdivision_name: 'Sinoe', code: 'LR-SI' },
  { country_code: 'LS', subdivision_name: 'Berea', code: 'LS-D' },
  { country_code: 'LS', subdivision_name: 'Leribe', code: 'LS-C' },
  { country_code: 'LS', subdivision_name: 'Maseru', code: 'LS-A' },
  { country_code: 'LS', subdivision_name: 'Quthing', code: 'LS-G' },
  { country_code: 'LT', subdivision_name: 'Alytaus apskritis', code: 'LT-AL' },
  { country_code: 'LT', subdivision_name: 'Kauno apskritis', code: 'LT-KU' },
  { country_code: 'LT', subdivision_name: 'Klaipedos apskritis', code: 'LT-KL' },
  { country_code: 'LT', subdivision_name: 'Marijampoles apskritis', code: 'LT-MR' },
  { country_code: 'LT', subdivision_name: 'Panevezio apskritis', code: 'LT-PN' },
  { country_code: 'LT', subdivision_name: 'Siauliu apskritis', code: 'LT-SA' },
  { country_code: 'LT', subdivision_name: 'Taurages apskritis', code: 'LT-TA' },
  { country_code: 'LT', subdivision_name: 'Telsiu apskritis', code: 'LT-TE' },
  { country_code: 'LT', subdivision_name: 'Utenos apskritis', code: 'LT-UT' },
  { country_code: 'LT', subdivision_name: 'Vilniaus apskritis', code: 'LT-VL' },
  { country_code: 'LU', subdivision_name: 'Diekirch', code: 'LU-DI' },
  { country_code: 'LU', subdivision_name: 'Grevenmacher', code: 'LU-GR' },
  { country_code: 'LU', subdivision_name: 'Luxembourg', code: 'LU-LU' },
  { country_code: 'LV', subdivision_name: 'Adazu novads', code: 'LV-011' },
  { country_code: 'LV', subdivision_name: 'Aglonas novads', code: 'LV-001' },
  { country_code: 'LV', subdivision_name: 'Aizkraukles novads', code: 'LV-002' },
  { country_code: 'LV', subdivision_name: 'Aizputes novads', code: 'LV-003' },
  { country_code: 'LV', subdivision_name: 'Alojas novads', code: 'LV-005' },
  { country_code: 'LV', subdivision_name: 'Aluksnes novads', code: 'LV-007' },
  { country_code: 'LV', subdivision_name: 'Babites novads', code: 'LV-012' },
  { country_code: 'LV', subdivision_name: 'Baldones novads', code: 'LV-013' },
  { country_code: 'LV', subdivision_name: 'Balvu novads', code: 'LV-015' },
  { country_code: 'LV', subdivision_name: 'Bauskas novads', code: 'LV-016' },
  { country_code: 'LV', subdivision_name: 'Beverinas novads', code: 'LV-017' },
  { country_code: 'LV', subdivision_name: 'Brocenu novads', code: 'LV-018' },
  { country_code: 'LV', subdivision_name: 'Carnikavas novads', code: 'LV-020' },
  { country_code: 'LV', subdivision_name: 'Cesu novads', code: 'LV-022' },
  { country_code: 'LV', subdivision_name: 'Cesvaines novads', code: 'LV-021' },
  { country_code: 'LV', subdivision_name: 'Daugavpils novads', code: 'LV-025' },
  { country_code: 'LV', subdivision_name: 'Dobeles novads', code: 'LV-026' },
  { country_code: 'LV', subdivision_name: 'Dundagas novads', code: 'LV-027' },
  { country_code: 'LV', subdivision_name: 'Erglu novads', code: 'LV-030' },
  { country_code: 'LV', subdivision_name: 'Gulbenes novads', code: 'LV-033' },
  { country_code: 'LV', subdivision_name: 'Iecavas novads', code: 'LV-034' },
  { country_code: 'LV', subdivision_name: 'Ikskiles novads', code: 'LV-035' },
  { country_code: 'LV', subdivision_name: 'Incukalna novads', code: 'LV-037' },
  { country_code: 'LV', subdivision_name: 'Jaunjelgavas novads', code: 'LV-038' },
  { country_code: 'LV', subdivision_name: 'Jaunpiebalgas novads', code: 'LV-039' },
  { country_code: 'LV', subdivision_name: 'Jaunpils novads', code: 'LV-040' },
  { country_code: 'LV', subdivision_name: 'Jekabpils novads', code: 'LV-042' },
  { country_code: 'LV', subdivision_name: 'Jelgava', code: 'LV-JEL' },
  { country_code: 'LV', subdivision_name: 'Jelgavas novads', code: 'LV-041' },
  { country_code: 'LV', subdivision_name: 'Jurmala', code: 'LV-JUR' },
  { country_code: 'LV', subdivision_name: 'Kekavas novads', code: 'LV-052' },
  { country_code: 'LV', subdivision_name: 'Kokneses novads', code: 'LV-046' },
  { country_code: 'LV', subdivision_name: 'Kraslavas novads', code: 'LV-047' },
  { country_code: 'LV', subdivision_name: 'Kuldigas novads', code: 'LV-050' },
  { country_code: 'LV', subdivision_name: 'Lielvardes novads', code: 'LV-053' },
  { country_code: 'LV', subdivision_name: 'Liepaja', code: 'LV-LPX' },
  { country_code: 'LV', subdivision_name: 'Limbazu novads', code: 'LV-054' },
  { country_code: 'LV', subdivision_name: 'Livanu novads', code: 'LV-056' },
  { country_code: 'LV', subdivision_name: 'Lubanas novads', code: 'LV-057' },
  { country_code: 'LV', subdivision_name: 'Ludzas novads', code: 'LV-058' },
  { country_code: 'LV', subdivision_name: 'Madonas novads', code: 'LV-059' },
  { country_code: 'LV', subdivision_name: 'Malpils novads', code: 'LV-061' },
  { country_code: 'LV', subdivision_name: 'Nauksenu novads', code: 'LV-064' },
  { country_code: 'LV', subdivision_name: 'Ogres novads', code: 'LV-067' },
  { country_code: 'LV', subdivision_name: 'Olaines novads', code: 'LV-068' },
  { country_code: 'LV', subdivision_name: 'Ozolnieku novads', code: 'LV-069' },
  { country_code: 'LV', subdivision_name: 'Preilu novads', code: 'LV-073' },
  { country_code: 'LV', subdivision_name: 'Rezeknes novads', code: 'LV-077' },
  { country_code: 'LV', subdivision_name: 'Riebinu novads', code: 'LV-078' },
  { country_code: 'LV', subdivision_name: 'Riga', code: 'LV-RIX' },
  { country_code: 'LV', subdivision_name: 'Rojas novads', code: 'LV-079' },
  { country_code: 'LV', subdivision_name: 'Ropazu novads', code: 'LV-080' },
  { country_code: 'LV', subdivision_name: 'Rugaju novads', code: 'LV-082' },
  { country_code: 'LV', subdivision_name: 'Rundales novads', code: 'LV-083' },
  { country_code: 'LV', subdivision_name: 'Salacgrivas novads', code: 'LV-086' },
  { country_code: 'LV', subdivision_name: 'Salaspils novads', code: 'LV-087' },
  { country_code: 'LV', subdivision_name: 'Saldus novads', code: 'LV-088' },
  { country_code: 'LV', subdivision_name: 'Saulkrastu novads', code: 'LV-089' },
  { country_code: 'LV', subdivision_name: 'Sejas novads', code: 'LV-090' },
  { country_code: 'LV', subdivision_name: 'Siguldas novads', code: 'LV-091' },
  { country_code: 'LV', subdivision_name: 'Skrundas novads', code: 'LV-093' },
  { country_code: 'LV', subdivision_name: 'Stopinu novads', code: 'LV-095' },
  { country_code: 'LV', subdivision_name: 'Talsu novads', code: 'LV-097' },
  { country_code: 'LV', subdivision_name: 'Tukuma novads', code: 'LV-099' },
  { country_code: 'LV', subdivision_name: 'Valkas novads', code: 'LV-101' },
  { country_code: 'LV', subdivision_name: 'Valmiera', code: 'LV-VMR' },
  { country_code: 'LV', subdivision_name: 'Varkavas novads', code: 'LV-103' },
  { country_code: 'LV', subdivision_name: 'Vecumnieku novads', code: 'LV-105' },
  { country_code: 'LV', subdivision_name: 'Ventspils novads', code: 'LV-106' },
  { country_code: 'LY', subdivision_name: 'Al Butnan', code: 'LY-BU' },
  { country_code: 'LY', subdivision_name: 'Al Jabal al Akhdar', code: 'LY-JA' },
  { country_code: 'LY', subdivision_name: 'Al Jabal al Gharbi', code: 'LY-JG' },
  { country_code: 'LY', subdivision_name: 'Al Jufrah', code: 'LY-JU' },
  { country_code: 'LY', subdivision_name: 'Al Kufrah', code: 'LY-KF' },
  { country_code: 'LY', subdivision_name: 'Al Marj', code: 'LY-MJ' },
  { country_code: 'LY', subdivision_name: 'Al Marqab', code: 'LY-MB' },
  { country_code: 'LY', subdivision_name: 'Al Wahat', code: 'LY-WA' },
  { country_code: 'LY', subdivision_name: 'An Nuqat al Khams', code: 'LY-NQ' },
  { country_code: 'LY', subdivision_name: 'Az Zawiyah', code: 'LY-ZA' },
  { country_code: 'LY', subdivision_name: 'Banghazi', code: 'LY-BA' },
  { country_code: 'LY', subdivision_name: 'Darnah', code: 'LY-DR' },
  { country_code: 'LY', subdivision_name: 'Misratah', code: 'LY-MI' },
  { country_code: 'LY', subdivision_name: 'Murzuq', code: 'LY-MQ' },
  { country_code: 'LY', subdivision_name: 'Nalut', code: 'LY-NL' },
  { country_code: 'LY', subdivision_name: 'Sabha', code: 'LY-SB' },
  { country_code: 'LY', subdivision_name: 'Tarabulus', code: 'LY-TB' },
  { country_code: 'MA', subdivision_name: 'Beni-Mellal-Khenifra', code: 'MA-05' },
  { country_code: 'MA', subdivision_name: 'Casablanca-Settat', code: 'MA-06' },
  { country_code: 'MA', subdivision_name: 'Draa-Tafilalet', code: 'MA-08' },
  { country_code: 'MA', subdivision_name: 'Fes- Meknes', code: 'MA-03' },
  { country_code: 'MA', subdivision_name: 'Guelmim-Oued Noun (EH-partial)', code: 'MA-10' },
  { country_code: 'MA', subdivision_name: "L'Oriental", code: 'MA-02' },
  { country_code: 'MA', subdivision_name: 'Laayoune-Sakia El Hamra (EH-partial)', code: 'MA-11' },
  { country_code: 'MA', subdivision_name: 'Marrakech-Safi', code: 'MA-07' },
  { country_code: 'MA', subdivision_name: 'Rabat-Sale-Kenitra', code: 'MA-04' },
  { country_code: 'MA', subdivision_name: 'Souss-Massa', code: 'MA-09' },
  { country_code: 'MA', subdivision_name: 'Tanger-Tetouan-Al Hoceima', code: 'MA-01' },
  { country_code: 'MC', subdivision_name: 'Fontvieille', code: 'MC-FO' },
  { country_code: 'MC', subdivision_name: 'La Condamine', code: 'MC-CO' },
  { country_code: 'MC', subdivision_name: 'Monaco-Ville', code: 'MC-MO' },
  { country_code: 'MC', subdivision_name: 'Monte-Carlo', code: 'MC-MC' },
  { country_code: 'MC', subdivision_name: 'Saint-Roman', code: 'MC-SR' },
  { country_code: 'MD', subdivision_name: 'Anenii Noi', code: 'MD-AN' },
  { country_code: 'MD', subdivision_name: 'Balti', code: 'MD-BA' },
  { country_code: 'MD', subdivision_name: 'Basarabeasca', code: 'MD-BS' },
  { country_code: 'MD', subdivision_name: 'Bender', code: 'MD-BD' },
  { country_code: 'MD', subdivision_name: 'Briceni', code: 'MD-BR' },
  { country_code: 'MD', subdivision_name: 'Cahul', code: 'MD-CA' },
  { country_code: 'MD', subdivision_name: 'Calarasi', code: 'MD-CL' },
  { country_code: 'MD', subdivision_name: 'Cantemir', code: 'MD-CT' },
  { country_code: 'MD', subdivision_name: 'Causeni', code: 'MD-CS' },
  { country_code: 'MD', subdivision_name: 'Chisinau', code: 'MD-CU' },
  { country_code: 'MD', subdivision_name: 'Cimislia', code: 'MD-CM' },
  { country_code: 'MD', subdivision_name: 'Criuleni', code: 'MD-CR' },
  { country_code: 'MD', subdivision_name: 'Donduseni', code: 'MD-DO' },
  { country_code: 'MD', subdivision_name: 'Drochia', code: 'MD-DR' },
  { country_code: 'MD', subdivision_name: 'Dubasari', code: 'MD-DU' },
  { country_code: 'MD', subdivision_name: 'Edinet', code: 'MD-ED' },
  { country_code: 'MD', subdivision_name: 'Falesti', code: 'MD-FA' },
  { country_code: 'MD', subdivision_name: 'Floresti', code: 'MD-FL' },
  { country_code: 'MD', subdivision_name: 'Gagauzia, Unitatea teritoriala autonoma', code: 'MD-GA' },
  { country_code: 'MD', subdivision_name: 'Glodeni', code: 'MD-GL' },
  { country_code: 'MD', subdivision_name: 'Hincesti', code: 'MD-HI' },
  { country_code: 'MD', subdivision_name: 'Ialoveni', code: 'MD-IA' },
  { country_code: 'MD', subdivision_name: 'Leova', code: 'MD-LE' },
  { country_code: 'MD', subdivision_name: 'Nisporeni', code: 'MD-NI' },
  { country_code: 'MD', subdivision_name: 'Ocnita', code: 'MD-OC' },
  { country_code: 'MD', subdivision_name: 'Orhei', code: 'MD-OR' },
  { country_code: 'MD', subdivision_name: 'Rezina', code: 'MD-RE' },
  { country_code: 'MD', subdivision_name: 'Riscani', code: 'MD-RI' },
  { country_code: 'MD', subdivision_name: 'Singerei', code: 'MD-SI' },
  { country_code: 'MD', subdivision_name: 'Soldanesti', code: 'MD-SD' },
  { country_code: 'MD', subdivision_name: 'Soroca', code: 'MD-SO' },
  { country_code: 'MD', subdivision_name: 'Stefan Voda', code: 'MD-SV' },
  { country_code: 'MD', subdivision_name: 'Stinga Nistrului, unitatea teritoriala din', code: 'MD-SN' },
  { country_code: 'MD', subdivision_name: 'Straseni', code: 'MD-ST' },
  { country_code: 'MD', subdivision_name: 'Taraclia', code: 'MD-TA' },
  { country_code: 'MD', subdivision_name: 'Telenesti', code: 'MD-TE' },
  { country_code: 'MD', subdivision_name: 'Ungheni', code: 'MD-UN' },
  { country_code: 'ME', subdivision_name: 'Bar', code: 'ME-02' },
  { country_code: 'ME', subdivision_name: 'Berane', code: 'ME-03' },
  { country_code: 'ME', subdivision_name: 'Bijelo Polje', code: 'ME-04' },
  { country_code: 'ME', subdivision_name: 'Budva', code: 'ME-05' },
  { country_code: 'ME', subdivision_name: 'Cetinje', code: 'ME-06' },
  { country_code: 'ME', subdivision_name: 'Danilovgrad', code: 'ME-07' },
  { country_code: 'ME', subdivision_name: 'Herceg-Novi', code: 'ME-08' },
  { country_code: 'ME', subdivision_name: 'Kolasin', code: 'ME-09' },
  { country_code: 'ME', subdivision_name: 'Kotor', code: 'ME-10' },
  { country_code: 'ME', subdivision_name: 'Niksic', code: 'ME-12' },
  { country_code: 'ME', subdivision_name: 'Plav', code: 'ME-13' },
  { country_code: 'ME', subdivision_name: 'Pljevlja', code: 'ME-14' },
  { country_code: 'ME', subdivision_name: 'Pluzine', code: 'ME-15' },
  { country_code: 'ME', subdivision_name: 'Podgorica', code: 'ME-16' },
  { country_code: 'ME', subdivision_name: 'Rozaje', code: 'ME-17' },
  { country_code: 'ME', subdivision_name: 'Tivat', code: 'ME-19' },
  { country_code: 'ME', subdivision_name: 'Ulcinj', code: 'ME-20' },
  { country_code: 'ME', subdivision_name: 'Zabljak', code: 'ME-21' },
  { country_code: 'MF', subdivision_name: 'Saint Martin (French Part)', code: '-' },
  { country_code: 'MG', subdivision_name: 'Antananarivo', code: 'MG-T' },
  { country_code: 'MG', subdivision_name: 'Antsiranana', code: 'MG-D' },
  { country_code: 'MG', subdivision_name: 'Fianarantsoa', code: 'MG-F' },
  { country_code: 'MG', subdivision_name: 'Mahajanga', code: 'MG-M' },
  { country_code: 'MG', subdivision_name: 'Toamasina', code: 'MG-A' },
  { country_code: 'MG', subdivision_name: 'Toliara', code: 'MG-U' },
  { country_code: 'MH', subdivision_name: 'Kwajalein', code: 'MH-KWA' },
  { country_code: 'MH', subdivision_name: 'Majuro', code: 'MH-MAJ' },
  { country_code: 'MK', subdivision_name: 'Aracinovo', code: 'MK-802' },
  { country_code: 'MK', subdivision_name: 'Berovo', code: 'MK-201' },
  { country_code: 'MK', subdivision_name: 'Bitola', code: 'MK-501' },
  { country_code: 'MK', subdivision_name: 'Bogdanci', code: 'MK-401' },
  { country_code: 'MK', subdivision_name: 'Bogovinje', code: 'MK-601' },
  { country_code: 'MK', subdivision_name: 'Bosilovo', code: 'MK-402' },
  { country_code: 'MK', subdivision_name: 'Brvenica', code: 'MK-602' },
  { country_code: 'MK', subdivision_name: 'Centar Zupa', code: 'MK-313' },
  { country_code: 'MK', subdivision_name: 'Cesinovo-Oblesevo', code: 'MK-210' },
  { country_code: 'MK', subdivision_name: 'Debar', code: 'MK-303' },
  { country_code: 'MK', subdivision_name: 'Delcevo', code: 'MK-203' },
  { country_code: 'MK', subdivision_name: 'Demir Kapija', code: 'MK-103' },
  { country_code: 'MK', subdivision_name: 'Dolneni', code: 'MK-503' },
  { country_code: 'MK', subdivision_name: 'Gevgelija', code: 'MK-405' },
  { country_code: 'MK', subdivision_name: 'Gostivar', code: 'MK-604' },
  { country_code: 'MK', subdivision_name: 'Ilinden', code: 'MK-807' },
  { country_code: 'MK', subdivision_name: 'Jegunovce', code: 'MK-606' },
  { country_code: 'MK', subdivision_name: 'Karbinci', code: 'MK-205' },
  { country_code: 'MK', subdivision_name: 'Kavadarci', code: 'MK-104' },
  { country_code: 'MK', subdivision_name: 'Kicevo', code: 'MK-307' },
  { country_code: 'MK', subdivision_name: 'Kocani', code: 'MK-206' },
  { country_code: 'MK', subdivision_name: 'Kratovo', code: 'MK-701' },
  { country_code: 'MK', subdivision_name: 'Kriva Palanka', code: 'MK-702' },
  { country_code: 'MK', subdivision_name: 'Krivogastani', code: 'MK-504' },
  { country_code: 'MK', subdivision_name: 'Krusevo', code: 'MK-505' },
  { country_code: 'MK', subdivision_name: 'Kumanovo', code: 'MK-703' },
  { country_code: 'MK', subdivision_name: 'Lipkovo', code: 'MK-704' },
  { country_code: 'MK', subdivision_name: 'Makedonska Kamenica', code: 'MK-207' },
  { country_code: 'MK', subdivision_name: 'Makedonski Brod', code: 'MK-308' },
  { country_code: 'MK', subdivision_name: 'Negotino', code: 'MK-106' },
  { country_code: 'MK', subdivision_name: 'Novo Selo', code: 'MK-408' },
  { country_code: 'MK', subdivision_name: 'Ohrid', code: 'MK-310' },
  { country_code: 'MK', subdivision_name: 'Pehcevo', code: 'MK-208' },
  { country_code: 'MK', subdivision_name: 'Petrovec', code: 'MK-810' },
  { country_code: 'MK', subdivision_name: 'Plasnica', code: 'MK-311' },
  { country_code: 'MK', subdivision_name: 'Prilep', code: 'MK-508' },
  { country_code: 'MK', subdivision_name: 'Probistip', code: 'MK-209' },
  { country_code: 'MK', subdivision_name: 'Radovis', code: 'MK-409' },
  { country_code: 'MK', subdivision_name: 'Rankovce', code: 'MK-705' },
  { country_code: 'MK', subdivision_name: 'Resen', code: 'MK-509' },
  { country_code: 'MK', subdivision_name: 'Rosoman', code: 'MK-107' },
  { country_code: 'MK', subdivision_name: 'Skopje', code: 'MK-85' },
  { country_code: 'MK', subdivision_name: 'Sopiste', code: 'MK-812' },
  { country_code: 'MK', subdivision_name: 'Stip', code: 'MK-211' },
  { country_code: 'MK', subdivision_name: 'Struga', code: 'MK-312' },
  { country_code: 'MK', subdivision_name: 'Strumica', code: 'MK-410' },
  { country_code: 'MK', subdivision_name: 'Studenicani', code: 'MK-813' },
  { country_code: 'MK', subdivision_name: 'Sveti Nikole', code: 'MK-108' },
  { country_code: 'MK', subdivision_name: 'Tearce', code: 'MK-608' },
  { country_code: 'MK', subdivision_name: 'Tetovo', code: 'MK-609' },
  { country_code: 'MK', subdivision_name: 'Valandovo', code: 'MK-403' },
  { country_code: 'MK', subdivision_name: 'Vasilevo', code: 'MK-404' },
  { country_code: 'MK', subdivision_name: 'Veles', code: 'MK-101' },
  { country_code: 'MK', subdivision_name: 'Vevcani', code: 'MK-301' },
  { country_code: 'MK', subdivision_name: 'Vinica', code: 'MK-202' },
  { country_code: 'MK', subdivision_name: 'Vrapciste', code: 'MK-603' },
  { country_code: 'MK', subdivision_name: 'Zelenikovo', code: 'MK-806' },
  { country_code: 'MK', subdivision_name: 'Zelino', code: 'MK-605' },
  { country_code: 'ML', subdivision_name: 'Bamako', code: 'ML-BKO' },
  { country_code: 'ML', subdivision_name: 'Gao', code: 'ML-7' },
  { country_code: 'ML', subdivision_name: 'Kayes', code: 'ML-1' },
  { country_code: 'ML', subdivision_name: 'Kidal', code: 'ML-8' },
  { country_code: 'ML', subdivision_name: 'Koulikoro', code: 'ML-2' },
  { country_code: 'ML', subdivision_name: 'Mopti', code: 'ML-5' },
  { country_code: 'ML', subdivision_name: 'Segou', code: 'ML-4' },
  { country_code: 'ML', subdivision_name: 'Sikasso', code: 'ML-3' },
  { country_code: 'ML', subdivision_name: 'Tombouctou', code: 'ML-6' },
  { country_code: 'MM', subdivision_name: 'Ayeyarwady', code: 'MM-07' },
  { country_code: 'MM', subdivision_name: 'Bago', code: 'MM-02' },
  { country_code: 'MM', subdivision_name: 'Kachin', code: 'MM-11' },
  { country_code: 'MM', subdivision_name: 'Kayah', code: 'MM-12' },
  { country_code: 'MM', subdivision_name: 'Kayin', code: 'MM-13' },
  { country_code: 'MM', subdivision_name: 'Magway', code: 'MM-03' },
  { country_code: 'MM', subdivision_name: 'Mandalay', code: 'MM-04' },
  { country_code: 'MM', subdivision_name: 'Mon', code: 'MM-15' },
  { country_code: 'MM', subdivision_name: 'Nay Pyi Taw', code: 'MM-18' },
  { country_code: 'MM', subdivision_name: 'Rakhine', code: 'MM-16' },
  { country_code: 'MM', subdivision_name: 'Sagaing', code: 'MM-01' },
  { country_code: 'MM', subdivision_name: 'Shan', code: 'MM-17' },
  { country_code: 'MM', subdivision_name: 'Tanintharyi', code: 'MM-05' },
  { country_code: 'MM', subdivision_name: 'Yangon', code: 'MM-06' },
  { country_code: 'MN', subdivision_name: 'Bayan-Olgiy', code: 'MN-071' },
  { country_code: 'MN', subdivision_name: 'Dornogovi', code: 'MN-063' },
  { country_code: 'MN', subdivision_name: 'Govi-Altay', code: 'MN-065' },
  { country_code: 'MN', subdivision_name: 'Omnogovi', code: 'MN-053' },
  { country_code: 'MN', subdivision_name: 'Orhon', code: 'MN-035' },
  { country_code: 'MN', subdivision_name: 'Ovorhangay', code: 'MN-055' },
  { country_code: 'MN', subdivision_name: 'Selenge', code: 'MN-049' },
  { country_code: 'MN', subdivision_name: 'Tov', code: 'MN-047' },
  { country_code: 'MN', subdivision_name: 'Ulaanbaatar', code: 'MN-1' },
  { country_code: 'MO', subdivision_name: 'Macao', code: '-' },
  { country_code: 'MP', subdivision_name: 'Northern Mariana Islands', code: '-' },
  { country_code: 'MQ', subdivision_name: 'Martinique', code: '-' },
  { country_code: 'MR', subdivision_name: 'Dakhlet Nouadhibou', code: 'MR-08' },
  { country_code: 'MR', subdivision_name: 'Nouakchott Nord', code: 'MR-14' },
  { country_code: 'MR', subdivision_name: 'Tiris Zemmour', code: 'MR-11' },
  { country_code: 'MS', subdivision_name: 'Saint Anthony', code: '-' },
  { country_code: 'MS', subdivision_name: 'Saint Peter', code: '-' },
  { country_code: 'MT', subdivision_name: 'Attard', code: 'MT-01' },
  { country_code: 'MT', subdivision_name: 'Balzan', code: 'MT-02' },
  { country_code: 'MT', subdivision_name: 'Birgu', code: 'MT-03' },
  { country_code: 'MT', subdivision_name: 'Birkirkara', code: 'MT-04' },
  { country_code: 'MT', subdivision_name: 'Birzebbuga', code: 'MT-05' },
  { country_code: 'MT', subdivision_name: 'Bormla', code: 'MT-06' },
  { country_code: 'MT', subdivision_name: 'Dingli', code: 'MT-07' },
  { country_code: 'MT', subdivision_name: 'Fgura', code: 'MT-08' },
  { country_code: 'MT', subdivision_name: 'Floriana', code: 'MT-09' },
  { country_code: 'MT', subdivision_name: 'Fontana', code: 'MT-10' },
  { country_code: 'MT', subdivision_name: 'Gharb', code: 'MT-14' },
  { country_code: 'MT', subdivision_name: 'Gharghur', code: 'MT-15' },
  { country_code: 'MT', subdivision_name: 'Ghasri', code: 'MT-16' },
  { country_code: 'MT', subdivision_name: 'Ghaxaq', code: 'MT-17' },
  { country_code: 'MT', subdivision_name: 'Gudja', code: 'MT-11' },
  { country_code: 'MT', subdivision_name: 'Gzira', code: 'MT-12' },
  { country_code: 'MT', subdivision_name: 'Hamrun', code: 'MT-18' },
  { country_code: 'MT', subdivision_name: 'Iklin', code: 'MT-19' },
  { country_code: 'MT', subdivision_name: 'Isla', code: 'MT-20' },
  { country_code: 'MT', subdivision_name: 'Kalkara', code: 'MT-21' },
  { country_code: 'MT', subdivision_name: 'Kercem', code: 'MT-22' },
  { country_code: 'MT', subdivision_name: 'Kirkop', code: 'MT-23' },
  { country_code: 'MT', subdivision_name: 'Lija', code: 'MT-24' },
  { country_code: 'MT', subdivision_name: 'Luqa', code: 'MT-25' },
  { country_code: 'MT', subdivision_name: 'Marsa', code: 'MT-26' },
  { country_code: 'MT', subdivision_name: 'Marsaskala', code: 'MT-27' },
  { country_code: 'MT', subdivision_name: 'Marsaxlokk', code: 'MT-28' },
  { country_code: 'MT', subdivision_name: 'Mdina', code: 'MT-29' },
  { country_code: 'MT', subdivision_name: 'Mellieha', code: 'MT-30' },
  { country_code: 'MT', subdivision_name: 'Mgarr', code: 'MT-31' },
  { country_code: 'MT', subdivision_name: 'Mosta', code: 'MT-32' },
  { country_code: 'MT', subdivision_name: 'Mqabba', code: 'MT-33' },
  { country_code: 'MT', subdivision_name: 'Msida', code: 'MT-34' },
  { country_code: 'MT', subdivision_name: 'Mtarfa', code: 'MT-35' },
  { country_code: 'MT', subdivision_name: 'Munxar', code: 'MT-36' },
  { country_code: 'MT', subdivision_name: 'Nadur', code: 'MT-37' },
  { country_code: 'MT', subdivision_name: 'Naxxar', code: 'MT-38' },
  { country_code: 'MT', subdivision_name: 'Paola', code: 'MT-39' },
  { country_code: 'MT', subdivision_name: 'Pembroke', code: 'MT-40' },
  { country_code: 'MT', subdivision_name: 'Pieta', code: 'MT-41' },
  { country_code: 'MT', subdivision_name: 'Qala', code: 'MT-42' },
  { country_code: 'MT', subdivision_name: 'Qormi', code: 'MT-43' },
  { country_code: 'MT', subdivision_name: 'Qrendi', code: 'MT-44' },
  { country_code: 'MT', subdivision_name: 'Rabat Gozo', code: 'MT-45' },
  { country_code: 'MT', subdivision_name: 'Rabat Malta', code: 'MT-46' },
  { country_code: 'MT', subdivision_name: 'Saint John', code: 'MT-49' },
  { country_code: 'MT', subdivision_name: "Saint Julian's", code: 'MT-48' },
  { country_code: 'MT', subdivision_name: "Saint Lucia's", code: 'MT-53' },
  { country_code: 'MT', subdivision_name: "Saint Paul's Bay", code: 'MT-51' },
  { country_code: 'MT', subdivision_name: 'Sannat', code: 'MT-52' },
  { country_code: 'MT', subdivision_name: 'Santa Venera', code: 'MT-54' },
  { country_code: 'MT', subdivision_name: 'Siggiewi', code: 'MT-55' },
  { country_code: 'MT', subdivision_name: 'Sliema', code: 'MT-56' },
  { country_code: 'MT', subdivision_name: 'Swieqi', code: 'MT-57' },
  { country_code: 'MT', subdivision_name: "Ta' Xbiex", code: 'MT-58' },
  { country_code: 'MT', subdivision_name: 'Tarxien', code: 'MT-59' },
  { country_code: 'MT', subdivision_name: 'Valletta', code: 'MT-60' },
  { country_code: 'MT', subdivision_name: 'Xaghra', code: 'MT-61' },
  { country_code: 'MT', subdivision_name: 'Xewkija', code: 'MT-62' },
  { country_code: 'MT', subdivision_name: 'Xghajra', code: 'MT-63' },
  { country_code: 'MT', subdivision_name: 'Zabbar', code: 'MT-64' },
  { country_code: 'MT', subdivision_name: 'Zebbug Gozo', code: 'MT-65' },
  { country_code: 'MT', subdivision_name: 'Zejtun', code: 'MT-67' },
  { country_code: 'MT', subdivision_name: 'Zurrieq', code: 'MT-68' },
  { country_code: 'MU', subdivision_name: 'Black River', code: 'MU-BL' },
  { country_code: 'MU', subdivision_name: 'Flacq', code: 'MU-FL' },
  { country_code: 'MU', subdivision_name: 'Grand Port', code: 'MU-GP' },
  { country_code: 'MU', subdivision_name: 'Moka', code: 'MU-MO' },
  { country_code: 'MU', subdivision_name: 'Pamplemousses', code: 'MU-PA' },
  { country_code: 'MU', subdivision_name: 'Plaines Wilhems', code: 'MU-PW' },
  { country_code: 'MU', subdivision_name: 'Port Louis', code: 'MU-PL' },
  { country_code: 'MU', subdivision_name: 'Riviere du Rempart', code: 'MU-RR' },
  { country_code: 'MU', subdivision_name: 'Rodrigues Islands', code: 'MU-RO' },
  { country_code: 'MU', subdivision_name: 'Savanne', code: 'MU-SA' },
  { country_code: 'MV', subdivision_name: 'Alifu Alifu', code: 'MV-02' },
  { country_code: 'MV', subdivision_name: 'Baa', code: 'MV-20' },
  { country_code: 'MV', subdivision_name: 'Dhaalu', code: 'MV-17' },
  { country_code: 'MV', subdivision_name: 'Gaafu Dhaalu', code: 'MV-28' },
  { country_code: 'MV', subdivision_name: 'Haa Dhaalu', code: 'MV-23' },
  { country_code: 'MV', subdivision_name: 'Kaafu', code: 'MV-26' },
  { country_code: 'MV', subdivision_name: 'Laamu', code: 'MV-05' },
  { country_code: 'MV', subdivision_name: 'Maale', code: 'MV-MLE' },
  { country_code: 'MV', subdivision_name: 'Meemu', code: 'MV-12' },
  { country_code: 'MV', subdivision_name: 'Noonu', code: 'MV-25' },
  { country_code: 'MV', subdivision_name: 'Raa', code: 'MV-13' },
  { country_code: 'MV', subdivision_name: 'Seenu', code: 'MV-01' },
  { country_code: 'MV', subdivision_name: 'Vaavu', code: 'MV-04' },
  { country_code: 'MW', subdivision_name: 'Balaka', code: 'MW-BA' },
  { country_code: 'MW', subdivision_name: 'Blantyre', code: 'MW-BL' },
  { country_code: 'MW', subdivision_name: 'Dowa', code: 'MW-DO' },
  { country_code: 'MW', subdivision_name: 'Lilongwe', code: 'MW-LI' },
  { country_code: 'MW', subdivision_name: 'Machinga', code: 'MW-MH' },
  { country_code: 'MW', subdivision_name: 'Mangochi', code: 'MW-MG' },
  { country_code: 'MW', subdivision_name: 'Mzimba', code: 'MW-MZ' },
  { country_code: 'MW', subdivision_name: 'Ntchisi', code: 'MW-NI' },
  { country_code: 'MW', subdivision_name: 'Salima', code: 'MW-SA' },
  { country_code: 'MW', subdivision_name: 'Zomba', code: 'MW-ZO' },
  { country_code: 'MX', subdivision_name: 'Aguascalientes', code: 'MX-AGU' },
  { country_code: 'MX', subdivision_name: 'Baja California', code: 'MX-BCN' },
  { country_code: 'MX', subdivision_name: 'Baja California Sur', code: 'MX-BCS' },
  { country_code: 'MX', subdivision_name: 'Campeche', code: 'MX-CAM' },
  { country_code: 'MX', subdivision_name: 'Chiapas', code: 'MX-CHP' },
  { country_code: 'MX', subdivision_name: 'Chihuahua', code: 'MX-CHH' },
  { country_code: 'MX', subdivision_name: 'Ciudad de Mexico', code: 'MX-CMX' },
  { country_code: 'MX', subdivision_name: 'Coahuila de Zaragoza', code: 'MX-COA' },
  { country_code: 'MX', subdivision_name: 'Colima', code: 'MX-COL' },
  { country_code: 'MX', subdivision_name: 'Durango', code: 'MX-DUR' },
  { country_code: 'MX', subdivision_name: 'Guanajuato', code: 'MX-GUA' },
  { country_code: 'MX', subdivision_name: 'Guerrero', code: 'MX-GRO' },
  { country_code: 'MX', subdivision_name: 'Hidalgo', code: 'MX-HID' },
  { country_code: 'MX', subdivision_name: 'Jalisco', code: 'MX-JAL' },
  { country_code: 'MX', subdivision_name: 'Mexico', code: 'MX-MEX' },
  { country_code: 'MX', subdivision_name: 'Michoacan de Ocampo', code: 'MX-MIC' },
  { country_code: 'MX', subdivision_name: 'Morelos', code: 'MX-MOR' },
  { country_code: 'MX', subdivision_name: 'Nayarit', code: 'MX-NAY' },
  { country_code: 'MX', subdivision_name: 'Nuevo Leon', code: 'MX-NLE' },
  { country_code: 'MX', subdivision_name: 'Oaxaca', code: 'MX-OAX' },
  { country_code: 'MX', subdivision_name: 'Puebla', code: 'MX-PUE' },
  { country_code: 'MX', subdivision_name: 'Queretaro', code: 'MX-QUE' },
  { country_code: 'MX', subdivision_name: 'Quintana Roo', code: 'MX-ROO' },
  { country_code: 'MX', subdivision_name: 'San Luis Potosi', code: 'MX-SLP' },
  { country_code: 'MX', subdivision_name: 'Sinaloa', code: 'MX-SIN' },
  { country_code: 'MX', subdivision_name: 'Sonora', code: 'MX-SON' },
  { country_code: 'MX', subdivision_name: 'Tabasco', code: 'MX-TAB' },
  { country_code: 'MX', subdivision_name: 'Tamaulipas', code: 'MX-TAM' },
  { country_code: 'MX', subdivision_name: 'Tlaxcala', code: 'MX-TLA' },
  { country_code: 'MX', subdivision_name: 'Veracruz de Ignacio de la Llave', code: 'MX-VER' },
  { country_code: 'MX', subdivision_name: 'Yucatan', code: 'MX-YUC' },
  { country_code: 'MX', subdivision_name: 'Zacatecas', code: 'MX-ZAC' },
  { country_code: 'MY', subdivision_name: 'Johor', code: 'MY-01' },
  { country_code: 'MY', subdivision_name: 'Kedah', code: 'MY-02' },
  { country_code: 'MY', subdivision_name: 'Kelantan', code: 'MY-03' },
  { country_code: 'MY', subdivision_name: 'Melaka', code: 'MY-04' },
  { country_code: 'MY', subdivision_name: 'Negeri Sembilan', code: 'MY-05' },
  { country_code: 'MY', subdivision_name: 'Pahang', code: 'MY-06' },
  { country_code: 'MY', subdivision_name: 'Perak', code: 'MY-08' },
  { country_code: 'MY', subdivision_name: 'Perlis', code: 'MY-09' },
  { country_code: 'MY', subdivision_name: 'Pulau Pinang', code: 'MY-07' },
  { country_code: 'MY', subdivision_name: 'Sabah', code: 'MY-12' },
  { country_code: 'MY', subdivision_name: 'Sarawak', code: 'MY-13' },
  { country_code: 'MY', subdivision_name: 'Selangor', code: 'MY-10' },
  { country_code: 'MY', subdivision_name: 'Terengganu', code: 'MY-11' },
  { country_code: 'MY', subdivision_name: 'Wilayah Persekutuan Kuala Lumpur', code: 'MY-14' },
  { country_code: 'MY', subdivision_name: 'Wilayah Persekutuan Labuan', code: 'MY-15' },
  { country_code: 'MY', subdivision_name: 'Wilayah Persekutuan Putrajaya', code: 'MY-16' },
  { country_code: 'MZ', subdivision_name: 'Cabo Delgado', code: 'MZ-P' },
  { country_code: 'MZ', subdivision_name: 'Gaza', code: 'MZ-G' },
  { country_code: 'MZ', subdivision_name: 'Inhambane', code: 'MZ-I' },
  { country_code: 'MZ', subdivision_name: 'Manica', code: 'MZ-B' },
  { country_code: 'MZ', subdivision_name: 'Maputo', code: 'MZ-L' },
  { country_code: 'MZ', subdivision_name: 'Nampula', code: 'MZ-N' },
  { country_code: 'MZ', subdivision_name: 'Niassa', code: 'MZ-A' },
  { country_code: 'MZ', subdivision_name: 'Sofala', code: 'MZ-S' },
  { country_code: 'MZ', subdivision_name: 'Tete', code: 'MZ-T' },
  { country_code: 'MZ', subdivision_name: 'Zambezia', code: 'MZ-Q' },
  { country_code: 'NA', subdivision_name: 'Erongo', code: 'NA-ER' },
  { country_code: 'NA', subdivision_name: 'Hardap', code: 'NA-HA' },
  { country_code: 'NA', subdivision_name: 'Karas', code: 'NA-KA' },
  { country_code: 'NA', subdivision_name: 'Kavango East', code: 'NA-KE' },
  { country_code: 'NA', subdivision_name: 'Khomas', code: 'NA-KH' },
  { country_code: 'NA', subdivision_name: 'Kunene', code: 'NA-KU' },
  { country_code: 'NA', subdivision_name: 'Ohangwena', code: 'NA-OW' },
  { country_code: 'NA', subdivision_name: 'Omaheke', code: 'NA-OH' },
  { country_code: 'NA', subdivision_name: 'Omusati', code: 'NA-OS' },
  { country_code: 'NA', subdivision_name: 'Oshana', code: 'NA-ON' },
  { country_code: 'NA', subdivision_name: 'Oshikoto', code: 'NA-OT' },
  { country_code: 'NA', subdivision_name: 'Otjozondjupa', code: 'NA-OD' },
  { country_code: 'NA', subdivision_name: 'Zambezi', code: 'NA-CA' },
  { country_code: 'NC', subdivision_name: 'Province Nord', code: '-' },
  { country_code: 'NC', subdivision_name: 'Province Sud', code: '-' },
  { country_code: 'NE', subdivision_name: 'Agadez', code: 'NE-1' },
  { country_code: 'NE', subdivision_name: 'Diffa', code: 'NE-2' },
  { country_code: 'NE', subdivision_name: 'Dosso', code: 'NE-3' },
  { country_code: 'NE', subdivision_name: 'Niamey', code: 'NE-8' },
  { country_code: 'NE', subdivision_name: 'Tahoua', code: 'NE-5' },
  { country_code: 'NE', subdivision_name: 'Zinder', code: 'NE-7' },
  { country_code: 'NF', subdivision_name: 'Norfolk Island', code: '-' },
  { country_code: 'NG', subdivision_name: 'Abia', code: 'NG-AB' },
  { country_code: 'NG', subdivision_name: 'Abuja Federal Capital Territory', code: 'NG-FC' },
  { country_code: 'NG', subdivision_name: 'Adamawa', code: 'NG-AD' },
  { country_code: 'NG', subdivision_name: 'Akwa Ibom', code: 'NG-AK' },
  { country_code: 'NG', subdivision_name: 'Anambra', code: 'NG-AN' },
  { country_code: 'NG', subdivision_name: 'Bauchi', code: 'NG-BA' },
  { country_code: 'NG', subdivision_name: 'Bayelsa', code: 'NG-BY' },
  { country_code: 'NG', subdivision_name: 'Benue', code: 'NG-BE' },
  { country_code: 'NG', subdivision_name: 'Borno', code: 'NG-BO' },
  { country_code: 'NG', subdivision_name: 'Cross River', code: 'NG-CR' },
  { country_code: 'NG', subdivision_name: 'Delta', code: 'NG-DE' },
  { country_code: 'NG', subdivision_name: 'Ebonyi', code: 'NG-EB' },
  { country_code: 'NG', subdivision_name: 'Edo', code: 'NG-ED' },
  { country_code: 'NG', subdivision_name: 'Ekiti', code: 'NG-EK' },
  { country_code: 'NG', subdivision_name: 'Enugu', code: 'NG-EN' },
  { country_code: 'NG', subdivision_name: 'Gombe', code: 'NG-GO' },
  { country_code: 'NG', subdivision_name: 'Imo', code: 'NG-IM' },
  { country_code: 'NG', subdivision_name: 'Jigawa', code: 'NG-JI' },
  { country_code: 'NG', subdivision_name: 'Kaduna', code: 'NG-KD' },
  { country_code: 'NG', subdivision_name: 'Kano', code: 'NG-KN' },
  { country_code: 'NG', subdivision_name: 'Katsina', code: 'NG-KT' },
  { country_code: 'NG', subdivision_name: 'Kebbi', code: 'NG-KE' },
  { country_code: 'NG', subdivision_name: 'Kogi', code: 'NG-KO' },
  { country_code: 'NG', subdivision_name: 'Kwara', code: 'NG-KW' },
  { country_code: 'NG', subdivision_name: 'Lagos', code: 'NG-LA' },
  { country_code: 'NG', subdivision_name: 'Nasarawa', code: 'NG-NA' },
  { country_code: 'NG', subdivision_name: 'Niger', code: 'NG-NI' },
  { country_code: 'NG', subdivision_name: 'Ogun', code: 'NG-OG' },
  { country_code: 'NG', subdivision_name: 'Ondo', code: 'NG-ON' },
  { country_code: 'NG', subdivision_name: 'Osun', code: 'NG-OS' },
  { country_code: 'NG', subdivision_name: 'Oyo', code: 'NG-OY' },
  { country_code: 'NG', subdivision_name: 'Plateau', code: 'NG-PL' },
  { country_code: 'NG', subdivision_name: 'Rivers', code: 'NG-RI' },
  { country_code: 'NG', subdivision_name: 'Sokoto', code: 'NG-SO' },
  { country_code: 'NG', subdivision_name: 'Taraba', code: 'NG-TA' },
  { country_code: 'NG', subdivision_name: 'Yobe', code: 'NG-YO' },
  { country_code: 'NG', subdivision_name: 'Zamfara', code: 'NG-ZA' },
  { country_code: 'NI', subdivision_name: 'Boaco', code: 'NI-BO' },
  { country_code: 'NI', subdivision_name: 'Carazo', code: 'NI-CA' },
  { country_code: 'NI', subdivision_name: 'Chinandega', code: 'NI-CI' },
  { country_code: 'NI', subdivision_name: 'Chontales', code: 'NI-CO' },
  { country_code: 'NI', subdivision_name: 'Costa Caribe Norte', code: 'NI-AN' },
  { country_code: 'NI', subdivision_name: 'Costa Caribe Sur', code: 'NI-AS' },
  { country_code: 'NI', subdivision_name: 'Esteli', code: 'NI-ES' },
  { country_code: 'NI', subdivision_name: 'Granada', code: 'NI-GR' },
  { country_code: 'NI', subdivision_name: 'Jinotega', code: 'NI-JI' },
  { country_code: 'NI', subdivision_name: 'Leon', code: 'NI-LE' },
  { country_code: 'NI', subdivision_name: 'Madriz', code: 'NI-MD' },
  { country_code: 'NI', subdivision_name: 'Managua', code: 'NI-MN' },
  { country_code: 'NI', subdivision_name: 'Masaya', code: 'NI-MS' },
  { country_code: 'NI', subdivision_name: 'Matagalpa', code: 'NI-MT' },
  { country_code: 'NI', subdivision_name: 'Nueva Segovia', code: 'NI-NS' },
  { country_code: 'NI', subdivision_name: 'Rio San Juan', code: 'NI-SJ' },
  { country_code: 'NI', subdivision_name: 'Rivas', code: 'NI-RI' },
  { country_code: 'NL', subdivision_name: 'Drenthe', code: 'NL-DR' },
  { country_code: 'NL', subdivision_name: 'Flevoland', code: 'NL-FL' },
  { country_code: 'NL', subdivision_name: 'Fryslan', code: 'NL-FR' },
  { country_code: 'NL', subdivision_name: 'Gelderland', code: 'NL-GE' },
  { country_code: 'NL', subdivision_name: 'Groningen', code: 'NL-GR' },
  { country_code: 'NL', subdivision_name: 'Limburg', code: 'NL-LI' },
  { country_code: 'NL', subdivision_name: 'Noord-Brabant', code: 'NL-NB' },
  { country_code: 'NL', subdivision_name: 'Noord-Holland', code: 'NL-NH' },
  { country_code: 'NL', subdivision_name: 'Overijssel', code: 'NL-OV' },
  { country_code: 'NL', subdivision_name: 'Utrecht', code: 'NL-UT' },
  { country_code: 'NL', subdivision_name: 'Zeeland', code: 'NL-ZE' },
  { country_code: 'NL', subdivision_name: 'Zuid-Holland', code: 'NL-ZH' },
  { country_code: 'NO', subdivision_name: 'Akershus', code: 'NO-02' },
  { country_code: 'NO', subdivision_name: 'Aust-Agder', code: 'NO-09' },
  { country_code: 'NO', subdivision_name: 'Buskerud', code: 'NO-06' },
  { country_code: 'NO', subdivision_name: 'Finnmark', code: 'NO-20' },
  { country_code: 'NO', subdivision_name: 'Hedmark', code: 'NO-04' },
  { country_code: 'NO', subdivision_name: 'Hordaland', code: 'NO-12' },
  { country_code: 'NO', subdivision_name: 'More og Romsdal', code: 'NO-15' },
  { country_code: 'NO', subdivision_name: 'Nord-Trondelag', code: 'NO-17' },
  { country_code: 'NO', subdivision_name: 'Nordland', code: 'NO-18' },
  { country_code: 'NO', subdivision_name: 'Oppland', code: 'NO-05' },
  { country_code: 'NO', subdivision_name: 'Oslo', code: 'NO-03' },
  { country_code: 'NO', subdivision_name: 'Ostfold', code: 'NO-01' },
  { country_code: 'NO', subdivision_name: 'Rogaland', code: 'NO-11' },
  { country_code: 'NO', subdivision_name: 'Sogn og Fjordane', code: 'NO-14' },
  { country_code: 'NO', subdivision_name: 'Sor-Trondelag', code: 'NO-16' },
  { country_code: 'NO', subdivision_name: 'Telemark', code: 'NO-08' },
  { country_code: 'NO', subdivision_name: 'Troms', code: 'NO-19' },
  { country_code: 'NO', subdivision_name: 'Vest-Agder', code: 'NO-10' },
  { country_code: 'NO', subdivision_name: 'Vestfold', code: 'NO-07' },
  { country_code: 'NP', subdivision_name: 'Bagmati', code: 'NP-BA' },
  { country_code: 'NP', subdivision_name: 'Bheri', code: 'NP-BH' },
  { country_code: 'NP', subdivision_name: 'Dhawalagiri', code: 'NP-DH' },
  { country_code: 'NP', subdivision_name: 'Gandaki', code: 'NP-GA' },
  { country_code: 'NP', subdivision_name: 'Janakpur', code: 'NP-JA' },
  { country_code: 'NP', subdivision_name: 'Kosi', code: 'NP-KO' },
  { country_code: 'NP', subdivision_name: 'Lumbini', code: 'NP-LU' },
  { country_code: 'NP', subdivision_name: 'Mahakali', code: 'NP-MA' },
  { country_code: 'NP', subdivision_name: 'Mechi', code: 'NP-ME' },
  { country_code: 'NP', subdivision_name: 'Narayani', code: 'NP-NA' },
  { country_code: 'NP', subdivision_name: 'Rapti', code: 'NP-RA' },
  { country_code: 'NP', subdivision_name: 'Sagarmatha', code: 'NP-SA' },
  { country_code: 'NP', subdivision_name: 'Seti', code: 'NP-SE' },
  { country_code: 'NR', subdivision_name: 'Yaren', code: 'NR-14' },
  { country_code: 'NU', subdivision_name: 'Niue', code: '-' },
  { country_code: 'NZ', subdivision_name: 'Auckland', code: 'NZ-AUK' },
  { country_code: 'NZ', subdivision_name: 'Bay of Plenty', code: 'NZ-BOP' },
  { country_code: 'NZ', subdivision_name: 'Canterbury', code: 'NZ-CAN' },
  { country_code: 'NZ', subdivision_name: 'Chatham Islands Territory', code: 'NZ-CIT' },
  { country_code: 'NZ', subdivision_name: 'Gisborne', code: 'NZ-GIS' },
  { country_code: 'NZ', subdivision_name: "Hawke's Bay", code: 'NZ-HKB' },
  { country_code: 'NZ', subdivision_name: 'Manawatu-Wanganui', code: 'NZ-MWT' },
  { country_code: 'NZ', subdivision_name: 'Marlborough', code: 'NZ-MBH' },
  { country_code: 'NZ', subdivision_name: 'Nelson', code: 'NZ-NSN' },
  { country_code: 'NZ', subdivision_name: 'Northland', code: 'NZ-NTL' },
  { country_code: 'NZ', subdivision_name: 'Otago', code: 'NZ-OTA' },
  { country_code: 'NZ', subdivision_name: 'Southland', code: 'NZ-STL' },
  { country_code: 'NZ', subdivision_name: 'Taranaki', code: 'NZ-TKI' },
  { country_code: 'NZ', subdivision_name: 'Tasman', code: 'NZ-TAS' },
  { country_code: 'NZ', subdivision_name: 'Waikato', code: 'NZ-WKO' },
  { country_code: 'NZ', subdivision_name: 'Wellington', code: 'NZ-WGN' },
  { country_code: 'NZ', subdivision_name: 'West Coast', code: 'NZ-WTC' },
  { country_code: 'OM', subdivision_name: 'Ad Dakhiliyah', code: 'OM-DA' },
  { country_code: 'OM', subdivision_name: 'Al Buraymi', code: 'OM-BU' },
  { country_code: 'OM', subdivision_name: 'Al Wusta', code: 'OM-WU' },
  { country_code: 'OM', subdivision_name: 'Az Zahirah', code: 'OM-ZA' },
  { country_code: 'OM', subdivision_name: 'Janub al Batinah', code: 'OM-BJ' },
  { country_code: 'OM', subdivision_name: 'Janub ash Sharqiyah', code: 'OM-SJ' },
  { country_code: 'OM', subdivision_name: 'Masqat', code: 'OM-MA' },
  { country_code: 'OM', subdivision_name: 'Musandam', code: 'OM-MU' },
  { country_code: 'OM', subdivision_name: 'Shamal al Batinah', code: 'OM-BS' },
  { country_code: 'OM', subdivision_name: 'Shamal ash Sharqiyah', code: 'OM-SS' },
  { country_code: 'OM', subdivision_name: 'Zufar', code: 'OM-ZU' },
  { country_code: 'PA', subdivision_name: 'Bocas del Toro', code: 'PA-1' },
  { country_code: 'PA', subdivision_name: 'Chiriqui', code: 'PA-4' },
  { country_code: 'PA', subdivision_name: 'Cocle', code: 'PA-2' },
  { country_code: 'PA', subdivision_name: 'Colon', code: 'PA-3' },
  { country_code: 'PA', subdivision_name: 'Herrera', code: 'PA-6' },
  { country_code: 'PA', subdivision_name: 'Los Santos', code: 'PA-7' },
  { country_code: 'PA', subdivision_name: 'Ngobe-Bugle', code: 'PA-NB' },
  { country_code: 'PA', subdivision_name: 'Panama', code: 'PA-8' },
  { country_code: 'PA', subdivision_name: 'Veraguas', code: 'PA-9' },
  { country_code: 'PE', subdivision_name: 'Amazonas', code: 'PE-AMA' },
  { country_code: 'PE', subdivision_name: 'Ancash', code: 'PE-ANC' },
  { country_code: 'PE', subdivision_name: 'Apurimac', code: 'PE-APU' },
  { country_code: 'PE', subdivision_name: 'Arequipa', code: 'PE-ARE' },
  { country_code: 'PE', subdivision_name: 'Ayacucho', code: 'PE-AYA' },
  { country_code: 'PE', subdivision_name: 'Cajamarca', code: 'PE-CAJ' },
  { country_code: 'PE', subdivision_name: 'Cusco', code: 'PE-CUS' },
  { country_code: 'PE', subdivision_name: 'El Callao', code: 'PE-CAL' },
  { country_code: 'PE', subdivision_name: 'Huancavelica', code: 'PE-HUV' },
  { country_code: 'PE', subdivision_name: 'Huanuco', code: 'PE-HUC' },
  { country_code: 'PE', subdivision_name: 'Ica', code: 'PE-ICA' },
  { country_code: 'PE', subdivision_name: 'Junin', code: 'PE-JUN' },
  { country_code: 'PE', subdivision_name: 'La Libertad', code: 'PE-LAL' },
  { country_code: 'PE', subdivision_name: 'Lambayeque', code: 'PE-LAM' },
  { country_code: 'PE', subdivision_name: 'Lima', code: 'PE-LIM' },
  { country_code: 'PE', subdivision_name: 'Loreto', code: 'PE-LOR' },
  { country_code: 'PE', subdivision_name: 'Madre de Dios', code: 'PE-MDD' },
  { country_code: 'PE', subdivision_name: 'Moquegua', code: 'PE-MOQ' },
  { country_code: 'PE', subdivision_name: 'Pasco', code: 'PE-PAS' },
  { country_code: 'PE', subdivision_name: 'Piura', code: 'PE-PIU' },
  { country_code: 'PE', subdivision_name: 'Puno', code: 'PE-PUN' },
  { country_code: 'PE', subdivision_name: 'San Martin', code: 'PE-SAM' },
  { country_code: 'PE', subdivision_name: 'Tacna', code: 'PE-TAC' },
  { country_code: 'PE', subdivision_name: 'Tumbes', code: 'PE-TUM' },
  { country_code: 'PE', subdivision_name: 'Ucayali', code: 'PE-UCA' },
  { country_code: 'PF', subdivision_name: 'Iles Marquises', code: '-' },
  { country_code: 'PF', subdivision_name: 'Iles Sous-le-Vent', code: '-' },
  { country_code: 'PF', subdivision_name: 'Iles Tuamotu-Gambier', code: '-' },
  { country_code: 'PF', subdivision_name: 'Iles du Vent', code: '-' },
  { country_code: 'PG', subdivision_name: 'Bougainville', code: 'PG-NSB' },
  { country_code: 'PG', subdivision_name: 'Central', code: 'PG-CPM' },
  { country_code: 'PG', subdivision_name: 'Chimbu', code: 'PG-CPK' },
  { country_code: 'PG', subdivision_name: 'East New Britain', code: 'PG-EBR' },
  { country_code: 'PG', subdivision_name: 'East Sepik', code: 'PG-ESW' },
  { country_code: 'PG', subdivision_name: 'Eastern Highlands', code: 'PG-EHG' },
  { country_code: 'PG', subdivision_name: 'Madang', code: 'PG-MPM' },
  { country_code: 'PG', subdivision_name: 'Manus', code: 'PG-MRL' },
  { country_code: 'PG', subdivision_name: 'Milne Bay', code: 'PG-MBA' },
  { country_code: 'PG', subdivision_name: 'Morobe', code: 'PG-MPL' },
  { country_code: 'PG', subdivision_name: 'National Capital District (Port Moresby)', code: 'PG-NCD' },
  { country_code: 'PG', subdivision_name: 'New Ireland', code: 'PG-NIK' },
  { country_code: 'PG', subdivision_name: 'Southern Highlands', code: 'PG-SHM' },
  { country_code: 'PG', subdivision_name: 'West New Britain', code: 'PG-WBK' },
  { country_code: 'PG', subdivision_name: 'Western', code: 'PG-WPD' },
  { country_code: 'PG', subdivision_name: 'Western Highlands', code: 'PG-WHM' },
  { country_code: 'PH', subdivision_name: 'Abra', code: 'PH-ABR' },
  { country_code: 'PH', subdivision_name: 'Agusan del Norte', code: 'PH-AGN' },
  { country_code: 'PH', subdivision_name: 'Agusan del Sur', code: 'PH-AGS' },
  { country_code: 'PH', subdivision_name: 'Aklan', code: 'PH-AKL' },
  { country_code: 'PH', subdivision_name: 'Albay', code: 'PH-ALB' },
  { country_code: 'PH', subdivision_name: 'Antique', code: 'PH-ANT' },
  { country_code: 'PH', subdivision_name: 'Apayao', code: 'PH-APA' },
  { country_code: 'PH', subdivision_name: 'Aurora', code: 'PH-AUR' },
  { country_code: 'PH', subdivision_name: 'Basilan', code: 'PH-BAS' },
  { country_code: 'PH', subdivision_name: 'Bataan', code: 'PH-BAN' },
  { country_code: 'PH', subdivision_name: 'Batanes', code: 'PH-BTN' },
  { country_code: 'PH', subdivision_name: 'Batangas', code: 'PH-BTG' },
  { country_code: 'PH', subdivision_name: 'Benguet', code: 'PH-BEN' },
  { country_code: 'PH', subdivision_name: 'Biliran', code: 'PH-BIL' },
  { country_code: 'PH', subdivision_name: 'Bohol', code: 'PH-BOH' },
  { country_code: 'PH', subdivision_name: 'Bukidnon', code: 'PH-BUK' },
  { country_code: 'PH', subdivision_name: 'Bulacan', code: 'PH-BUL' },
  { country_code: 'PH', subdivision_name: 'Cagayan', code: 'PH-CAG' },
  { country_code: 'PH', subdivision_name: 'Camarines Norte', code: 'PH-CAN' },
  { country_code: 'PH', subdivision_name: 'Camarines Sur', code: 'PH-CAS' },
  { country_code: 'PH', subdivision_name: 'Camiguin', code: 'PH-CAM' },
  { country_code: 'PH', subdivision_name: 'Capiz', code: 'PH-CAP' },
  { country_code: 'PH', subdivision_name: 'Catanduanes', code: 'PH-CAT' },
  { country_code: 'PH', subdivision_name: 'Cavite', code: 'PH-CAV' },
  { country_code: 'PH', subdivision_name: 'Cebu', code: 'PH-CEB' },
  { country_code: 'PH', subdivision_name: 'Compostela Valley', code: 'PH-COM' },
  { country_code: 'PH', subdivision_name: 'Cotabato', code: 'PH-NCO' },
  { country_code: 'PH', subdivision_name: 'Davao Oriental', code: 'PH-DAO' },
  { country_code: 'PH', subdivision_name: 'Davao del Norte', code: 'PH-DAV' },
  { country_code: 'PH', subdivision_name: 'Davao del Sur', code: 'PH-DAS' },
  { country_code: 'PH', subdivision_name: 'Dinagat Islands', code: 'PH-DIN' },
  { country_code: 'PH', subdivision_name: 'Eastern Samar', code: 'PH-EAS' },
  { country_code: 'PH', subdivision_name: 'Guimaras', code: 'PH-GUI' },
  { country_code: 'PH', subdivision_name: 'Ifugao', code: 'PH-IFU' },
  { country_code: 'PH', subdivision_name: 'Ilocos Norte', code: 'PH-ILN' },
  { country_code: 'PH', subdivision_name: 'Ilocos Sur', code: 'PH-ILS' },
  { country_code: 'PH', subdivision_name: 'Iloilo', code: 'PH-ILI' },
  { country_code: 'PH', subdivision_name: 'Isabela', code: 'PH-ISA' },
  { country_code: 'PH', subdivision_name: 'La Union', code: 'PH-LUN' },
  { country_code: 'PH', subdivision_name: 'Laguna', code: 'PH-LAG' },
  { country_code: 'PH', subdivision_name: 'Lanao del Norte', code: 'PH-LAN' },
  { country_code: 'PH', subdivision_name: 'Lanao del Sur', code: 'PH-LAS' },
  { country_code: 'PH', subdivision_name: 'Leyte', code: 'PH-LEY' },
  { country_code: 'PH', subdivision_name: 'Maguindanao', code: 'PH-MAG' },
  { country_code: 'PH', subdivision_name: 'Marinduque', code: 'PH-MAD' },
  { country_code: 'PH', subdivision_name: 'Masbate', code: 'PH-MAS' },
  { country_code: 'PH', subdivision_name: 'Mindoro Occidental', code: 'PH-MDC' },
  { country_code: 'PH', subdivision_name: 'Mindoro Oriental', code: 'PH-MDR' },
  { country_code: 'PH', subdivision_name: 'Misamis Occidental', code: 'PH-MSC' },
  { country_code: 'PH', subdivision_name: 'Misamis Oriental', code: 'PH-MSR' },
  { country_code: 'PH', subdivision_name: 'Mountain Province', code: 'PH-MOU' },
  { country_code: 'PH', subdivision_name: 'National Capital Region', code: 'PH-00' },
  { country_code: 'PH', subdivision_name: 'Negros Occidental', code: 'PH-NEC' },
  { country_code: 'PH', subdivision_name: 'Negros Oriental', code: 'PH-NER' },
  { country_code: 'PH', subdivision_name: 'Northern Samar', code: 'PH-NSA' },
  { country_code: 'PH', subdivision_name: 'Nueva Ecija', code: 'PH-NUE' },
  { country_code: 'PH', subdivision_name: 'Nueva Vizcaya', code: 'PH-NUV' },
  { country_code: 'PH', subdivision_name: 'Palawan', code: 'PH-PLW' },
  { country_code: 'PH', subdivision_name: 'Pampanga', code: 'PH-PAM' },
  { country_code: 'PH', subdivision_name: 'Pangasinan', code: 'PH-PAN' },
  { country_code: 'PH', subdivision_name: 'Quezon', code: 'PH-QUE' },
  { country_code: 'PH', subdivision_name: 'Quirino', code: 'PH-QUI' },
  { country_code: 'PH', subdivision_name: 'Rizal', code: 'PH-RIZ' },
  { country_code: 'PH', subdivision_name: 'Romblon', code: 'PH-ROM' },
  { country_code: 'PH', subdivision_name: 'Samar', code: 'PH-WSA' },
  { country_code: 'PH', subdivision_name: 'Sarangani', code: 'PH-SAR' },
  { country_code: 'PH', subdivision_name: 'Siquijor', code: 'PH-SIG' },
  { country_code: 'PH', subdivision_name: 'Sorsogon', code: 'PH-SOR' },
  { country_code: 'PH', subdivision_name: 'South Cotabato', code: 'PH-SCO' },
  { country_code: 'PH', subdivision_name: 'Southern Leyte', code: 'PH-SLE' },
  { country_code: 'PH', subdivision_name: 'Sultan Kudarat', code: 'PH-SUK' },
  { country_code: 'PH', subdivision_name: 'Sulu', code: 'PH-SLU' },
  { country_code: 'PH', subdivision_name: 'Surigao del Norte', code: 'PH-SUN' },
  { country_code: 'PH', subdivision_name: 'Surigao del Sur', code: 'PH-SUR' },
  { country_code: 'PH', subdivision_name: 'Tarlac', code: 'PH-TAR' },
  { country_code: 'PH', subdivision_name: 'Tawi-Tawi', code: 'PH-TAW' },
  { country_code: 'PH', subdivision_name: 'Zambales', code: 'PH-ZMB' },
  { country_code: 'PH', subdivision_name: 'Zamboanga Sibugay', code: 'PH-ZSI' },
  { country_code: 'PH', subdivision_name: 'Zamboanga del Norte', code: 'PH-ZAN' },
  { country_code: 'PH', subdivision_name: 'Zamboanga del Sur', code: 'PH-ZAS' },
  { country_code: 'PK', subdivision_name: 'Azad Jammu and Kashmir', code: 'PK-JK' },
  { country_code: 'PK', subdivision_name: 'Balochistan', code: 'PK-BA' },
  { country_code: 'PK', subdivision_name: 'Federally Administered Tribal Areas', code: 'PK-TA' },
  { country_code: 'PK', subdivision_name: 'Gilgit-Baltistan', code: 'PK-GB' },
  { country_code: 'PK', subdivision_name: 'Islamabad', code: 'PK-IS' },
  { country_code: 'PK', subdivision_name: 'Khyber Pakhtunkhwa', code: 'PK-KP' },
  { country_code: 'PK', subdivision_name: 'Punjab', code: 'PK-PB' },
  { country_code: 'PK', subdivision_name: 'Sindh', code: 'PK-SD' },
  { country_code: 'PL', subdivision_name: 'Dolnoslaskie', code: 'PL-02' },
  { country_code: 'PL', subdivision_name: 'Kujawsko-pomorskie', code: 'PL-04' },
  { country_code: 'PL', subdivision_name: 'Lodzkie', code: 'PL-10' },
  { country_code: 'PL', subdivision_name: 'Lubelskie', code: 'PL-06' },
  { country_code: 'PL', subdivision_name: 'Lubuskie', code: 'PL-08' },
  { country_code: 'PL', subdivision_name: 'Malopolskie', code: 'PL-12' },
  { country_code: 'PL', subdivision_name: 'Mazowieckie', code: 'PL-14' },
  { country_code: 'PL', subdivision_name: 'Opolskie', code: 'PL-16' },
  { country_code: 'PL', subdivision_name: 'Podkarpackie', code: 'PL-18' },
  { country_code: 'PL', subdivision_name: 'Podlaskie', code: 'PL-20' },
  { country_code: 'PL', subdivision_name: 'Pomorskie', code: 'PL-22' },
  { country_code: 'PL', subdivision_name: 'Slaskie', code: 'PL-24' },
  { country_code: 'PL', subdivision_name: 'Swietokrzyskie', code: 'PL-26' },
  { country_code: 'PL', subdivision_name: 'Warminsko-mazurskie', code: 'PL-28' },
  { country_code: 'PL', subdivision_name: 'Wielkopolskie', code: 'PL-30' },
  { country_code: 'PL', subdivision_name: 'Zachodniopomorskie', code: 'PL-32' },
  { country_code: 'PM', subdivision_name: 'Saint Pierre and Miquelon', code: '-' },
  { country_code: 'PN', subdivision_name: 'Pitcairn', code: '-' },
  { country_code: 'PR', subdivision_name: 'Adjuntas', code: '-' },
  { country_code: 'PR', subdivision_name: 'Aguada', code: '-' },
  { country_code: 'PR', subdivision_name: 'Aguadilla', code: '-' },
  { country_code: 'PR', subdivision_name: 'Aguas Buenas', code: '-' },
  { country_code: 'PR', subdivision_name: 'Aibonito', code: '-' },
  { country_code: 'PR', subdivision_name: 'Anasco', code: '-' },
  { country_code: 'PR', subdivision_name: 'Arecibo', code: '-' },
  { country_code: 'PR', subdivision_name: 'Arroyo', code: '-' },
  { country_code: 'PR', subdivision_name: 'Barceloneta', code: '-' },
  { country_code: 'PR', subdivision_name: 'Barranquitas', code: '-' },
  { country_code: 'PR', subdivision_name: 'Bayamon', code: '-' },
  { country_code: 'PR', subdivision_name: 'Cabo Rojo', code: '-' },
  { country_code: 'PR', subdivision_name: 'Caguas', code: '-' },
  { country_code: 'PR', subdivision_name: 'Camuy', code: '-' },
  { country_code: 'PR', subdivision_name: 'Canovanas', code: '-' },
  { country_code: 'PR', subdivision_name: 'Carolina', code: '-' },
  { country_code: 'PR', subdivision_name: 'Catano', code: '-' },
  { country_code: 'PR', subdivision_name: 'Cayey', code: '-' },
  { country_code: 'PR', subdivision_name: 'Ceiba', code: '-' },
  { country_code: 'PR', subdivision_name: 'Ciales', code: '-' },
  { country_code: 'PR', subdivision_name: 'Cidra', code: '-' },
  { country_code: 'PR', subdivision_name: 'Coamo', code: '-' },
  { country_code: 'PR', subdivision_name: 'Comerio', code: '-' },
  { country_code: 'PR', subdivision_name: 'Corozal', code: '-' },
  { country_code: 'PR', subdivision_name: 'Culebra', code: '-' },
  { country_code: 'PR', subdivision_name: 'Dorado', code: '-' },
  { country_code: 'PR', subdivision_name: 'Fajardo', code: '-' },
  { country_code: 'PR', subdivision_name: 'Florida', code: '-' },
  { country_code: 'PR', subdivision_name: 'Guanica', code: '-' },
  { country_code: 'PR', subdivision_name: 'Guayama', code: '-' },
  { country_code: 'PR', subdivision_name: 'Guayanilla', code: '-' },
  { country_code: 'PR', subdivision_name: 'Guaynabo', code: '-' },
  { country_code: 'PR', subdivision_name: 'Gurabo', code: '-' },
  { country_code: 'PR', subdivision_name: 'Hatillo', code: '-' },
  { country_code: 'PR', subdivision_name: 'Hormigueros', code: '-' },
  { country_code: 'PR', subdivision_name: 'Humacao', code: '-' },
  { country_code: 'PR', subdivision_name: 'Isabela', code: '-' },
  { country_code: 'PR', subdivision_name: 'Juana Diaz', code: '-' },
  { country_code: 'PR', subdivision_name: 'Lajas', code: '-' },
  { country_code: 'PR', subdivision_name: 'Lares', code: '-' },
  { country_code: 'PR', subdivision_name: 'Las Marias', code: '-' },
  { country_code: 'PR', subdivision_name: 'Las Piedras', code: '-' },
  { country_code: 'PR', subdivision_name: 'Loiza', code: '-' },
  { country_code: 'PR', subdivision_name: 'Luquillo', code: '-' },
  { country_code: 'PR', subdivision_name: 'Manati', code: '-' },
  { country_code: 'PR', subdivision_name: 'Maricao', code: '-' },
  { country_code: 'PR', subdivision_name: 'Mayaguez', code: '-' },
  { country_code: 'PR', subdivision_name: 'Moca', code: '-' },
  { country_code: 'PR', subdivision_name: 'Morovis', code: '-' },
  { country_code: 'PR', subdivision_name: 'Municipio de Jayuya', code: '-' },
  { country_code: 'PR', subdivision_name: 'Municipio de Juncos', code: '-' },
  { country_code: 'PR', subdivision_name: 'Naguabo', code: '-' },
  { country_code: 'PR', subdivision_name: 'Naranjito', code: '-' },
  { country_code: 'PR', subdivision_name: 'Patillas', code: '-' },
  { country_code: 'PR', subdivision_name: 'Penuelas', code: '-' },
  { country_code: 'PR', subdivision_name: 'Ponce', code: '-' },
  { country_code: 'PR', subdivision_name: 'Quebradillas', code: '-' },
  { country_code: 'PR', subdivision_name: 'Rincon', code: '-' },
  { country_code: 'PR', subdivision_name: 'Rio Grande', code: '-' },
  { country_code: 'PR', subdivision_name: 'Sabana Grande', code: '-' },
  { country_code: 'PR', subdivision_name: 'Salinas', code: '-' },
  { country_code: 'PR', subdivision_name: 'San German', code: '-' },
  { country_code: 'PR', subdivision_name: 'San Juan', code: '-' },
  { country_code: 'PR', subdivision_name: 'San Lorenzo', code: '-' },
  { country_code: 'PR', subdivision_name: 'San Sebastian', code: '-' },
  { country_code: 'PR', subdivision_name: 'Santa Isabel Municipio', code: '-' },
  { country_code: 'PR', subdivision_name: 'Toa Alta', code: '-' },
  { country_code: 'PR', subdivision_name: 'Toa Baja', code: '-' },
  { country_code: 'PR', subdivision_name: 'Trujillo Alto', code: '-' },
  { country_code: 'PR', subdivision_name: 'Utuado', code: '-' },
  { country_code: 'PR', subdivision_name: 'Vega Alta', code: '-' },
  { country_code: 'PR', subdivision_name: 'Vega Baja', code: '-' },
  { country_code: 'PR', subdivision_name: 'Vieques', code: '-' },
  { country_code: 'PR', subdivision_name: 'Villalba', code: '-' },
  { country_code: 'PR', subdivision_name: 'Yabucoa', code: '-' },
  { country_code: 'PR', subdivision_name: 'Yauco', code: '-' },
  { country_code: 'PS', subdivision_name: 'Bethlehem', code: 'PS-BTH' },
  { country_code: 'PS', subdivision_name: 'Gaza', code: 'PS-GZA' },
  { country_code: 'PS', subdivision_name: 'Hebron', code: 'PS-HBN' },
  { country_code: 'PS', subdivision_name: 'Jenin', code: 'PS-JEN' },
  { country_code: 'PS', subdivision_name: 'Jericho and Al Aghwar', code: 'PS-JRH' },
  { country_code: 'PS', subdivision_name: 'Jerusalem', code: 'PS-JEM' },
  { country_code: 'PS', subdivision_name: 'Nablus', code: 'PS-NBS' },
  { country_code: 'PS', subdivision_name: 'Qalqilya', code: 'PS-QQA' },
  { country_code: 'PS', subdivision_name: 'Ramallah', code: 'PS-RBH' },
  { country_code: 'PS', subdivision_name: 'Salfit', code: 'PS-SLT' },
  { country_code: 'PS', subdivision_name: 'Tubas', code: 'PS-TBS' },
  { country_code: 'PS', subdivision_name: 'Tulkarm', code: 'PS-TKM' },
  { country_code: 'PT', subdivision_name: 'Aveiro', code: 'PT-01' },
  { country_code: 'PT', subdivision_name: 'Beja', code: 'PT-02' },
  { country_code: 'PT', subdivision_name: 'Braga', code: 'PT-03' },
  { country_code: 'PT', subdivision_name: 'Braganca', code: 'PT-04' },
  { country_code: 'PT', subdivision_name: 'Castelo Branco', code: 'PT-05' },
  { country_code: 'PT', subdivision_name: 'Coimbra', code: 'PT-06' },
  { country_code: 'PT', subdivision_name: 'Evora', code: 'PT-07' },
  { country_code: 'PT', subdivision_name: 'Faro', code: 'PT-08' },
  { country_code: 'PT', subdivision_name: 'Guarda', code: 'PT-09' },
  { country_code: 'PT', subdivision_name: 'Leiria', code: 'PT-10' },
  { country_code: 'PT', subdivision_name: 'Lisboa', code: 'PT-11' },
  { country_code: 'PT', subdivision_name: 'Portalegre', code: 'PT-12' },
  { country_code: 'PT', subdivision_name: 'Porto', code: 'PT-13' },
  { country_code: 'PT', subdivision_name: 'Regiao Autonoma da Madeira', code: 'PT-30' },
  { country_code: 'PT', subdivision_name: 'Regiao Autonoma dos Acores', code: 'PT-20' },
  { country_code: 'PT', subdivision_name: 'Santarem', code: 'PT-14' },
  { country_code: 'PT', subdivision_name: 'Setubal', code: 'PT-15' },
  { country_code: 'PT', subdivision_name: 'Viana do Castelo', code: 'PT-16' },
  { country_code: 'PT', subdivision_name: 'Vila Real', code: 'PT-17' },
  { country_code: 'PT', subdivision_name: 'Viseu', code: 'PT-18' },
  { country_code: 'PW', subdivision_name: 'Airai', code: 'PW-004' },
  { country_code: 'PW', subdivision_name: 'Kayangel', code: 'PW-100' },
  { country_code: 'PW', subdivision_name: 'Koror', code: 'PW-150' },
  { country_code: 'PW', subdivision_name: 'Melekeok', code: 'PW-212' },
  { country_code: 'PW', subdivision_name: 'Ngaraard', code: 'PW-214' },
  { country_code: 'PW', subdivision_name: 'Ngardmau', code: 'PW-222' },
  { country_code: 'PY', subdivision_name: 'Alto Paraguay', code: 'PY-16' },
  { country_code: 'PY', subdivision_name: 'Alto Parana', code: 'PY-10' },
  { country_code: 'PY', subdivision_name: 'Amambay', code: 'PY-13' },
  { country_code: 'PY', subdivision_name: 'Asuncion', code: 'PY-ASU' },
  { country_code: 'PY', subdivision_name: 'Boqueron', code: 'PY-19' },
  { country_code: 'PY', subdivision_name: 'Caaguazu', code: 'PY-5' },
  { country_code: 'PY', subdivision_name: 'Caazapa', code: 'PY-6' },
  { country_code: 'PY', subdivision_name: 'Canindeyu', code: 'PY-14' },
  { country_code: 'PY', subdivision_name: 'Central', code: 'PY-11' },
  { country_code: 'PY', subdivision_name: 'Concepcion', code: 'PY-1' },
  { country_code: 'PY', subdivision_name: 'Cordillera', code: 'PY-3' },
  { country_code: 'PY', subdivision_name: 'Guaira', code: 'PY-4' },
  { country_code: 'PY', subdivision_name: 'Itapua', code: 'PY-7' },
  { country_code: 'PY', subdivision_name: 'Misiones', code: 'PY-8' },
  { country_code: 'PY', subdivision_name: 'Neembucu', code: 'PY-12' },
  { country_code: 'PY', subdivision_name: 'Paraguari', code: 'PY-9' },
  { country_code: 'PY', subdivision_name: 'Presidente Hayes', code: 'PY-15' },
  { country_code: 'PY', subdivision_name: 'San Pedro', code: 'PY-2' },
  { country_code: 'QA', subdivision_name: 'Ad Dawhah', code: 'QA-DA' },
  { country_code: 'QA', subdivision_name: 'Al Khawr wa adh Dhakhirah', code: 'QA-KH' },
  { country_code: 'QA', subdivision_name: 'Al Wakrah', code: 'QA-WA' },
  { country_code: 'QA', subdivision_name: 'Ar Rayyan', code: 'QA-RA' },
  { country_code: 'QA', subdivision_name: 'Ash Shamal', code: 'QA-MS' },
  { country_code: 'QA', subdivision_name: "Az Za'ayin", code: 'QA-ZA' },
  { country_code: 'QA', subdivision_name: 'Umm Salal', code: 'QA-US' },
  { country_code: 'RE', subdivision_name: 'Reunion', code: '-' },
  { country_code: 'RO', subdivision_name: 'Alba', code: 'RO-AB' },
  { country_code: 'RO', subdivision_name: 'Arad', code: 'RO-AR' },
  { country_code: 'RO', subdivision_name: 'Arges', code: 'RO-AG' },
  { country_code: 'RO', subdivision_name: 'Bacau', code: 'RO-BC' },
  { country_code: 'RO', subdivision_name: 'Bihor', code: 'RO-BH' },
  { country_code: 'RO', subdivision_name: 'Bistrita-Nasaud', code: 'RO-BN' },
  { country_code: 'RO', subdivision_name: 'Botosani', code: 'RO-BT' },
  { country_code: 'RO', subdivision_name: 'Braila', code: 'RO-BR' },
  { country_code: 'RO', subdivision_name: 'Brasov', code: 'RO-BV' },
  { country_code: 'RO', subdivision_name: 'Bucuresti', code: 'RO-B' },
  { country_code: 'RO', subdivision_name: 'Buzau', code: 'RO-BZ' },
  { country_code: 'RO', subdivision_name: 'Calarasi', code: 'RO-CL' },
  { country_code: 'RO', subdivision_name: 'Caras-Severin', code: 'RO-CS' },
  { country_code: 'RO', subdivision_name: 'Cluj', code: 'RO-CJ' },
  { country_code: 'RO', subdivision_name: 'Constanta', code: 'RO-CT' },
  { country_code: 'RO', subdivision_name: 'Covasna', code: 'RO-CV' },
  { country_code: 'RO', subdivision_name: 'Dambovita', code: 'RO-DB' },
  { country_code: 'RO', subdivision_name: 'Dolj', code: 'RO-DJ' },
  { country_code: 'RO', subdivision_name: 'Galati', code: 'RO-GL' },
  { country_code: 'RO', subdivision_name: 'Giurgiu', code: 'RO-GR' },
  { country_code: 'RO', subdivision_name: 'Gorj', code: 'RO-GJ' },
  { country_code: 'RO', subdivision_name: 'Harghita', code: 'RO-HR' },
  { country_code: 'RO', subdivision_name: 'Hunedoara', code: 'RO-HD' },
  { country_code: 'RO', subdivision_name: 'Ialomita', code: 'RO-IL' },
  { country_code: 'RO', subdivision_name: 'Iasi', code: 'RO-IS' },
  { country_code: 'RO', subdivision_name: 'Ilfov', code: 'RO-IF' },
  { country_code: 'RO', subdivision_name: 'Maramures', code: 'RO-MM' },
  { country_code: 'RO', subdivision_name: 'Mehedinti', code: 'RO-MH' },
  { country_code: 'RO', subdivision_name: 'Mures', code: 'RO-MS' },
  { country_code: 'RO', subdivision_name: 'Neamt', code: 'RO-NT' },
  { country_code: 'RO', subdivision_name: 'Olt', code: 'RO-OT' },
  { country_code: 'RO', subdivision_name: 'Prahova', code: 'RO-PH' },
  { country_code: 'RO', subdivision_name: 'Salaj', code: 'RO-SJ' },
  { country_code: 'RO', subdivision_name: 'Satu Mare', code: 'RO-SM' },
  { country_code: 'RO', subdivision_name: 'Sibiu', code: 'RO-SB' },
  { country_code: 'RO', subdivision_name: 'Suceava', code: 'RO-SV' },
  { country_code: 'RO', subdivision_name: 'Teleorman', code: 'RO-TR' },
  { country_code: 'RO', subdivision_name: 'Timis', code: 'RO-TM' },
  { country_code: 'RO', subdivision_name: 'Tulcea', code: 'RO-TL' },
  { country_code: 'RO', subdivision_name: 'Valcea', code: 'RO-VL' },
  { country_code: 'RO', subdivision_name: 'Vaslui', code: 'RO-VS' },
  { country_code: 'RO', subdivision_name: 'Vrancea', code: 'RO-VN' },
  { country_code: 'RS', subdivision_name: 'Beograd', code: 'RS-00' },
  { country_code: 'RS', subdivision_name: 'Borski okrug', code: 'RS-14' },
  { country_code: 'RS', subdivision_name: 'Branicevski okrug', code: 'RS-11' },
  { country_code: 'RS', subdivision_name: 'Jablanicki okrug', code: 'RS-23' },
  { country_code: 'RS', subdivision_name: 'Juznobacki okrug', code: 'RS-06' },
  { country_code: 'RS', subdivision_name: 'Juznobanatski okrug', code: 'RS-04' },
  { country_code: 'RS', subdivision_name: 'Kolubarski okrug', code: 'RS-09' },
  { country_code: 'RS', subdivision_name: 'Kosovsko-Mitrovacki okrug', code: 'RS-28' },
  { country_code: 'RS', subdivision_name: 'Macvanski okrug', code: 'RS-08' },
  { country_code: 'RS', subdivision_name: 'Moravicki okrug', code: 'RS-17' },
  { country_code: 'RS', subdivision_name: 'Nisavski okrug', code: 'RS-20' },
  { country_code: 'RS', subdivision_name: 'Pcinjski okrug', code: 'RS-24' },
  { country_code: 'RS', subdivision_name: 'Pecki okrug', code: 'RS-26' },
  { country_code: 'RS', subdivision_name: 'Pirotski okrug', code: 'RS-22' },
  { country_code: 'RS', subdivision_name: 'Podunavski okrug', code: 'RS-10' },
  { country_code: 'RS', subdivision_name: 'Pomoravski okrug', code: 'RS-13' },
  { country_code: 'RS', subdivision_name: 'Prizrenski okrug', code: 'RS-27' },
  { country_code: 'RS', subdivision_name: 'Rasinski okrug', code: 'RS-19' },
  { country_code: 'RS', subdivision_name: 'Raski okrug', code: 'RS-18' },
  { country_code: 'RS', subdivision_name: 'Severnobacki okrug', code: 'RS-01' },
  { country_code: 'RS', subdivision_name: 'Severnobanatski okrug', code: 'RS-03' },
  { country_code: 'RS', subdivision_name: 'Srednjebanatski okrug', code: 'RS-02' },
  { country_code: 'RS', subdivision_name: 'Sremski okrug', code: 'RS-07' },
  { country_code: 'RS', subdivision_name: 'Sumadijski okrug', code: 'RS-12' },
  { country_code: 'RS', subdivision_name: 'Toplicki okrug', code: 'RS-21' },
  { country_code: 'RS', subdivision_name: 'Zajecarski okrug', code: 'RS-15' },
  { country_code: 'RS', subdivision_name: 'Zapadnobacki okrug', code: 'RS-05' },
  { country_code: 'RS', subdivision_name: 'Zlatiborski okrug', code: 'RS-16' },
  { country_code: 'RU', subdivision_name: 'Adygeya, Respublika', code: 'RU-AD' },
  { country_code: 'RU', subdivision_name: 'Altay, Respublika', code: 'RU-AL' },
  { country_code: 'RU', subdivision_name: 'Altayskiy kray', code: 'RU-ALT' },
  { country_code: 'RU', subdivision_name: "Amurskaya oblast'", code: 'RU-AMU' },
  { country_code: 'RU', subdivision_name: "Arkhangel'skaya oblast'", code: 'RU-ARK' },
  { country_code: 'RU', subdivision_name: "Astrakhanskaya oblast'", code: 'RU-AST' },
  { country_code: 'RU', subdivision_name: 'Bashkortostan, Respublika', code: 'RU-BA' },
  { country_code: 'RU', subdivision_name: "Belgorodskaya oblast'", code: 'RU-BEL' },
  { country_code: 'RU', subdivision_name: "Bryanskaya oblast'", code: 'RU-BRY' },
  { country_code: 'RU', subdivision_name: 'Buryatiya, Respublika', code: 'RU-BU' },
  { country_code: 'RU', subdivision_name: 'Chechenskaya Respublika', code: 'RU-CE' },
  { country_code: 'RU', subdivision_name: "Chelyabinskaya oblast'", code: 'RU-CHE' },
  { country_code: 'RU', subdivision_name: 'Chukotskiy avtonomnyy okrug', code: 'RU-CHU' },
  { country_code: 'RU', subdivision_name: 'Chuvashskaya Respublika', code: 'RU-CU' },
  { country_code: 'RU', subdivision_name: 'Dagestan, Respublika', code: 'RU-DA' },
  { country_code: 'RU', subdivision_name: 'Ingushetiya, Respublika', code: 'RU-IN' },
  { country_code: 'RU', subdivision_name: "Irkutskaya oblast'", code: 'RU-IRK' },
  { country_code: 'RU', subdivision_name: "Ivanovskaya oblast'", code: 'RU-IVA' },
  { country_code: 'RU', subdivision_name: 'Kabardino-Balkarskaya Respublika', code: 'RU-KB' },
  { country_code: 'RU', subdivision_name: "Kaliningradskaya oblast'", code: 'RU-KGD' },
  { country_code: 'RU', subdivision_name: 'Kalmykiya, Respublika', code: 'RU-KL' },
  { country_code: 'RU', subdivision_name: "Kaluzhskaya oblast'", code: 'RU-KLU' },
  { country_code: 'RU', subdivision_name: 'Kamchatskiy kray', code: 'RU-KAM' },
  { country_code: 'RU', subdivision_name: 'Karachayevo-Cherkesskaya Respublika', code: 'RU-KC' },
  { country_code: 'RU', subdivision_name: 'Kareliya, Respublika', code: 'RU-KR' },
  { country_code: 'RU', subdivision_name: "Kemerovskaya oblast'", code: 'RU-KEM' },
  { country_code: 'RU', subdivision_name: 'Khabarovskiy kray', code: 'RU-KHA' },
  { country_code: 'RU', subdivision_name: 'Khakasiya, Respublika', code: 'RU-KK' },
  { country_code: 'RU', subdivision_name: 'Khanty-Mansiyskiy avtonomnyy okrug', code: 'RU-KHM' },
  { country_code: 'RU', subdivision_name: "Kirovskaya oblast'", code: 'RU-KIR' },
  { country_code: 'RU', subdivision_name: 'Komi, Respublika', code: 'RU-KO' },
  { country_code: 'RU', subdivision_name: "Kostromskaya oblast'", code: 'RU-KOS' },
  { country_code: 'RU', subdivision_name: 'Krasnodarskiy kray', code: 'RU-KDA' },
  { country_code: 'RU', subdivision_name: 'Krasnoyarskiy kray', code: 'RU-KYA' },
  { country_code: 'RU', subdivision_name: "Kurganskaya oblast'", code: 'RU-KGN' },
  { country_code: 'RU', subdivision_name: "Kurskaya oblast'", code: 'RU-KRS' },
  { country_code: 'RU', subdivision_name: "Leningradskaya oblast'", code: 'RU-LEN' },
  { country_code: 'RU', subdivision_name: "Lipetskaya oblast'", code: 'RU-LIP' },
  { country_code: 'RU', subdivision_name: "Magadanskaya oblast'", code: 'RU-MAG' },
  { country_code: 'RU', subdivision_name: 'Mariy El, Respublika', code: 'RU-ME' },
  { country_code: 'RU', subdivision_name: 'Mordoviya, Respublika', code: 'RU-MO' },
  { country_code: 'RU', subdivision_name: "Moskovskaya oblast'", code: 'RU-MOS' },
  { country_code: 'RU', subdivision_name: 'Moskva', code: 'RU-MOW' },
  { country_code: 'RU', subdivision_name: "Murmanskaya oblast'", code: 'RU-MUR' },
  { country_code: 'RU', subdivision_name: 'Nenetskiy avtonomnyy okrug', code: 'RU-NEN' },
  { country_code: 'RU', subdivision_name: "Nizhegorodskaya oblast'", code: 'RU-NIZ' },
  { country_code: 'RU', subdivision_name: "Novgorodskaya oblast'", code: 'RU-NGR' },
  { country_code: 'RU', subdivision_name: "Novosibirskaya oblast'", code: 'RU-NVS' },
  { country_code: 'RU', subdivision_name: "Omskaya oblast'", code: 'RU-OMS' },
  { country_code: 'RU', subdivision_name: "Orenburgskaya oblast'", code: 'RU-ORE' },
  { country_code: 'RU', subdivision_name: "Orlovskaya oblast'", code: 'RU-ORL' },
  { country_code: 'RU', subdivision_name: "Penzenskaya oblast'", code: 'RU-PNZ' },
  { country_code: 'RU', subdivision_name: 'Permskiy kray', code: 'RU-PER' },
  { country_code: 'RU', subdivision_name: 'Primorskiy kray', code: 'RU-PRI' },
  { country_code: 'RU', subdivision_name: "Pskovskaya oblast'", code: 'RU-PSK' },
  { country_code: 'RU', subdivision_name: "Rostovskaya oblast'", code: 'RU-ROS' },
  { country_code: 'RU', subdivision_name: "Ryazanskaya oblast'", code: 'RU-RYA' },
  { country_code: 'RU', subdivision_name: 'Saha, Respublika', code: 'RU-SA' },
  { country_code: 'RU', subdivision_name: "Sakhalinskaya oblast'", code: 'RU-SAK' },
  { country_code: 'RU', subdivision_name: "Samarskaya oblast'", code: 'RU-SAM' },
  { country_code: 'RU', subdivision_name: 'Sankt-Peterburg', code: 'RU-SPE' },
  { country_code: 'RU', subdivision_name: "Saratovskaya oblast'", code: 'RU-SAR' },
  { country_code: 'RU', subdivision_name: 'Severnaya Osetiya, Respublika', code: 'RU-SE' },
  { country_code: 'RU', subdivision_name: "Smolenskaya oblast'", code: 'RU-SMO' },
  { country_code: 'RU', subdivision_name: "Stavropol'skiy kray", code: 'RU-STA' },
  { country_code: 'RU', subdivision_name: "Sverdlovskaya oblast'", code: 'RU-SVE' },
  { country_code: 'RU', subdivision_name: "Tambovskaya oblast'", code: 'RU-TAM' },
  { country_code: 'RU', subdivision_name: 'Tatarstan, Respublika', code: 'RU-TA' },
  { country_code: 'RU', subdivision_name: "Tomskaya oblast'", code: 'RU-TOM' },
  { country_code: 'RU', subdivision_name: "Tul'skaya oblast'", code: 'RU-TUL' },
  { country_code: 'RU', subdivision_name: "Tverskaya oblast'", code: 'RU-TVE' },
  { country_code: 'RU', subdivision_name: "Tyumenskaya oblast'", code: 'RU-TYU' },
  { country_code: 'RU', subdivision_name: 'Tyva, Respublika', code: 'RU-TY' },
  { country_code: 'RU', subdivision_name: 'Udmurtskaya Respublika', code: 'RU-UD' },
  { country_code: 'RU', subdivision_name: "Ul'yanovskaya oblast'", code: 'RU-ULY' },
  { country_code: 'RU', subdivision_name: "Vladimirskaya oblast'", code: 'RU-VLA' },
  { country_code: 'RU', subdivision_name: "Volgogradskaya oblast'", code: 'RU-VGG' },
  { country_code: 'RU', subdivision_name: "Vologodskaya oblast'", code: 'RU-VLG' },
  { country_code: 'RU', subdivision_name: "Voronezhskaya oblast'", code: 'RU-VOR' },
  { country_code: 'RU', subdivision_name: 'Yamalo-Nenetskiy avtonomnyy okrug', code: 'RU-YAN' },
  { country_code: 'RU', subdivision_name: "Yaroslavskaya oblast'", code: 'RU-YAR' },
  { country_code: 'RU', subdivision_name: "Yevreyskaya avtonomnaya oblast'", code: 'RU-YEV' },
  { country_code: 'RU', subdivision_name: "Zabaykal'skiy kray", code: 'RU-ZAB' },
  { country_code: 'RW', subdivision_name: 'Est', code: 'RW-02' },
  { country_code: 'RW', subdivision_name: 'Nord', code: 'RW-03' },
  { country_code: 'RW', subdivision_name: 'Ouest', code: 'RW-04' },
  { country_code: 'RW', subdivision_name: 'Sud', code: 'RW-05' },
  { country_code: 'RW', subdivision_name: 'Ville de Kigali', code: 'RW-01' },
  { country_code: 'SA', subdivision_name: "'Asir", code: 'SA-14' },
  { country_code: 'SA', subdivision_name: 'Al Bahah', code: 'SA-11' },
  { country_code: 'SA', subdivision_name: 'Al Hudud ash Shamaliyah', code: 'SA-08' },
  { country_code: 'SA', subdivision_name: 'Al Jawf', code: 'SA-12' },
  { country_code: 'SA', subdivision_name: 'Al Madinah al Munawwarah', code: 'SA-03' },
  { country_code: 'SA', subdivision_name: 'Al Qasim', code: 'SA-05' },
  { country_code: 'SA', subdivision_name: 'Ar Riyad', code: 'SA-01' },
  { country_code: 'SA', subdivision_name: 'Ash Sharqiyah', code: 'SA-04' },
  { country_code: 'SA', subdivision_name: "Ha'il", code: 'SA-06' },
  { country_code: 'SA', subdivision_name: 'Jazan', code: 'SA-09' },
  { country_code: 'SA', subdivision_name: 'Makkah al Mukarramah', code: 'SA-02' },
  { country_code: 'SA', subdivision_name: 'Najran', code: 'SA-10' },
  { country_code: 'SA', subdivision_name: 'Tabuk', code: 'SA-07' },
  { country_code: 'SB', subdivision_name: 'Choiseul', code: 'SB-CH' },
  { country_code: 'SB', subdivision_name: 'Guadalcanal', code: 'SB-GU' },
  { country_code: 'SC', subdivision_name: 'Anse Boileau', code: 'SC-02' },
  { country_code: 'SC', subdivision_name: 'Anse aux Pins', code: 'SC-01' },
  { country_code: 'SC', subdivision_name: 'Baie Lazare', code: 'SC-06' },
  { country_code: 'SC', subdivision_name: 'Beau Vallon', code: 'SC-08' },
  { country_code: 'SC', subdivision_name: 'Bel Ombre', code: 'SC-10' },
  { country_code: 'SC', subdivision_name: 'Cascade', code: 'SC-11' },
  { country_code: 'SC', subdivision_name: 'English River', code: 'SC-16' },
  { country_code: 'SC', subdivision_name: 'Grand Anse Mahe', code: 'SC-13' },
  { country_code: 'SC', subdivision_name: 'La Digue', code: 'SC-15' },
  { country_code: 'SC', subdivision_name: 'Pointe Larue', code: 'SC-20' },
  { country_code: 'SC', subdivision_name: 'Port Glaud', code: 'SC-21' },
  { country_code: 'SC', subdivision_name: 'Takamaka', code: 'SC-23' },
  { country_code: 'SD', subdivision_name: 'Blue Nile', code: 'SD-NB' },
  { country_code: 'SD', subdivision_name: 'Gedaref', code: 'SD-GD' },
  { country_code: 'SD', subdivision_name: 'Gezira', code: 'SD-GZ' },
  { country_code: 'SD', subdivision_name: 'Kassala', code: 'SD-KA' },
  { country_code: 'SD', subdivision_name: 'Khartoum', code: 'SD-KH' },
  { country_code: 'SD', subdivision_name: 'North Darfur', code: 'SD-DN' },
  { country_code: 'SD', subdivision_name: 'North Kordofan', code: 'SD-KN' },
  { country_code: 'SD', subdivision_name: 'Northern', code: 'SD-NO' },
  { country_code: 'SD', subdivision_name: 'Red Sea', code: 'SD-RS' },
  { country_code: 'SD', subdivision_name: 'River Nile', code: 'SD-NR' },
  { country_code: 'SD', subdivision_name: 'Sennar', code: 'SD-SI' },
  { country_code: 'SD', subdivision_name: 'South Darfur', code: 'SD-DS' },
  { country_code: 'SD', subdivision_name: 'South Kordofan', code: 'SD-KS' },
  { country_code: 'SD', subdivision_name: 'West Darfur', code: 'SD-DW' },
  { country_code: 'SD', subdivision_name: 'White Nile', code: 'SD-NW' },
  { country_code: 'SE', subdivision_name: 'Blekinge lan', code: 'SE-K' },
  { country_code: 'SE', subdivision_name: 'Dalarnas lan', code: 'SE-W' },
  { country_code: 'SE', subdivision_name: 'Gavleborgs lan', code: 'SE-X' },
  { country_code: 'SE', subdivision_name: 'Gotlands lan', code: 'SE-I' },
  { country_code: 'SE', subdivision_name: 'Hallands lan', code: 'SE-N' },
  { country_code: 'SE', subdivision_name: 'Jamtlands lan', code: 'SE-Z' },
  { country_code: 'SE', subdivision_name: 'Jonkopings lan', code: 'SE-F' },
  { country_code: 'SE', subdivision_name: 'Kalmar lan', code: 'SE-H' },
  { country_code: 'SE', subdivision_name: 'Kronobergs lan', code: 'SE-G' },
  { country_code: 'SE', subdivision_name: 'Norrbottens lan', code: 'SE-BD' },
  { country_code: 'SE', subdivision_name: 'Orebro lan', code: 'SE-T' },
  { country_code: 'SE', subdivision_name: 'Ostergotlands lan', code: 'SE-E' },
  { country_code: 'SE', subdivision_name: 'Skane lan', code: 'SE-M' },
  { country_code: 'SE', subdivision_name: 'Sodermanlands lan', code: 'SE-D' },
  { country_code: 'SE', subdivision_name: 'Stockholms lan', code: 'SE-AB' },
  { country_code: 'SE', subdivision_name: 'Uppsala lan', code: 'SE-C' },
  { country_code: 'SE', subdivision_name: 'Varmlands lan', code: 'SE-S' },
  { country_code: 'SE', subdivision_name: 'Vasterbottens lan', code: 'SE-AC' },
  { country_code: 'SE', subdivision_name: 'Vasternorrlands lan', code: 'SE-Y' },
  { country_code: 'SE', subdivision_name: 'Vastmanlands lan', code: 'SE-U' },
  { country_code: 'SE', subdivision_name: 'Vastra Gotalands lan', code: 'SE-O' },
  { country_code: 'SG', subdivision_name: 'Singapore', code: '-' },
  { country_code: 'SH', subdivision_name: 'Saint Helena', code: 'SH-HL' },
  { country_code: 'SI', subdivision_name: 'Ajdovscina', code: 'SI-001' },
  { country_code: 'SI', subdivision_name: 'Apace', code: 'SI-195' },
  { country_code: 'SI', subdivision_name: 'Beltinci', code: 'SI-002' },
  { country_code: 'SI', subdivision_name: 'Benedikt', code: 'SI-148' },
  { country_code: 'SI', subdivision_name: 'Bistrica ob Sotli', code: 'SI-149' },
  { country_code: 'SI', subdivision_name: 'Bled', code: 'SI-003' },
  { country_code: 'SI', subdivision_name: 'Bloke', code: 'SI-150' },
  { country_code: 'SI', subdivision_name: 'Bohinj', code: 'SI-004' },
  { country_code: 'SI', subdivision_name: 'Borovnica', code: 'SI-005' },
  { country_code: 'SI', subdivision_name: 'Bovec', code: 'SI-006' },
  { country_code: 'SI', subdivision_name: 'Braslovce', code: 'SI-151' },
  { country_code: 'SI', subdivision_name: 'Brda', code: 'SI-007' },
  { country_code: 'SI', subdivision_name: 'Brezice', code: 'SI-009' },
  { country_code: 'SI', subdivision_name: 'Brezovica', code: 'SI-008' },
  { country_code: 'SI', subdivision_name: 'Cankova', code: 'SI-152' },
  { country_code: 'SI', subdivision_name: 'Celje', code: 'SI-011' },
  { country_code: 'SI', subdivision_name: 'Cerklje na Gorenjskem', code: 'SI-012' },
  { country_code: 'SI', subdivision_name: 'Cerknica', code: 'SI-013' },
  { country_code: 'SI', subdivision_name: 'Cerkno', code: 'SI-014' },
  { country_code: 'SI', subdivision_name: 'Cirkulane', code: 'SI-196' },
  { country_code: 'SI', subdivision_name: 'Crensovci', code: 'SI-015' },
  { country_code: 'SI', subdivision_name: 'Crnomelj', code: 'SI-017' },
  { country_code: 'SI', subdivision_name: 'Destrnik', code: 'SI-018' },
  { country_code: 'SI', subdivision_name: 'Divaca', code: 'SI-019' },
  { country_code: 'SI', subdivision_name: 'Dobje', code: 'SI-154' },
  { country_code: 'SI', subdivision_name: 'Dobrepolje', code: 'SI-020' },
  { country_code: 'SI', subdivision_name: 'Dobrna', code: 'SI-155' },
  { country_code: 'SI', subdivision_name: 'Dobrova-Polhov Gradec', code: 'SI-021' },
  { country_code: 'SI', subdivision_name: 'Dobrovnik', code: 'SI-156' },
  { country_code: 'SI', subdivision_name: 'Domzale', code: 'SI-023' },
  { country_code: 'SI', subdivision_name: 'Dornava', code: 'SI-024' },
  { country_code: 'SI', subdivision_name: 'Dravograd', code: 'SI-025' },
  { country_code: 'SI', subdivision_name: 'Duplek', code: 'SI-026' },
  { country_code: 'SI', subdivision_name: 'Gorje', code: 'SI-207' },
  { country_code: 'SI', subdivision_name: 'Gornja Radgona', code: 'SI-029' },
  { country_code: 'SI', subdivision_name: 'Gornji Petrovci', code: 'SI-031' },
  { country_code: 'SI', subdivision_name: 'Grad', code: 'SI-158' },
  { country_code: 'SI', subdivision_name: 'Grosuplje', code: 'SI-032' },
  { country_code: 'SI', subdivision_name: 'Hajdina', code: 'SI-159' },
  { country_code: 'SI', subdivision_name: 'Hoce-Slivnica', code: 'SI-160' },
  { country_code: 'SI', subdivision_name: 'Hodos', code: 'SI-161' },
  { country_code: 'SI', subdivision_name: 'Horjul', code: 'SI-162' },
  { country_code: 'SI', subdivision_name: 'Hrastnik', code: 'SI-034' },
  { country_code: 'SI', subdivision_name: 'Hrpelje-Kozina', code: 'SI-035' },
  { country_code: 'SI', subdivision_name: 'Idrija', code: 'SI-036' },
  { country_code: 'SI', subdivision_name: 'Ig', code: 'SI-037' },
  { country_code: 'SI', subdivision_name: 'Ilirska Bistrica', code: 'SI-038' },
  { country_code: 'SI', subdivision_name: 'Ivancna Gorica', code: 'SI-039' },
  { country_code: 'SI', subdivision_name: 'Izola', code: 'SI-040' },
  { country_code: 'SI', subdivision_name: 'Jesenice', code: 'SI-041' },
  { country_code: 'SI', subdivision_name: 'Jursinci', code: 'SI-042' },
  { country_code: 'SI', subdivision_name: 'Kamnik', code: 'SI-043' },
  { country_code: 'SI', subdivision_name: 'Kanal', code: 'SI-044' },
  { country_code: 'SI', subdivision_name: 'Kidricevo', code: 'SI-045' },
  { country_code: 'SI', subdivision_name: 'Kobarid', code: 'SI-046' },
  { country_code: 'SI', subdivision_name: 'Kobilje', code: 'SI-047' },
  { country_code: 'SI', subdivision_name: 'Kocevje', code: 'SI-048' },
  { country_code: 'SI', subdivision_name: 'Komen', code: 'SI-049' },
  { country_code: 'SI', subdivision_name: 'Komenda', code: 'SI-164' },
  { country_code: 'SI', subdivision_name: 'Koper', code: 'SI-050' },
  { country_code: 'SI', subdivision_name: 'Kosanjevica na Krki', code: 'SI-197' },
  { country_code: 'SI', subdivision_name: 'Kostel', code: 'SI-165' },
  { country_code: 'SI', subdivision_name: 'Kranj', code: 'SI-052' },
  { country_code: 'SI', subdivision_name: 'Kranjska Gora', code: 'SI-053' },
  { country_code: 'SI', subdivision_name: 'Krizevci', code: 'SI-166' },
  { country_code: 'SI', subdivision_name: 'Krsko', code: 'SI-054' },
  { country_code: 'SI', subdivision_name: 'Kungota', code: 'SI-055' },
  { country_code: 'SI', subdivision_name: 'Kuzma', code: 'SI-056' },
  { country_code: 'SI', subdivision_name: 'Lasko', code: 'SI-057' },
  { country_code: 'SI', subdivision_name: 'Lenart', code: 'SI-058' },
  { country_code: 'SI', subdivision_name: 'Lendava', code: 'SI-059' },
  { country_code: 'SI', subdivision_name: 'Litija', code: 'SI-060' },
  { country_code: 'SI', subdivision_name: 'Ljubljana', code: 'SI-061' },
  { country_code: 'SI', subdivision_name: 'Ljutomer', code: 'SI-063' },
  { country_code: 'SI', subdivision_name: 'Log-Dragomer', code: 'SI-208' },
  { country_code: 'SI', subdivision_name: 'Logatec', code: 'SI-064' },
  { country_code: 'SI', subdivision_name: 'Loska Dolina', code: 'SI-065' },
  { country_code: 'SI', subdivision_name: 'Lovrenc na Pohorju', code: 'SI-167' },
  { country_code: 'SI', subdivision_name: 'Luce', code: 'SI-067' },
  { country_code: 'SI', subdivision_name: 'Lukovica', code: 'SI-068' },
  { country_code: 'SI', subdivision_name: 'Majsperk', code: 'SI-069' },
  { country_code: 'SI', subdivision_name: 'Makole', code: 'SI-198' },
  { country_code: 'SI', subdivision_name: 'Maribor', code: 'SI-070' },
  { country_code: 'SI', subdivision_name: 'Markovci', code: 'SI-168' },
  { country_code: 'SI', subdivision_name: 'Medvode', code: 'SI-071' },
  { country_code: 'SI', subdivision_name: 'Menges', code: 'SI-072' },
  { country_code: 'SI', subdivision_name: 'Metlika', code: 'SI-073' },
  { country_code: 'SI', subdivision_name: 'Mezica', code: 'SI-074' },
  { country_code: 'SI', subdivision_name: 'Miklavz na Dravskem Polju', code: 'SI-169' },
  { country_code: 'SI', subdivision_name: 'Miren-Kostanjevica', code: 'SI-075' },
  { country_code: 'SI', subdivision_name: 'Mirna Pec', code: 'SI-170' },
  { country_code: 'SI', subdivision_name: 'Mislinja', code: 'SI-076' },
  { country_code: 'SI', subdivision_name: 'Mokronog-Trebelno', code: 'SI-199' },
  { country_code: 'SI', subdivision_name: 'Moravce', code: 'SI-077' },
  { country_code: 'SI', subdivision_name: 'Mozirje', code: 'SI-079' },
  { country_code: 'SI', subdivision_name: 'Murska Sobota', code: 'SI-080' },
  { country_code: 'SI', subdivision_name: 'Muta', code: 'SI-081' },
  { country_code: 'SI', subdivision_name: 'Naklo', code: 'SI-082' },
  { country_code: 'SI', subdivision_name: 'Nazarje', code: 'SI-083' },
  { country_code: 'SI', subdivision_name: 'Nova Gorica', code: 'SI-084' },
  { country_code: 'SI', subdivision_name: 'Novo Mesto', code: 'SI-085' },
  { country_code: 'SI', subdivision_name: 'Odranci', code: 'SI-086' },
  { country_code: 'SI', subdivision_name: 'Oplotnica', code: 'SI-171' },
  { country_code: 'SI', subdivision_name: 'Ormoz', code: 'SI-087' },
  { country_code: 'SI', subdivision_name: 'Piran', code: 'SI-090' },
  { country_code: 'SI', subdivision_name: 'Pivka', code: 'SI-091' },
  { country_code: 'SI', subdivision_name: 'Podcetrtek', code: 'SI-092' },
  { country_code: 'SI', subdivision_name: 'Podlehnik', code: 'SI-172' },
  { country_code: 'SI', subdivision_name: 'Poljcane', code: 'SI-200' },
  { country_code: 'SI', subdivision_name: 'Polzela', code: 'SI-173' },
  { country_code: 'SI', subdivision_name: 'Postojna', code: 'SI-094' },
  { country_code: 'SI', subdivision_name: 'Prebold', code: 'SI-174' },
  { country_code: 'SI', subdivision_name: 'Preddvor', code: 'SI-095' },
  { country_code: 'SI', subdivision_name: 'Prevalje', code: 'SI-175' },
  { country_code: 'SI', subdivision_name: 'Ptuj', code: 'SI-096' },
  { country_code: 'SI', subdivision_name: 'Puconci', code: 'SI-097' },
  { country_code: 'SI', subdivision_name: 'Race-Fram', code: 'SI-098' },
  { country_code: 'SI', subdivision_name: 'Radece', code: 'SI-099' },
  { country_code: 'SI', subdivision_name: 'Radenci', code: 'SI-100' },
  { country_code: 'SI', subdivision_name: 'Radlje ob Dravi', code: 'SI-101' },
  { country_code: 'SI', subdivision_name: 'Radovljica', code: 'SI-102' },
  { country_code: 'SI', subdivision_name: 'Ravne na Koroskem', code: 'SI-103' },
  { country_code: 'SI', subdivision_name: 'Razkrizje', code: 'SI-176' },
  { country_code: 'SI', subdivision_name: 'Recica ob Savinji', code: 'SI-209' },
  { country_code: 'SI', subdivision_name: 'Rence-Vogrsko', code: 'SI-201' },
  { country_code: 'SI', subdivision_name: 'Ribnica', code: 'SI-104' },
  { country_code: 'SI', subdivision_name: 'Rogaska Slatina', code: 'SI-106' },
  { country_code: 'SI', subdivision_name: 'Rogasovci', code: 'SI-105' },
  { country_code: 'SI', subdivision_name: 'Ruse', code: 'SI-108' },
  { country_code: 'SI', subdivision_name: 'Salovci', code: 'SI-033' },
  { country_code: 'SI', subdivision_name: 'Semic', code: 'SI-109' },
  { country_code: 'SI', subdivision_name: 'Sempeter-Vrtojba', code: 'SI-183' },
  { country_code: 'SI', subdivision_name: 'Sencur', code: 'SI-117' },
  { country_code: 'SI', subdivision_name: 'Sentilj', code: 'SI-118' },
  { country_code: 'SI', subdivision_name: 'Sentjernej', code: 'SI-119' },
  { country_code: 'SI', subdivision_name: 'Sentjur', code: 'SI-120' },
  { country_code: 'SI', subdivision_name: 'Sentrupert', code: 'SI-211' },
  { country_code: 'SI', subdivision_name: 'Sevnica', code: 'SI-110' },
  { country_code: 'SI', subdivision_name: 'Sezana', code: 'SI-111' },
  { country_code: 'SI', subdivision_name: 'Skocjan', code: 'SI-121' },
  { country_code: 'SI', subdivision_name: 'Skofja Loka', code: 'SI-122' },
  { country_code: 'SI', subdivision_name: 'Skofljica', code: 'SI-123' },
  { country_code: 'SI', subdivision_name: 'Slovenj Gradec', code: 'SI-112' },
  { country_code: 'SI', subdivision_name: 'Slovenska Bistrica', code: 'SI-113' },
  { country_code: 'SI', subdivision_name: 'Slovenske Konjice', code: 'SI-114' },
  { country_code: 'SI', subdivision_name: 'Smarje pri Jelsah', code: 'SI-124' },
  { country_code: 'SI', subdivision_name: 'Smarjeske Toplice', code: 'SI-206' },
  { country_code: 'SI', subdivision_name: 'Smartno ob Paki', code: 'SI-125' },
  { country_code: 'SI', subdivision_name: 'Smartno pri Litiji', code: 'SI-194' },
  { country_code: 'SI', subdivision_name: 'Sodrazica', code: 'SI-179' },
  { country_code: 'SI', subdivision_name: 'Solcava', code: 'SI-180' },
  { country_code: 'SI', subdivision_name: 'Sostanj', code: 'SI-126' },
  { country_code: 'SI', subdivision_name: 'Starse', code: 'SI-115' },
  { country_code: 'SI', subdivision_name: 'Store', code: 'SI-127' },
  { country_code: 'SI', subdivision_name: 'Straza', code: 'SI-203' },
  { country_code: 'SI', subdivision_name: 'Sveta Trojica v Slovenskih Goricah', code: 'SI-204' },
  { country_code: 'SI', subdivision_name: 'Sveti Andraz v Slovenskih Goricah', code: 'SI-182' },
  { country_code: 'SI', subdivision_name: 'Sveti Jurij', code: 'SI-116' },
  { country_code: 'SI', subdivision_name: 'Sveti Jurij v Slovenskih Goricah', code: 'SI-210' },
  { country_code: 'SI', subdivision_name: 'Sveti Tomaz', code: 'SI-205' },
  { country_code: 'SI', subdivision_name: 'Tabor', code: 'SI-184' },
  { country_code: 'SI', subdivision_name: 'Tisina', code: 'SI-010' },
  { country_code: 'SI', subdivision_name: 'Tolmin', code: 'SI-128' },
  { country_code: 'SI', subdivision_name: 'Trbovlje', code: 'SI-129' },
  { country_code: 'SI', subdivision_name: 'Trebnje', code: 'SI-130' },
  { country_code: 'SI', subdivision_name: 'Trnovska Vas', code: 'SI-185' },
  { country_code: 'SI', subdivision_name: 'Trzic', code: 'SI-131' },
  { country_code: 'SI', subdivision_name: 'Trzin', code: 'SI-186' },
  { country_code: 'SI', subdivision_name: 'Turnisce', code: 'SI-132' },
  { country_code: 'SI', subdivision_name: 'Velenje', code: 'SI-133' },
  { country_code: 'SI', subdivision_name: 'Velika Polana', code: 'SI-187' },
  { country_code: 'SI', subdivision_name: 'Velike Lasce', code: 'SI-134' },
  { country_code: 'SI', subdivision_name: 'Verzej', code: 'SI-188' },
  { country_code: 'SI', subdivision_name: 'Videm', code: 'SI-135' },
  { country_code: 'SI', subdivision_name: 'Vipava', code: 'SI-136' },
  { country_code: 'SI', subdivision_name: 'Vitanje', code: 'SI-137' },
  { country_code: 'SI', subdivision_name: 'Vodice', code: 'SI-138' },
  { country_code: 'SI', subdivision_name: 'Vojnik', code: 'SI-139' },
  { country_code: 'SI', subdivision_name: 'Vransko', code: 'SI-189' },
  { country_code: 'SI', subdivision_name: 'Vrhnika', code: 'SI-140' },
  { country_code: 'SI', subdivision_name: 'Vuzenica', code: 'SI-141' },
  { country_code: 'SI', subdivision_name: 'Zagorje ob Savi', code: 'SI-142' },
  { country_code: 'SI', subdivision_name: 'Zalec', code: 'SI-190' },
  { country_code: 'SI', subdivision_name: 'Zavrc', code: 'SI-143' },
  { country_code: 'SI', subdivision_name: 'Zelezniki', code: 'SI-146' },
  { country_code: 'SI', subdivision_name: 'Zetale', code: 'SI-191' },
  { country_code: 'SI', subdivision_name: 'Ziri', code: 'SI-147' },
  { country_code: 'SI', subdivision_name: 'Zrece', code: 'SI-144' },
  { country_code: 'SI', subdivision_name: 'Zuzemberk', code: 'SI-193' },
  { country_code: 'SJ', subdivision_name: 'Svalbard and Jan Mayen', code: '-' },
  { country_code: 'SK', subdivision_name: 'Banskobystricky kraj', code: 'SK-BC' },
  { country_code: 'SK', subdivision_name: 'Bratislavsky kraj', code: 'SK-BL' },
  { country_code: 'SK', subdivision_name: 'Kosicky kraj', code: 'SK-KI' },
  { country_code: 'SK', subdivision_name: 'Nitriansky kraj', code: 'SK-NI' },
  { country_code: 'SK', subdivision_name: 'Presovsky kraj', code: 'SK-PV' },
  { country_code: 'SK', subdivision_name: 'Trenciansky kraj', code: 'SK-TC' },
  { country_code: 'SK', subdivision_name: 'Trnavsky kraj', code: 'SK-TA' },
  { country_code: 'SK', subdivision_name: 'Zilinsky kraj', code: 'SK-ZI' },
  { country_code: 'SL', subdivision_name: 'Eastern', code: 'SL-E' },
  { country_code: 'SL', subdivision_name: 'Northern', code: 'SL-N' },
  { country_code: 'SL', subdivision_name: 'Western Area', code: 'SL-W' },
  { country_code: 'SM', subdivision_name: 'Domagnano', code: 'SM-03' },
  { country_code: 'SM', subdivision_name: 'San Marino', code: 'SM-07' },
  { country_code: 'SM', subdivision_name: 'Serravalle', code: 'SM-09' },
  { country_code: 'SN', subdivision_name: 'Dakar', code: 'SN-DK' },
  { country_code: 'SN', subdivision_name: 'Diourbel', code: 'SN-DB' },
  { country_code: 'SN', subdivision_name: 'Fatick', code: 'SN-FK' },
  { country_code: 'SN', subdivision_name: 'Kaffrine', code: 'SN-KA' },
  { country_code: 'SN', subdivision_name: 'Kaolack', code: 'SN-KL' },
  { country_code: 'SN', subdivision_name: 'Kolda', code: 'SN-KD' },
  { country_code: 'SN', subdivision_name: 'Louga', code: 'SN-LG' },
  { country_code: 'SN', subdivision_name: 'Matam', code: 'SN-MT' },
  { country_code: 'SN', subdivision_name: 'Saint-Louis', code: 'SN-SL' },
  { country_code: 'SN', subdivision_name: 'Tambacounda', code: 'SN-TC' },
  { country_code: 'SN', subdivision_name: 'Thies', code: 'SN-TH' },
  { country_code: 'SN', subdivision_name: 'Ziguinchor', code: 'SN-ZG' },
  { country_code: 'SO', subdivision_name: 'Awdal', code: 'SO-AW' },
  { country_code: 'SO', subdivision_name: 'Banaadir', code: 'SO-BN' },
  { country_code: 'SO', subdivision_name: 'Bay', code: 'SO-BY' },
  { country_code: 'SO', subdivision_name: 'Hiiraan', code: 'SO-HI' },
  { country_code: 'SO', subdivision_name: 'Nugaal', code: 'SO-NU' },
  { country_code: 'SO', subdivision_name: 'Shabeellaha Hoose', code: 'SO-SH' },
  { country_code: 'SO', subdivision_name: 'Togdheer', code: 'SO-TO' },
  { country_code: 'SO', subdivision_name: 'Woqooyi Galbeed', code: 'SO-WO' },
  { country_code: 'SR', subdivision_name: 'Brokopondo', code: 'SR-BR' },
  { country_code: 'SR', subdivision_name: 'Commewijne', code: 'SR-CM' },
  { country_code: 'SR', subdivision_name: 'Nickerie', code: 'SR-NI' },
  { country_code: 'SR', subdivision_name: 'Para', code: 'SR-PR' },
  { country_code: 'SR', subdivision_name: 'Paramaribo', code: 'SR-PM' },
  { country_code: 'SR', subdivision_name: 'Saramacca', code: 'SR-SA' },
  { country_code: 'SR', subdivision_name: 'Sipaliwini', code: 'SR-SI' },
  { country_code: 'SR', subdivision_name: 'Wanica', code: 'SR-WA' },
  { country_code: 'SS', subdivision_name: 'Central Equatoria', code: 'SS-EC' },
  { country_code: 'SS', subdivision_name: 'Eastern Equatoria', code: 'SS-EE' },
  { country_code: 'SS', subdivision_name: 'Lakes', code: 'SS-LK' },
  { country_code: 'SS', subdivision_name: 'Northern Bahr el Ghazal', code: 'SS-BN' },
  { country_code: 'SS', subdivision_name: 'Unity', code: 'SS-UY' },
  { country_code: 'SS', subdivision_name: 'Upper Nile', code: 'SS-NU' },
  { country_code: 'SS', subdivision_name: 'Western Equatoria', code: 'SS-EW' },
  { country_code: 'ST', subdivision_name: 'Principe', code: 'ST-P' },
  { country_code: 'ST', subdivision_name: 'Sao Tome', code: 'ST-S' },
  { country_code: 'SV', subdivision_name: 'Ahuachapan', code: 'SV-AH' },
  { country_code: 'SV', subdivision_name: 'Cabanas', code: 'SV-CA' },
  { country_code: 'SV', subdivision_name: 'Chalatenango', code: 'SV-CH' },
  { country_code: 'SV', subdivision_name: 'Cuscatlan', code: 'SV-CU' },
  { country_code: 'SV', subdivision_name: 'La Libertad', code: 'SV-LI' },
  { country_code: 'SV', subdivision_name: 'La Paz', code: 'SV-PA' },
  { country_code: 'SV', subdivision_name: 'La Union', code: 'SV-UN' },
  { country_code: 'SV', subdivision_name: 'Morazan', code: 'SV-MO' },
  { country_code: 'SV', subdivision_name: 'San Miguel', code: 'SV-SM' },
  { country_code: 'SV', subdivision_name: 'San Salvador', code: 'SV-SS' },
  { country_code: 'SV', subdivision_name: 'San Vicente', code: 'SV-SV' },
  { country_code: 'SV', subdivision_name: 'Santa Ana', code: 'SV-SA' },
  { country_code: 'SV', subdivision_name: 'Sonsonate', code: 'SV-SO' },
  { country_code: 'SV', subdivision_name: 'Usulutan', code: 'SV-US' },
  { country_code: 'SX', subdivision_name: 'Sint Maarten (Dutch Part)', code: '-' },
  { country_code: 'SY', subdivision_name: 'Al Hasakah', code: 'SY-HA' },
  { country_code: 'SY', subdivision_name: 'Al Ladhiqiyah', code: 'SY-LA' },
  { country_code: 'SY', subdivision_name: 'Al Qunaytirah', code: 'SY-QU' },
  { country_code: 'SY', subdivision_name: 'Ar Raqqah', code: 'SY-RA' },
  { country_code: 'SY', subdivision_name: "As Suwayda'", code: 'SY-SU' },
  { country_code: 'SY', subdivision_name: "Dar'a", code: 'SY-DR' },
  { country_code: 'SY', subdivision_name: 'Dayr az Zawr', code: 'SY-DY' },
  { country_code: 'SY', subdivision_name: 'Dimashq', code: 'SY-DI' },
  { country_code: 'SY', subdivision_name: 'Halab', code: 'SY-HL' },
  { country_code: 'SY', subdivision_name: 'Hamah', code: 'SY-HM' },
  { country_code: 'SY', subdivision_name: 'Hims', code: 'SY-HI' },
  { country_code: 'SY', subdivision_name: 'Idlib', code: 'SY-ID' },
  { country_code: 'SY', subdivision_name: 'Rif Dimashq', code: 'SY-RD' },
  { country_code: 'SY', subdivision_name: 'Tartus', code: 'SY-TA' },
  { country_code: 'SZ', subdivision_name: 'Hhohho', code: 'SZ-HH' },
  { country_code: 'SZ', subdivision_name: 'Lubombo', code: 'SZ-LU' },
  { country_code: 'SZ', subdivision_name: 'Manzini', code: 'SZ-MA' },
  { country_code: 'TC', subdivision_name: 'Turks and Caicos Islands', code: '-' },
  { country_code: 'TD', subdivision_name: 'Guera', code: 'TD-GR' },
  { country_code: 'TD', subdivision_name: 'Hadjer Lamis', code: 'TD-HL' },
  { country_code: 'TD', subdivision_name: 'Logone-Occidental', code: 'TD-LO' },
  { country_code: 'TD', subdivision_name: 'Logone-Oriental', code: 'TD-LR' },
  { country_code: 'TD', subdivision_name: 'Mayo-Kebbi-Est', code: 'TD-ME' },
  { country_code: 'TD', subdivision_name: 'Ouaddai', code: 'TD-OD' },
  { country_code: 'TD', subdivision_name: 'Tibesti', code: 'TD-TI' },
  { country_code: 'TD', subdivision_name: 'Ville de Ndjamena', code: 'TD-ND' },
  { country_code: 'TG', subdivision_name: 'Centrale', code: 'TG-C' },
  { country_code: 'TG', subdivision_name: 'Kara', code: 'TG-K' },
  { country_code: 'TG', subdivision_name: 'Maritime', code: 'TG-M' },
  { country_code: 'TG', subdivision_name: 'Plateaux', code: 'TG-P' },
  { country_code: 'TH', subdivision_name: 'Amnat Charoen', code: 'TH-37' },
  { country_code: 'TH', subdivision_name: 'Ang Thong', code: 'TH-15' },
  { country_code: 'TH', subdivision_name: 'Bueng Kan', code: 'TH-38' },
  { country_code: 'TH', subdivision_name: 'Buri Ram', code: 'TH-31' },
  { country_code: 'TH', subdivision_name: 'Chachoengsao', code: 'TH-24' },
  { country_code: 'TH', subdivision_name: 'Chai Nat', code: 'TH-18' },
  { country_code: 'TH', subdivision_name: 'Chaiyaphum', code: 'TH-36' },
  { country_code: 'TH', subdivision_name: 'Chanthaburi', code: 'TH-22' },
  { country_code: 'TH', subdivision_name: 'Chiang Mai', code: 'TH-50' },
  { country_code: 'TH', subdivision_name: 'Chiang Rai', code: 'TH-57' },
  { country_code: 'TH', subdivision_name: 'Chon Buri', code: 'TH-20' },
  { country_code: 'TH', subdivision_name: 'Chumphon', code: 'TH-86' },
  { country_code: 'TH', subdivision_name: 'Kalasin', code: 'TH-46' },
  { country_code: 'TH', subdivision_name: 'Kamphaeng Phet', code: 'TH-62' },
  { country_code: 'TH', subdivision_name: 'Kanchanaburi', code: 'TH-71' },
  { country_code: 'TH', subdivision_name: 'Khon Kaen', code: 'TH-40' },
  { country_code: 'TH', subdivision_name: 'Krabi', code: 'TH-81' },
  { country_code: 'TH', subdivision_name: 'Krung Thep Maha Nakhon', code: 'TH-10' },
  { country_code: 'TH', subdivision_name: 'Lampang', code: 'TH-52' },
  { country_code: 'TH', subdivision_name: 'Lamphun', code: 'TH-51' },
  { country_code: 'TH', subdivision_name: 'Loei', code: 'TH-42' },
  { country_code: 'TH', subdivision_name: 'Lop Buri', code: 'TH-16' },
  { country_code: 'TH', subdivision_name: 'Mae Hong Son', code: 'TH-58' },
  { country_code: 'TH', subdivision_name: 'Maha Sarakham', code: 'TH-44' },
  { country_code: 'TH', subdivision_name: 'Mukdahan', code: 'TH-49' },
  { country_code: 'TH', subdivision_name: 'Nakhon Nayok', code: 'TH-26' },
  { country_code: 'TH', subdivision_name: 'Nakhon Pathom', code: 'TH-73' },
  { country_code: 'TH', subdivision_name: 'Nakhon Phanom', code: 'TH-48' },
  { country_code: 'TH', subdivision_name: 'Nakhon Ratchasima', code: 'TH-30' },
  { country_code: 'TH', subdivision_name: 'Nakhon Sawan', code: 'TH-60' },
  { country_code: 'TH', subdivision_name: 'Nakhon Si Thammarat', code: 'TH-80' },
  { country_code: 'TH', subdivision_name: 'Nan', code: 'TH-55' },
  { country_code: 'TH', subdivision_name: 'Narathiwat', code: 'TH-96' },
  { country_code: 'TH', subdivision_name: 'Nong Bua Lam Phu', code: 'TH-39' },
  { country_code: 'TH', subdivision_name: 'Nong Khai', code: 'TH-43' },
  { country_code: 'TH', subdivision_name: 'Nonthaburi', code: 'TH-12' },
  { country_code: 'TH', subdivision_name: 'Pathum Thani', code: 'TH-13' },
  { country_code: 'TH', subdivision_name: 'Pattani', code: 'TH-94' },
  { country_code: 'TH', subdivision_name: 'Phangnga', code: 'TH-82' },
  { country_code: 'TH', subdivision_name: 'Phatthalung', code: 'TH-93' },
  { country_code: 'TH', subdivision_name: 'Phayao', code: 'TH-56' },
  { country_code: 'TH', subdivision_name: 'Phetchabun', code: 'TH-67' },
  { country_code: 'TH', subdivision_name: 'Phetchaburi', code: 'TH-76' },
  { country_code: 'TH', subdivision_name: 'Phichit', code: 'TH-66' },
  { country_code: 'TH', subdivision_name: 'Phitsanulok', code: 'TH-65' },
  { country_code: 'TH', subdivision_name: 'Phra Nakhon Si Ayutthaya', code: 'TH-14' },
  { country_code: 'TH', subdivision_name: 'Phrae', code: 'TH-54' },
  { country_code: 'TH', subdivision_name: 'Phuket', code: 'TH-83' },
  { country_code: 'TH', subdivision_name: 'Prachin Buri', code: 'TH-25' },
  { country_code: 'TH', subdivision_name: 'Prachuap Khiri Khan', code: 'TH-77' },
  { country_code: 'TH', subdivision_name: 'Ranong', code: 'TH-85' },
  { country_code: 'TH', subdivision_name: 'Ratchaburi', code: 'TH-70' },
  { country_code: 'TH', subdivision_name: 'Rayong', code: 'TH-21' },
  { country_code: 'TH', subdivision_name: 'Roi Et', code: 'TH-45' },
  { country_code: 'TH', subdivision_name: 'Sa Kaeo', code: 'TH-27' },
  { country_code: 'TH', subdivision_name: 'Sakon Nakhon', code: 'TH-47' },
  { country_code: 'TH', subdivision_name: 'Samut Prakan', code: 'TH-11' },
  { country_code: 'TH', subdivision_name: 'Samut Sakhon', code: 'TH-74' },
  { country_code: 'TH', subdivision_name: 'Samut Songkhram', code: 'TH-75' },
  { country_code: 'TH', subdivision_name: 'Saraburi', code: 'TH-19' },
  { country_code: 'TH', subdivision_name: 'Satun', code: 'TH-91' },
  { country_code: 'TH', subdivision_name: 'Si Sa Ket', code: 'TH-33' },
  { country_code: 'TH', subdivision_name: 'Sing Buri', code: 'TH-17' },
  { country_code: 'TH', subdivision_name: 'Songkhla', code: 'TH-90' },
  { country_code: 'TH', subdivision_name: 'Sukhothai', code: 'TH-64' },
  { country_code: 'TH', subdivision_name: 'Suphan Buri', code: 'TH-72' },
  { country_code: 'TH', subdivision_name: 'Surat Thani', code: 'TH-84' },
  { country_code: 'TH', subdivision_name: 'Surin', code: 'TH-32' },
  { country_code: 'TH', subdivision_name: 'Tak', code: 'TH-63' },
  { country_code: 'TH', subdivision_name: 'Trang', code: 'TH-92' },
  { country_code: 'TH', subdivision_name: 'Trat', code: 'TH-23' },
  { country_code: 'TH', subdivision_name: 'Ubon Ratchathani', code: 'TH-34' },
  { country_code: 'TH', subdivision_name: 'Udon Thani', code: 'TH-41' },
  { country_code: 'TH', subdivision_name: 'Uthai Thani', code: 'TH-61' },
  { country_code: 'TH', subdivision_name: 'Uttaradit', code: 'TH-53' },
  { country_code: 'TH', subdivision_name: 'Yala', code: 'TH-95' },
  { country_code: 'TH', subdivision_name: 'Yasothon', code: 'TH-35' },
  { country_code: 'TJ', subdivision_name: 'Dushanbe', code: 'TJ-DU' },
  { country_code: 'TJ', subdivision_name: 'Khatlon', code: 'TJ-KT' },
  { country_code: 'TJ', subdivision_name: 'Kuhistoni Badakhshon', code: 'TJ-GB' },
  { country_code: 'TJ', subdivision_name: 'Nohiyahoi Tobei Jumhuri', code: 'TJ-RA' },
  { country_code: 'TJ', subdivision_name: 'Sughd', code: 'TJ-SU' },
  { country_code: 'TK', subdivision_name: 'Tokelau', code: '-' },
  { country_code: 'TL', subdivision_name: 'Ainaro', code: 'TL-AN' },
  { country_code: 'TL', subdivision_name: 'Cova Lima', code: 'TL-CO' },
  { country_code: 'TL', subdivision_name: 'Dili', code: 'TL-DI' },
  { country_code: 'TM', subdivision_name: 'Ahal', code: 'TM-A' },
  { country_code: 'TM', subdivision_name: 'Balkan', code: 'TM-B' },
  { country_code: 'TM', subdivision_name: 'Dasoguz', code: 'TM-D' },
  { country_code: 'TM', subdivision_name: 'Lebap', code: 'TM-L' },
  { country_code: 'TM', subdivision_name: 'Mary', code: 'TM-M' },
  { country_code: 'TN', subdivision_name: 'Beja', code: 'TN-31' },
  { country_code: 'TN', subdivision_name: 'Ben Arous', code: 'TN-13' },
  { country_code: 'TN', subdivision_name: 'Bizerte', code: 'TN-23' },
  { country_code: 'TN', subdivision_name: 'Gabes', code: 'TN-81' },
  { country_code: 'TN', subdivision_name: 'Gafsa', code: 'TN-71' },
  { country_code: 'TN', subdivision_name: 'Jendouba', code: 'TN-32' },
  { country_code: 'TN', subdivision_name: 'Kairouan', code: 'TN-41' },
  { country_code: 'TN', subdivision_name: 'Kasserine', code: 'TN-42' },
  { country_code: 'TN', subdivision_name: 'Kebili', code: 'TN-73' },
  { country_code: 'TN', subdivision_name: "L'Ariana", code: 'TN-12' },
  { country_code: 'TN', subdivision_name: 'La Manouba', code: 'TN-14' },
  { country_code: 'TN', subdivision_name: 'Le Kef', code: 'TN-33' },
  { country_code: 'TN', subdivision_name: 'Mahdia', code: 'TN-53' },
  { country_code: 'TN', subdivision_name: 'Medenine', code: 'TN-82' },
  { country_code: 'TN', subdivision_name: 'Monastir', code: 'TN-52' },
  { country_code: 'TN', subdivision_name: 'Nabeul', code: 'TN-21' },
  { country_code: 'TN', subdivision_name: 'Sfax', code: 'TN-61' },
  { country_code: 'TN', subdivision_name: 'Sidi Bouzid', code: 'TN-43' },
  { country_code: 'TN', subdivision_name: 'Siliana', code: 'TN-34' },
  { country_code: 'TN', subdivision_name: 'Sousse', code: 'TN-51' },
  { country_code: 'TN', subdivision_name: 'Tataouine', code: 'TN-83' },
  { country_code: 'TN', subdivision_name: 'Tozeur', code: 'TN-72' },
  { country_code: 'TN', subdivision_name: 'Tunis', code: 'TN-11' },
  { country_code: 'TN', subdivision_name: 'Zaghouan', code: 'TN-22' },
  { country_code: 'TO', subdivision_name: 'Niuas', code: 'TO-03' },
  { country_code: 'TO', subdivision_name: 'Tongatapu', code: 'TO-04' },
  { country_code: 'TR', subdivision_name: 'Adana', code: 'TR-01' },
  { country_code: 'TR', subdivision_name: 'Adiyaman', code: 'TR-02' },
  { country_code: 'TR', subdivision_name: 'Afyonkarahisar', code: 'TR-03' },
  { country_code: 'TR', subdivision_name: 'Agri', code: 'TR-04' },
  { country_code: 'TR', subdivision_name: 'Aksaray', code: 'TR-68' },
  { country_code: 'TR', subdivision_name: 'Amasya', code: 'TR-05' },
  { country_code: 'TR', subdivision_name: 'Ankara', code: 'TR-06' },
  { country_code: 'TR', subdivision_name: 'Antalya', code: 'TR-07' },
  { country_code: 'TR', subdivision_name: 'Ardahan', code: 'TR-75' },
  { country_code: 'TR', subdivision_name: 'Artvin', code: 'TR-08' },
  { country_code: 'TR', subdivision_name: 'Aydin', code: 'TR-09' },
  { country_code: 'TR', subdivision_name: 'Balikesir', code: 'TR-10' },
  { country_code: 'TR', subdivision_name: 'Bartin', code: 'TR-74' },
  { country_code: 'TR', subdivision_name: 'Batman', code: 'TR-72' },
  { country_code: 'TR', subdivision_name: 'Bayburt', code: 'TR-69' },
  { country_code: 'TR', subdivision_name: 'Bilecik', code: 'TR-11' },
  { country_code: 'TR', subdivision_name: 'Bingol', code: 'TR-12' },
  { country_code: 'TR', subdivision_name: 'Bitlis', code: 'TR-13' },
  { country_code: 'TR', subdivision_name: 'Bolu', code: 'TR-14' },
  { country_code: 'TR', subdivision_name: 'Burdur', code: 'TR-15' },
  { country_code: 'TR', subdivision_name: 'Bursa', code: 'TR-16' },
  { country_code: 'TR', subdivision_name: 'Canakkale', code: 'TR-17' },
  { country_code: 'TR', subdivision_name: 'Cankiri', code: 'TR-18' },
  { country_code: 'TR', subdivision_name: 'Corum', code: 'TR-19' },
  { country_code: 'TR', subdivision_name: 'Denizli', code: 'TR-20' },
  { country_code: 'TR', subdivision_name: 'Diyarbakir', code: 'TR-21' },
  { country_code: 'TR', subdivision_name: 'Duzce', code: 'TR-81' },
  { country_code: 'TR', subdivision_name: 'Edirne', code: 'TR-22' },
  { country_code: 'TR', subdivision_name: 'Elazig', code: 'TR-23' },
  { country_code: 'TR', subdivision_name: 'Erzincan', code: 'TR-24' },
  { country_code: 'TR', subdivision_name: 'Erzurum', code: 'TR-25' },
  { country_code: 'TR', subdivision_name: 'Eskisehir', code: 'TR-26' },
  { country_code: 'TR', subdivision_name: 'Gaziantep', code: 'TR-27' },
  { country_code: 'TR', subdivision_name: 'Giresun', code: 'TR-28' },
  { country_code: 'TR', subdivision_name: 'Gumushane', code: 'TR-29' },
  { country_code: 'TR', subdivision_name: 'Hakkari', code: 'TR-30' },
  { country_code: 'TR', subdivision_name: 'Hatay', code: 'TR-31' },
  { country_code: 'TR', subdivision_name: 'Igdir', code: 'TR-76' },
  { country_code: 'TR', subdivision_name: 'Isparta', code: 'TR-32' },
  { country_code: 'TR', subdivision_name: 'Istanbul', code: 'TR-34' },
  { country_code: 'TR', subdivision_name: 'Izmir', code: 'TR-35' },
  { country_code: 'TR', subdivision_name: 'Kahramanmaras', code: 'TR-46' },
  { country_code: 'TR', subdivision_name: 'Karabuk', code: 'TR-78' },
  { country_code: 'TR', subdivision_name: 'Karaman', code: 'TR-70' },
  { country_code: 'TR', subdivision_name: 'Kars', code: 'TR-36' },
  { country_code: 'TR', subdivision_name: 'Kastamonu', code: 'TR-37' },
  { country_code: 'TR', subdivision_name: 'Kayseri', code: 'TR-38' },
  { country_code: 'TR', subdivision_name: 'Kilis', code: 'TR-79' },
  { country_code: 'TR', subdivision_name: 'Kirikkale', code: 'TR-71' },
  { country_code: 'TR', subdivision_name: 'Kirklareli', code: 'TR-39' },
  { country_code: 'TR', subdivision_name: 'Kirsehir', code: 'TR-40' },
  { country_code: 'TR', subdivision_name: 'Kocaeli', code: 'TR-41' },
  { country_code: 'TR', subdivision_name: 'Konya', code: 'TR-42' },
  { country_code: 'TR', subdivision_name: 'Kutahya', code: 'TR-43' },
  { country_code: 'TR', subdivision_name: 'Malatya', code: 'TR-44' },
  { country_code: 'TR', subdivision_name: 'Manisa', code: 'TR-45' },
  { country_code: 'TR', subdivision_name: 'Mardin', code: 'TR-47' },
  { country_code: 'TR', subdivision_name: 'Mersin', code: 'TR-33' },
  { country_code: 'TR', subdivision_name: 'Mugla', code: 'TR-48' },
  { country_code: 'TR', subdivision_name: 'Mus', code: 'TR-49' },
  { country_code: 'TR', subdivision_name: 'Nevsehir', code: 'TR-50' },
  { country_code: 'TR', subdivision_name: 'Nigde', code: 'TR-51' },
  { country_code: 'TR', subdivision_name: 'Ordu', code: 'TR-52' },
  { country_code: 'TR', subdivision_name: 'Osmaniye', code: 'TR-80' },
  { country_code: 'TR', subdivision_name: 'Rize', code: 'TR-53' },
  { country_code: 'TR', subdivision_name: 'Sakarya', code: 'TR-54' },
  { country_code: 'TR', subdivision_name: 'Samsun', code: 'TR-55' },
  { country_code: 'TR', subdivision_name: 'Sanliurfa', code: 'TR-63' },
  { country_code: 'TR', subdivision_name: 'Siirt', code: 'TR-56' },
  { country_code: 'TR', subdivision_name: 'Sinop', code: 'TR-57' },
  { country_code: 'TR', subdivision_name: 'Sirnak', code: 'TR-73' },
  { country_code: 'TR', subdivision_name: 'Sivas', code: 'TR-58' },
  { country_code: 'TR', subdivision_name: 'Tekirdag', code: 'TR-59' },
  { country_code: 'TR', subdivision_name: 'Tokat', code: 'TR-60' },
  { country_code: 'TR', subdivision_name: 'Trabzon', code: 'TR-61' },
  { country_code: 'TR', subdivision_name: 'Tunceli', code: 'TR-62' },
  { country_code: 'TR', subdivision_name: 'Usak', code: 'TR-64' },
  { country_code: 'TR', subdivision_name: 'Van', code: 'TR-65' },
  { country_code: 'TR', subdivision_name: 'Yalova', code: 'TR-77' },
  { country_code: 'TR', subdivision_name: 'Yozgat', code: 'TR-66' },
  { country_code: 'TR', subdivision_name: 'Zonguldak', code: 'TR-67' },
  { country_code: 'TT', subdivision_name: 'Arima', code: 'TT-ARI' },
  { country_code: 'TT', subdivision_name: 'Chaguanas', code: 'TT-CHA' },
  { country_code: 'TT', subdivision_name: 'Couva-Tabaquite-Talparo', code: 'TT-CTT' },
  { country_code: 'TT', subdivision_name: 'Diego Martin', code: 'TT-DMN' },
  { country_code: 'TT', subdivision_name: 'Mayaro-Rio Claro', code: 'TT-MRC' },
  { country_code: 'TT', subdivision_name: 'Penal-Debe', code: 'TT-PED' },
  { country_code: 'TT', subdivision_name: 'Point Fortin', code: 'TT-PTF' },
  { country_code: 'TT', subdivision_name: 'Port of Spain', code: 'TT-POS' },
  { country_code: 'TT', subdivision_name: 'Princes Town', code: 'TT-PRT' },
  { country_code: 'TT', subdivision_name: 'San Fernando', code: 'TT-SFO' },
  { country_code: 'TT', subdivision_name: 'San Juan-Laventille', code: 'TT-SJL' },
  { country_code: 'TT', subdivision_name: 'Sangre Grande', code: 'TT-SGE' },
  { country_code: 'TT', subdivision_name: 'Siparia', code: 'TT-SIP' },
  { country_code: 'TT', subdivision_name: 'Tobago', code: 'TT-TOB' },
  { country_code: 'TT', subdivision_name: 'Tunapuna-Piarco', code: 'TT-TUP' },
  { country_code: 'TV', subdivision_name: 'Funafuti', code: 'TV-FUN' },
  { country_code: 'TW', subdivision_name: 'Changhua', code: 'TW-CHA' },
  { country_code: 'TW', subdivision_name: 'Chiayi', code: 'TW-CYQ' },
  { country_code: 'TW', subdivision_name: 'Hsinchu', code: 'TW-HSQ' },
  { country_code: 'TW', subdivision_name: 'Hualien', code: 'TW-HUA' },
  { country_code: 'TW', subdivision_name: 'Kaohsiung', code: 'TW-KHH' },
  { country_code: 'TW', subdivision_name: 'Keelung', code: 'TW-KEE' },
  { country_code: 'TW', subdivision_name: 'Kinmen', code: 'TW-KIN' },
  { country_code: 'TW', subdivision_name: 'Lienchiang', code: 'TW-LIE' },
  { country_code: 'TW', subdivision_name: 'Miaoli', code: 'TW-MIA' },
  { country_code: 'TW', subdivision_name: 'Nantou', code: 'TW-NAN' },
  { country_code: 'TW', subdivision_name: 'New Taipei', code: 'TW-NWT' },
  { country_code: 'TW', subdivision_name: 'Penghu', code: 'TW-PEN' },
  { country_code: 'TW', subdivision_name: 'Pingtung', code: 'TW-PIF' },
  { country_code: 'TW', subdivision_name: 'Taichung', code: 'TW-TXG' },
  { country_code: 'TW', subdivision_name: 'Tainan', code: 'TW-TNN' },
  { country_code: 'TW', subdivision_name: 'Taipei', code: 'TW-TPE' },
  { country_code: 'TW', subdivision_name: 'Taitung', code: 'TW-TTT' },
  { country_code: 'TW', subdivision_name: 'Taoyuan', code: 'TW-TAO' },
  { country_code: 'TW', subdivision_name: 'Yilan', code: 'TW-ILA' },
  { country_code: 'TW', subdivision_name: 'Yunlin', code: 'TW-YUN' },
  { country_code: 'TZ', subdivision_name: 'Arusha', code: 'TZ-01' },
  { country_code: 'TZ', subdivision_name: 'Dar es Salaam', code: 'TZ-02' },
  { country_code: 'TZ', subdivision_name: 'Dodoma', code: 'TZ-03' },
  { country_code: 'TZ', subdivision_name: 'Geita', code: 'TZ-27' },
  { country_code: 'TZ', subdivision_name: 'Iringa', code: 'TZ-04' },
  { country_code: 'TZ', subdivision_name: 'Kagera', code: 'TZ-05' },
  { country_code: 'TZ', subdivision_name: 'Kaskazini Unguja', code: 'TZ-07' },
  { country_code: 'TZ', subdivision_name: 'Katavi', code: 'TZ-28' },
  { country_code: 'TZ', subdivision_name: 'Kigoma', code: 'TZ-08' },
  { country_code: 'TZ', subdivision_name: 'Kilimanjaro', code: 'TZ-09' },
  { country_code: 'TZ', subdivision_name: 'Kusini Pemba', code: 'TZ-10' },
  { country_code: 'TZ', subdivision_name: 'Kusini Unguja', code: 'TZ-11' },
  { country_code: 'TZ', subdivision_name: 'Lindi', code: 'TZ-12' },
  { country_code: 'TZ', subdivision_name: 'Manyara', code: 'TZ-26' },
  { country_code: 'TZ', subdivision_name: 'Mara', code: 'TZ-13' },
  { country_code: 'TZ', subdivision_name: 'Mbeya', code: 'TZ-14' },
  { country_code: 'TZ', subdivision_name: 'Mjini Magharibi', code: 'TZ-15' },
  { country_code: 'TZ', subdivision_name: 'Morogoro', code: 'TZ-16' },
  { country_code: 'TZ', subdivision_name: 'Mtwara', code: 'TZ-17' },
  { country_code: 'TZ', subdivision_name: 'Mwanza', code: 'TZ-18' },
  { country_code: 'TZ', subdivision_name: 'Njombe', code: 'TZ-29' },
  { country_code: 'TZ', subdivision_name: 'Pwani', code: 'TZ-19' },
  { country_code: 'TZ', subdivision_name: 'Rukwa', code: 'TZ-20' },
  { country_code: 'TZ', subdivision_name: 'Ruvuma', code: 'TZ-21' },
  { country_code: 'TZ', subdivision_name: 'Shinyanga', code: 'TZ-22' },
  { country_code: 'TZ', subdivision_name: 'Simiyu', code: 'TZ-30' },
  { country_code: 'TZ', subdivision_name: 'Singida', code: 'TZ-23' },
  { country_code: 'TZ', subdivision_name: 'Tabora', code: 'TZ-24' },
  { country_code: 'TZ', subdivision_name: 'Tanga', code: 'TZ-25' },
  { country_code: 'UA', subdivision_name: 'Avtonomna Respublika Krym', code: 'UA-43' },
  { country_code: 'UA', subdivision_name: 'Cherkaska oblast', code: 'UA-71' },
  { country_code: 'UA', subdivision_name: 'Chernihivska oblast', code: 'UA-74' },
  { country_code: 'UA', subdivision_name: 'Chernivetska oblast', code: 'UA-77' },
  { country_code: 'UA', subdivision_name: 'Dnipropetrovska oblast', code: 'UA-12' },
  { country_code: 'UA', subdivision_name: 'Donetska oblast', code: 'UA-14' },
  { country_code: 'UA', subdivision_name: 'Ivano-Frankivska oblast', code: 'UA-26' },
  { country_code: 'UA', subdivision_name: 'Kharkivska oblast', code: 'UA-63' },
  { country_code: 'UA', subdivision_name: 'Khersonska oblast', code: 'UA-65' },
  { country_code: 'UA', subdivision_name: 'Khmelnytska oblast', code: 'UA-68' },
  { country_code: 'UA', subdivision_name: 'Kirovohradska oblast', code: 'UA-35' },
  { country_code: 'UA', subdivision_name: 'Kyiv', code: 'UA-30' },
  { country_code: 'UA', subdivision_name: 'Kyivska oblast', code: 'UA-32' },
  { country_code: 'UA', subdivision_name: 'Luhanska oblast', code: 'UA-09' },
  { country_code: 'UA', subdivision_name: 'Lvivska oblast', code: 'UA-46' },
  { country_code: 'UA', subdivision_name: 'Mykolaivska oblast', code: 'UA-48' },
  { country_code: 'UA', subdivision_name: 'Odeska oblast', code: 'UA-51' },
  { country_code: 'UA', subdivision_name: 'Poltavska oblast', code: 'UA-53' },
  { country_code: 'UA', subdivision_name: 'Rivnenska oblast', code: 'UA-56' },
  { country_code: 'UA', subdivision_name: 'Sevastopol', code: 'UA-40' },
  { country_code: 'UA', subdivision_name: 'Sumska oblast', code: 'UA-59' },
  { country_code: 'UA', subdivision_name: 'Ternopilska oblast', code: 'UA-61' },
  { country_code: 'UA', subdivision_name: 'Vinnytska oblast', code: 'UA-05' },
  { country_code: 'UA', subdivision_name: 'Volynska oblast', code: 'UA-07' },
  { country_code: 'UA', subdivision_name: 'Zakarpatska oblast', code: 'UA-21' },
  { country_code: 'UA', subdivision_name: 'Zaporizka oblast', code: 'UA-23' },
  { country_code: 'UA', subdivision_name: 'Zhytomyrska oblast', code: 'UA-18' },
  { country_code: 'UG', subdivision_name: 'Amuru', code: 'UG-316' },
  { country_code: 'UG', subdivision_name: 'Arua', code: 'UG-303' },
  { country_code: 'UG', subdivision_name: 'Bugiri', code: 'UG-201' },
  { country_code: 'UG', subdivision_name: 'Buikwe', code: 'UG-117' },
  { country_code: 'UG', subdivision_name: 'Bukedea', code: 'UG-219' },
  { country_code: 'UG', subdivision_name: 'Buliisa', code: 'UG-416' },
  { country_code: 'UG', subdivision_name: 'Buvuma', code: 'UG-120' },
  { country_code: 'UG', subdivision_name: 'Gulu', code: 'UG-304' },
  { country_code: 'UG', subdivision_name: 'Hoima', code: 'UG-403' },
  { country_code: 'UG', subdivision_name: 'Iganga', code: 'UG-203' },
  { country_code: 'UG', subdivision_name: 'Jinja', code: 'UG-204' },
  { country_code: 'UG', subdivision_name: 'Kabale', code: 'UG-404' },
  { country_code: 'UG', subdivision_name: 'Kabarole', code: 'UG-405' },
  { country_code: 'UG', subdivision_name: 'Kalangala', code: 'UG-101' },
  { country_code: 'UG', subdivision_name: 'Kaliro', code: 'UG-222' },
  { country_code: 'UG', subdivision_name: 'Kalungu', code: 'UG-122' },
  { country_code: 'UG', subdivision_name: 'Kampala', code: 'UG-102' },
  { country_code: 'UG', subdivision_name: 'Kamuli', code: 'UG-205' },
  { country_code: 'UG', subdivision_name: 'Kapchorwa', code: 'UG-206' },
  { country_code: 'UG', subdivision_name: 'Kasese', code: 'UG-406' },
  { country_code: 'UG', subdivision_name: 'Kayunga', code: 'UG-112' },
  { country_code: 'UG', subdivision_name: 'Kibaale', code: 'UG-407' },
  { country_code: 'UG', subdivision_name: 'Kiboga', code: 'UG-103' },
  { country_code: 'UG', subdivision_name: 'Kiruhura', code: 'UG-419' },
  { country_code: 'UG', subdivision_name: 'Kitgum', code: 'UG-305' },
  { country_code: 'UG', subdivision_name: 'Kumi', code: 'UG-208' },
  { country_code: 'UG', subdivision_name: 'Kyenjojo', code: 'UG-415' },
  { country_code: 'UG', subdivision_name: 'Lira', code: 'UG-307' },
  { country_code: 'UG', subdivision_name: 'Luwero', code: 'UG-104' },
  { country_code: 'UG', subdivision_name: 'Lyantonde', code: 'UG-114' },
  { country_code: 'UG', subdivision_name: 'Masaka', code: 'UG-105' },
  { country_code: 'UG', subdivision_name: 'Masindi', code: 'UG-409' },
  { country_code: 'UG', subdivision_name: 'Mayuge', code: 'UG-214' },
  { country_code: 'UG', subdivision_name: 'Mbale', code: 'UG-209' },
  { country_code: 'UG', subdivision_name: 'Mbarara', code: 'UG-410' },
  { country_code: 'UG', subdivision_name: 'Mityana', code: 'UG-115' },
  { country_code: 'UG', subdivision_name: 'Mpigi', code: 'UG-106' },
  { country_code: 'UG', subdivision_name: 'Mukono', code: 'UG-108' },
  { country_code: 'UG', subdivision_name: 'Nakaseke', code: 'UG-116' },
  { country_code: 'UG', subdivision_name: 'Nwoya', code: 'UG-328' },
  { country_code: 'UG', subdivision_name: 'Oyam', code: 'UG-321' },
  { country_code: 'UG', subdivision_name: 'Pallisa', code: 'UG-210' },
  { country_code: 'UG', subdivision_name: 'Rukungiri', code: 'UG-412' },
  { country_code: 'UG', subdivision_name: 'Sironko', code: 'UG-215' },
  { country_code: 'UG', subdivision_name: 'Soroti', code: 'UG-211' },
  { country_code: 'UG', subdivision_name: 'Wakiso', code: 'UG-113' },
  { country_code: 'UM', subdivision_name: 'Palmyra Atoll', code: 'UM-95' },
  { country_code: 'US', subdivision_name: 'Alabama', code: 'US-AL', us_state_code: 'AL' },
  { country_code: 'US', subdivision_name: 'Alaska', code: 'US-AK', us_state_code: 'AK' },
  { country_code: 'US', subdivision_name: 'American Samoa', code: 'US-AS', us_state_code: 'AS' },
  { country_code: 'US', subdivision_name: 'Arizona', code: 'US-AZ', us_state_code: 'AZ' },
  { country_code: 'US', subdivision_name: 'Arkansas', code: 'US-AR', us_state_code: 'AR' },
  { country_code: 'US', subdivision_name: 'California', code: 'US-CA', us_state_code: 'CA' },
  { country_code: 'US', subdivision_name: 'Colorado', code: 'US-CO', us_state_code: 'CO' },
  { country_code: 'US', subdivision_name: 'Connecticut', code: 'US-CT', us_state_code: 'CT' },
  { country_code: 'US', subdivision_name: 'Delaware', code: 'US-DE', us_state_code: 'DE' },
  { country_code: 'US', subdivision_name: 'District of Columbia', code: 'US-DC', us_state_code: 'DC' },
  { country_code: 'US', subdivision_name: 'Florida', code: 'US-FL', us_state_code: 'FL' },
  { country_code: 'US', subdivision_name: 'Georgia', code: 'US-GA', us_state_code: 'GA' },
  { country_code: 'US', subdivision_name: 'Guam', code: 'US-GU', us_state_code: 'GU' },
  { country_code: 'US', subdivision_name: 'Hawaii', code: 'US-HI', us_state_code: 'HI' },
  { country_code: 'US', subdivision_name: 'Idaho', code: 'US-ID', us_state_code: 'ID' },
  { country_code: 'US', subdivision_name: 'Illinois', code: 'US-IL', us_state_code: 'IL' },
  { country_code: 'US', subdivision_name: 'Indiana', code: 'US-IN', us_state_code: 'IN' },
  { country_code: 'US', subdivision_name: 'Iowa', code: 'US-IA', us_state_code: 'IA' },
  { country_code: 'US', subdivision_name: 'Kansas', code: 'US-KS', us_state_code: 'KS' },
  { country_code: 'US', subdivision_name: 'Kentucky', code: 'US-KY', us_state_code: 'KY' },
  { country_code: 'US', subdivision_name: 'Louisiana', code: 'US-LA', us_state_code: 'LA' },
  { country_code: 'US', subdivision_name: 'Maine', code: 'US-ME', us_state_code: 'ME' },
  { country_code: 'US', subdivision_name: 'Maryland', code: 'US-MD', us_state_code: 'MD' },
  { country_code: 'US', subdivision_name: 'Massachusetts', code: 'US-MA', us_state_code: 'MA' },
  { country_code: 'US', subdivision_name: 'Michigan', code: 'US-MI', us_state_code: 'MI' },
  { country_code: 'US', subdivision_name: 'Minnesota', code: 'US-MN', us_state_code: 'MN' },
  { country_code: 'US', subdivision_name: 'Mississippi', code: 'US-MS', us_state_code: 'MS' },
  { country_code: 'US', subdivision_name: 'Missouri', code: 'US-MO', us_state_code: 'MO' },
  { country_code: 'US', subdivision_name: 'Montana', code: 'US-MT', us_state_code: 'MT' },
  { country_code: 'US', subdivision_name: 'Nebraska', code: 'US-NE', us_state_code: 'NE' },
  { country_code: 'US', subdivision_name: 'Nevada', code: 'US-NV', us_state_code: 'NV' },
  { country_code: 'US', subdivision_name: 'New Hampshire', code: 'US-NH', us_state_code: 'NH' },
  { country_code: 'US', subdivision_name: 'New Jersey', code: 'US-NJ', us_state_code: 'NJ' },
  { country_code: 'US', subdivision_name: 'New Mexico', code: 'US-NM', us_state_code: 'NM' },
  { country_code: 'US', subdivision_name: 'New York', code: 'US-NY', us_state_code: 'NY' },
  { country_code: 'US', subdivision_name: 'North Carolina', code: 'US-NC', us_state_code: 'NC' },
  { country_code: 'US', subdivision_name: 'North Dakota', code: 'US-ND', us_state_code: 'ND' },
  { country_code: 'US', subdivision_name: 'Northern Mariana Islands', code: 'US-MP', us_state_code: 'MP' },
  { country_code: 'US', subdivision_name: 'Ohio', code: 'US-OH', us_state_code: 'OH' },
  { country_code: 'US', subdivision_name: 'Oklahoma', code: 'US-OK', us_state_code: 'OK' },
  { country_code: 'US', subdivision_name: 'Oregon', code: 'US-OR', us_state_code: 'OR' },
  { country_code: 'US', subdivision_name: 'Pennsylvania', code: 'US-PA', us_state_code: 'PA' },
  { country_code: 'US', subdivision_name: 'Puerto Rico', code: 'US-PR', us_state_code: 'PR' },
  { country_code: 'US', subdivision_name: 'Rhode Island', code: 'US-RI', us_state_code: 'RI' },
  { country_code: 'US', subdivision_name: 'South Carolina', code: 'US-SC', us_state_code: 'SC' },
  { country_code: 'US', subdivision_name: 'South Dakota', code: 'US-SD', us_state_code: 'SD' },
  { country_code: 'US', subdivision_name: 'Tennessee', code: 'US-TN', us_state_code: 'TN' },
  { country_code: 'US', subdivision_name: 'Texas', code: 'US-TX', us_state_code: 'TX' },
  { country_code: 'US', subdivision_name: 'U.S. Outlying Islands', code: 'US-UM', us_state_code: 'UM' },
  { country_code: 'US', subdivision_name: 'Utah', code: 'US-UT', us_state_code: 'UT' },
  { country_code: 'US', subdivision_name: 'Vermont', code: 'US-VT', us_state_code: 'VT' },
  { country_code: 'US', subdivision_name: 'U.S. Virgin Islands', code: 'US-VI', us_state_code: 'VI' },
  { country_code: 'US', subdivision_name: 'Virginia', code: 'US-VA', us_state_code: 'VA' },
  { country_code: 'US', subdivision_name: 'Washington', code: 'US-WA', us_state_code: 'WA' },
  { country_code: 'US', subdivision_name: 'West Virginia', code: 'US-WV', us_state_code: 'WV' },
  { country_code: 'US', subdivision_name: 'Wisconsin', code: 'US-WI', us_state_code: 'WI' },
  { country_code: 'US', subdivision_name: 'Wyoming', code: 'US-WY', us_state_code: 'WY' },
  { country_code: 'UY', subdivision_name: 'Artigas', code: 'UY-AR' },
  { country_code: 'UY', subdivision_name: 'Canelones', code: 'UY-CA' },
  { country_code: 'UY', subdivision_name: 'Cerro Largo', code: 'UY-CL' },
  { country_code: 'UY', subdivision_name: 'Colonia', code: 'UY-CO' },
  { country_code: 'UY', subdivision_name: 'Durazno', code: 'UY-DU' },
  { country_code: 'UY', subdivision_name: 'Flores', code: 'UY-FS' },
  { country_code: 'UY', subdivision_name: 'Florida', code: 'UY-FD' },
  { country_code: 'UY', subdivision_name: 'Lavalleja', code: 'UY-LA' },
  { country_code: 'UY', subdivision_name: 'Maldonado', code: 'UY-MA' },
  { country_code: 'UY', subdivision_name: 'Montevideo', code: 'UY-MO' },
  { country_code: 'UY', subdivision_name: 'Paysandu', code: 'UY-PA' },
  { country_code: 'UY', subdivision_name: 'Rio Negro', code: 'UY-RN' },
  { country_code: 'UY', subdivision_name: 'Rivera', code: 'UY-RV' },
  { country_code: 'UY', subdivision_name: 'Rocha', code: 'UY-RO' },
  { country_code: 'UY', subdivision_name: 'Salto', code: 'UY-SA' },
  { country_code: 'UY', subdivision_name: 'San Jose', code: 'UY-SJ' },
  { country_code: 'UY', subdivision_name: 'Soriano', code: 'UY-SO' },
  { country_code: 'UY', subdivision_name: 'Tacuarembo', code: 'UY-TA' },
  { country_code: 'UY', subdivision_name: 'Treinta y Tres', code: 'UY-TT' },
  { country_code: 'UZ', subdivision_name: 'Andijon', code: 'UZ-AN' },
  { country_code: 'UZ', subdivision_name: 'Buxoro', code: 'UZ-BU' },
  { country_code: 'UZ', subdivision_name: "Farg'ona", code: 'UZ-FA' },
  { country_code: 'UZ', subdivision_name: 'Jizzax', code: 'UZ-JI' },
  { country_code: 'UZ', subdivision_name: 'Namangan', code: 'UZ-NG' },
  { country_code: 'UZ', subdivision_name: 'Navoiy', code: 'UZ-NW' },
  { country_code: 'UZ', subdivision_name: 'Qashqadaryo', code: 'UZ-QA' },
  { country_code: 'UZ', subdivision_name: "Qoraqalpog'iston Respublikasi", code: 'UZ-QR' },
  { country_code: 'UZ', subdivision_name: 'Samarqand', code: 'UZ-SA' },
  { country_code: 'UZ', subdivision_name: 'Surxondaryo', code: 'UZ-SU' },
  { country_code: 'UZ', subdivision_name: 'Toshkent', code: 'UZ-TK' },
  { country_code: 'UZ', subdivision_name: 'Xorazm', code: 'UZ-XO' },
  { country_code: 'VA', subdivision_name: 'Vatican City', code: '-' },
  { country_code: 'VC', subdivision_name: 'Charlotte', code: 'VC-01' },
  { country_code: 'VC', subdivision_name: 'Grenadines', code: 'VC-06' },
  { country_code: 'VC', subdivision_name: 'Saint David', code: 'VC-03' },
  { country_code: 'VC', subdivision_name: 'Saint George', code: 'VC-04' },
  { country_code: 'VC', subdivision_name: 'Saint Patrick', code: 'VC-05' },
  { country_code: 'VE', subdivision_name: 'Amazonas', code: 'VE-Z' },
  { country_code: 'VE', subdivision_name: 'Anzoategui', code: 'VE-B' },
  { country_code: 'VE', subdivision_name: 'Apure', code: 'VE-C' },
  { country_code: 'VE', subdivision_name: 'Aragua', code: 'VE-D' },
  { country_code: 'VE', subdivision_name: 'Barinas', code: 'VE-E' },
  { country_code: 'VE', subdivision_name: 'Bolivar', code: 'VE-F' },
  { country_code: 'VE', subdivision_name: 'Carabobo', code: 'VE-G' },
  { country_code: 'VE', subdivision_name: 'Cojedes', code: 'VE-H' },
  { country_code: 'VE', subdivision_name: 'Delta Amacuro', code: 'VE-Y' },
  { country_code: 'VE', subdivision_name: 'Distrito Capital', code: 'VE-A' },
  { country_code: 'VE', subdivision_name: 'Falcon', code: 'VE-I' },
  { country_code: 'VE', subdivision_name: 'Guarico', code: 'VE-J' },
  { country_code: 'VE', subdivision_name: 'Lara', code: 'VE-K' },
  { country_code: 'VE', subdivision_name: 'Merida', code: 'VE-L' },
  { country_code: 'VE', subdivision_name: 'Miranda', code: 'VE-M' },
  { country_code: 'VE', subdivision_name: 'Monagas', code: 'VE-N' },
  { country_code: 'VE', subdivision_name: 'Nueva Esparta', code: 'VE-O' },
  { country_code: 'VE', subdivision_name: 'Portuguesa', code: 'VE-P' },
  { country_code: 'VE', subdivision_name: 'Sucre', code: 'VE-R' },
  { country_code: 'VE', subdivision_name: 'Tachira', code: 'VE-S' },
  { country_code: 'VE', subdivision_name: 'Trujillo', code: 'VE-T' },
  { country_code: 'VE', subdivision_name: 'Vargas', code: 'VE-X' },
  { country_code: 'VE', subdivision_name: 'Yaracuy', code: 'VE-U' },
  { country_code: 'VE', subdivision_name: 'Zulia', code: 'VE-V' },
  { country_code: 'VG', subdivision_name: 'Virgin Islands, British', code: '-' },
  { country_code: 'VI', subdivision_name: 'Virgin Islands, U.S.', code: '-' },
  { country_code: 'VN', subdivision_name: 'An Giang', code: 'VN-44' },
  { country_code: 'VN', subdivision_name: 'Ba Ria - Vung Tau', code: 'VN-43' },
  { country_code: 'VN', subdivision_name: 'Bac Giang', code: 'VN-54' },
  { country_code: 'VN', subdivision_name: 'Bac Kan', code: 'VN-53' },
  { country_code: 'VN', subdivision_name: 'Bac Lieu', code: 'VN-55' },
  { country_code: 'VN', subdivision_name: 'Bac Ninh', code: 'VN-56' },
  { country_code: 'VN', subdivision_name: 'Ben Tre', code: 'VN-50' },
  { country_code: 'VN', subdivision_name: 'Binh Dinh', code: 'VN-31' },
  { country_code: 'VN', subdivision_name: 'Binh Duong', code: 'VN-57' },
  { country_code: 'VN', subdivision_name: 'Binh Phuoc', code: 'VN-58' },
  { country_code: 'VN', subdivision_name: 'Binh Thuan', code: 'VN-40' },
  { country_code: 'VN', subdivision_name: 'Ca Mau', code: 'VN-59' },
  { country_code: 'VN', subdivision_name: 'Can Tho', code: 'VN-CT' },
  { country_code: 'VN', subdivision_name: 'Cao Bang', code: 'VN-04' },
  { country_code: 'VN', subdivision_name: 'Da Nang', code: 'VN-DN' },
  { country_code: 'VN', subdivision_name: 'Dak Lak', code: 'VN-33' },
  { country_code: 'VN', subdivision_name: 'Dak Nong', code: 'VN-72' },
  { country_code: 'VN', subdivision_name: 'Dien Bien', code: 'VN-71' },
  { country_code: 'VN', subdivision_name: 'Dong Nai', code: 'VN-39' },
  { country_code: 'VN', subdivision_name: 'Dong Thap', code: 'VN-45' },
  { country_code: 'VN', subdivision_name: 'Gia Lai', code: 'VN-30' },
  { country_code: 'VN', subdivision_name: 'Ha Giang', code: 'VN-03' },
  { country_code: 'VN', subdivision_name: 'Ha Nam', code: 'VN-63' },
  { country_code: 'VN', subdivision_name: 'Ha Noi', code: 'VN-HN' },
  { country_code: 'VN', subdivision_name: 'Ha Tinh', code: 'VN-23' },
  { country_code: 'VN', subdivision_name: 'Hai Duong', code: 'VN-61' },
  { country_code: 'VN', subdivision_name: 'Hai Phong', code: 'VN-HP' },
  { country_code: 'VN', subdivision_name: 'Ho Chi Minh', code: 'VN-SG' },
  { country_code: 'VN', subdivision_name: 'Hoa Binh', code: 'VN-14' },
  { country_code: 'VN', subdivision_name: 'Hung Yen', code: 'VN-66' },
  { country_code: 'VN', subdivision_name: 'Khanh Hoa', code: 'VN-34' },
  { country_code: 'VN', subdivision_name: 'Kien Giang', code: 'VN-47' },
  { country_code: 'VN', subdivision_name: 'Kon Tum', code: 'VN-28' },
  { country_code: 'VN', subdivision_name: 'Lai Chau', code: 'VN-01' },
  { country_code: 'VN', subdivision_name: 'Lam Dong', code: 'VN-35' },
  { country_code: 'VN', subdivision_name: 'Lang Son', code: 'VN-09' },
  { country_code: 'VN', subdivision_name: 'Lao Cai', code: 'VN-02' },
  { country_code: 'VN', subdivision_name: 'Long An', code: 'VN-41' },
  { country_code: 'VN', subdivision_name: 'Nam Dinh', code: 'VN-67' },
  { country_code: 'VN', subdivision_name: 'Nghe An', code: 'VN-22' },
  { country_code: 'VN', subdivision_name: 'Ninh Binh', code: 'VN-18' },
  { country_code: 'VN', subdivision_name: 'Ninh Thuan', code: 'VN-36' },
  { country_code: 'VN', subdivision_name: 'Phu Tho', code: 'VN-68' },
  { country_code: 'VN', subdivision_name: 'Phu Yen', code: 'VN-32' },
  { country_code: 'VN', subdivision_name: 'Quang Binh', code: 'VN-24' },
  { country_code: 'VN', subdivision_name: 'Quang Nam', code: 'VN-27' },
  { country_code: 'VN', subdivision_name: 'Quang Ngai', code: 'VN-29' },
  { country_code: 'VN', subdivision_name: 'Quang Ninh', code: 'VN-13' },
  { country_code: 'VN', subdivision_name: 'Quang Tri', code: 'VN-25' },
  { country_code: 'VN', subdivision_name: 'Soc Trang', code: 'VN-52' },
  { country_code: 'VN', subdivision_name: 'Son La', code: 'VN-05' },
  { country_code: 'VN', subdivision_name: 'Tay Ninh', code: 'VN-37' },
  { country_code: 'VN', subdivision_name: 'Thai Binh', code: 'VN-20' },
  { country_code: 'VN', subdivision_name: 'Thai Nguyen', code: 'VN-69' },
  { country_code: 'VN', subdivision_name: 'Thanh Hoa', code: 'VN-21' },
  { country_code: 'VN', subdivision_name: 'Thua Thien-Hue', code: 'VN-26' },
  { country_code: 'VN', subdivision_name: 'Tien Giang', code: 'VN-46' },
  { country_code: 'VN', subdivision_name: 'Tra Vinh', code: 'VN-51' },
  { country_code: 'VN', subdivision_name: 'Tuyen Quang', code: 'VN-07' },
  { country_code: 'VN', subdivision_name: 'Vinh Long', code: 'VN-49' },
  { country_code: 'VN', subdivision_name: 'Vinh Phuc', code: 'VN-70' },
  { country_code: 'VN', subdivision_name: 'Yen Bai', code: 'VN-06' },
  { country_code: 'VU', subdivision_name: 'Shefa', code: 'VU-SEE' },
  { country_code: 'VU', subdivision_name: 'Tafea', code: 'VU-TAE' },
  { country_code: 'VU', subdivision_name: 'Torba', code: 'VU-TOB' },
  { country_code: 'WF', subdivision_name: 'Sigave', code: 'WF-SG' },
  { country_code: 'WF', subdivision_name: 'Uvea', code: 'WF-UV' },
  { country_code: 'WS', subdivision_name: "Fa'asaleleaga", code: 'WS-FA' },
  { country_code: 'WS', subdivision_name: 'Tuamasaga', code: 'WS-TU' },
  { country_code: 'YE', subdivision_name: "'Adan", code: 'YE-AD' },
  { country_code: 'YE', subdivision_name: "'Amran", code: 'YE-AM' },
  { country_code: 'YE', subdivision_name: 'Abyan', code: 'YE-AB' },
  { country_code: 'YE', subdivision_name: "Ad Dali'", code: 'YE-DA' },
  { country_code: 'YE', subdivision_name: "Al Bayda'", code: 'YE-BA' },
  { country_code: 'YE', subdivision_name: 'Al Hudaydah', code: 'YE-HU' },
  { country_code: 'YE', subdivision_name: 'Al Jawf', code: 'YE-JA' },
  { country_code: 'YE', subdivision_name: 'Al Mahrah', code: 'YE-MR' },
  { country_code: 'YE', subdivision_name: 'Al Mahwit', code: 'YE-MW' },
  { country_code: 'YE', subdivision_name: "Amanat al 'Asimah", code: 'YE-SA' },
  { country_code: 'YE', subdivision_name: 'Dhamar', code: 'YE-DH' },
  { country_code: 'YE', subdivision_name: 'Hadramawt', code: 'YE-HD' },
  { country_code: 'YE', subdivision_name: 'Ibb', code: 'YE-IB' },
  { country_code: 'YE', subdivision_name: 'Lahij', code: 'YE-LA' },
  { country_code: 'YE', subdivision_name: "Ma'rib", code: 'YE-MA' },
  { country_code: 'YE', subdivision_name: "Sa'dah", code: 'YE-SD' },
  { country_code: 'YE', subdivision_name: "San'a'", code: 'YE-SN' },
  { country_code: 'YE', subdivision_name: 'Shabwah', code: 'YE-SH' },
  { country_code: 'YE', subdivision_name: "Ta'izz", code: 'YE-TA' },
  { country_code: 'YT', subdivision_name: 'Mamoudzou', code: '-' },
  { country_code: 'YT', subdivision_name: 'Mtsamboro', code: '-' },
  { country_code: 'YT', subdivision_name: 'Ouangani', code: '-' },
  { country_code: 'YT', subdivision_name: 'Pamandzi', code: '-' },
  { country_code: 'YT', subdivision_name: 'Sada', code: '-' },
  { country_code: 'ZA', subdivision_name: 'Eastern Cape', code: 'ZA-EC' },
  { country_code: 'ZA', subdivision_name: 'Free State', code: 'ZA-FS' },
  { country_code: 'ZA', subdivision_name: 'Gauteng', code: 'ZA-GP' },
  { country_code: 'ZA', subdivision_name: 'Kwazulu-Natal', code: 'ZA-KZN' },
  { country_code: 'ZA', subdivision_name: 'Limpopo', code: 'ZA-LP' },
  { country_code: 'ZA', subdivision_name: 'Mpumalanga', code: 'ZA-MP' },
  { country_code: 'ZA', subdivision_name: 'North-West', code: 'ZA-NW' },
  { country_code: 'ZA', subdivision_name: 'Northern Cape', code: 'ZA-NC' },
  { country_code: 'ZA', subdivision_name: 'Western Cape', code: 'ZA-WC' },
  { country_code: 'ZM', subdivision_name: 'Central', code: 'ZM-02' },
  { country_code: 'ZM', subdivision_name: 'Copperbelt', code: 'ZM-08' },
  { country_code: 'ZM', subdivision_name: 'Eastern', code: 'ZM-03' },
  { country_code: 'ZM', subdivision_name: 'Luapula', code: 'ZM-04' },
  { country_code: 'ZM', subdivision_name: 'Lusaka', code: 'ZM-09' },
  { country_code: 'ZM', subdivision_name: 'North-Western', code: 'ZM-06' },
  { country_code: 'ZM', subdivision_name: 'Northern', code: 'ZM-05' },
  { country_code: 'ZM', subdivision_name: 'Southern', code: 'ZM-07' },
  { country_code: 'ZM', subdivision_name: 'Western', code: 'ZM-01' },
  { country_code: 'ZW', subdivision_name: 'Bulawayo', code: 'ZW-BU' },
  { country_code: 'ZW', subdivision_name: 'Harare', code: 'ZW-HA' },
  { country_code: 'ZW', subdivision_name: 'Manicaland', code: 'ZW-MA' },
  { country_code: 'ZW', subdivision_name: 'Mashonaland Central', code: 'ZW-MC' },
  { country_code: 'ZW', subdivision_name: 'Mashonaland East', code: 'ZW-ME' },
  { country_code: 'ZW', subdivision_name: 'Mashonaland West', code: 'ZW-MW' },
  { country_code: 'ZW', subdivision_name: 'Masvingo', code: 'ZW-MV' },
  { country_code: 'ZW', subdivision_name: 'Matabeleland North', code: 'ZW-MN' },
  { country_code: 'ZW', subdivision_name: 'Matabeleland South', code: 'ZW-MS' },
  { country_code: 'ZW', subdivision_name: 'Midlands', code: 'ZW-MI' }
];
